var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilepic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1242 2206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eeeee6",
    d: "M1 1591V1h1242v1856l-3-2-25-21-28-22c-10-7-20-17-32-22l-27-15-14-4h-3l-5-4q-4 0-6-2-9-6-18-6l-6-2q-6-4-13-4l-3-1-31-10-22-10-16-8-10-4-19-8q-8-4-16-6l-16-8-14-5-23-11-7-2-14-13-17-16c-6-5-15-8-18-17q-4-9-1-17 8-12 19-22l17-18 8-11 7-12 10-18 12-23 20-40 15-33 1-5v-2l5-8q3-4 2-10v-1q5-4 6-11v-7c5-2 4-6 5-9q6-13 6-27l1-9v-4q5-1 4-5l1-24-1-17v-3c5-3 2-7 3-10l2-37-1-25-1-15q-4-12-6-25c-2-11-1-23-5-35q-2-13-2-27l2-21 2-6 7-15q2-7 8-12l4-5q7-12 8-26 0-7 5-13l14-24q5-10 11-16 11-11 24-21 11-9 19-19t14-21c5-6 3-13 3-20v-18c-1-12 1-23-4-34l-6-18-3-2v-3l1-5-1-25 1-9c2-10-3-18-7-26q-6-11-15-21l-5-5-6-4-8-4-6-5q-11-7-23-8l-3-4q-7-5-9-14-1-8 0-18 3-15 6-31 3-13-2-27-1-3-3-5l-13-14q-7-5-16-5l-2-1-3-3-7-1c-8 0-16-2-22 4h-3c-9-1-14 5-21 7-6 1-18 1-21-3l-12-17-4-3-1-6-5-7-2-3h-2l-7-7v-2l-4-4v-1l-3-2-1-1-2-3-8-12q-3-6-9-8v-1l-2-4-7-4-12-8-21-4-34-5-1-1-7-5-16-9-7-4q-3-4-6-5h-28c-4 1-11 0-12 7h-1l-8 2-4 3-25 8h-36l-28-12-8-1q-5-5-8 0l-12 2-18 13a70 70 0 0 1-42 16q-17 2-32-4h-2q-15 2-23 14-12 15-29 19-11 1-21 5-9 3-17 2l-16 2-14 7c-10 6-13 16-18 25q-6 10-16 16c-5 4-12 4-18 8-13 9-19 22-28 33q-12 18-26 35-10 10-21 18-5 5-7 11l-3 24 1 16-1 11-2 7-2 11q-6 16-6 33l3 13 2 18c1 2-1 7 4 7v6l-1 16q-3 12 1 23l4 5v3l6 19 2 2v8l-3 12q-5 16-5 34v5l-6 15-7 20q-5 12 3 22l21 21 5 6v1q0 7 5 7l2 6 6 8v2l4 5 1 1q4 10 12 14v1l2 2 2 3 6 13 4 7q1 9-3 17-5 10-6 21c-1 18-4 37 5 55l6 10 2 3 1 4 4 5 6 7 2 3 1 1 3 3 4 5 6 7 1 2 2 2 1 1 3 4 1 2 2 2 5 5v2l11 15h1l1 2 3 4v1l5 9 9 10 5 8v4q13 16 20 35 1 5 5 9v2q-1 7 1 10c2 3-1 8 4 9v14l-1 7v8l-1 5-2 4-1 18-2 27-2 3-2 4q-4 10-10 19-5 7-14 13l-19 10q-16 10-36 11l-63 6-31 6h-2l-13 4-25 4-17 4c-14 2-28-1-42 4q-8 2-17 1l-17 1-11 2-5 1zM1243 1968v239H1v-244l24 2q1 3 4 3l18 1 5-1 993 1 29-4q11 0 18-5 3-2 8-3l41-1q10 1 20 5l13 2h2l7 2h8q7 4 15 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M1 1835v-113q14-1 14 12 0 6 7 6l4 3 11 17 1 4q3 13 9 24 3 8 4 15l2 9 2 5 2 4q8 7 8 16-1 7 4 14 3 5-1 10l-1 6c2 13 12 22 20 31q7 6 0 10l-2 5q3 8-2 12c-6 7-5 15-8 22l1 4H17l4-3q5-3 4-8l-4-11q-4-10-4-22l1-12-6-28-6-24q0-5-5-8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2525",
    d: "m76 1951-1-4c3-7 2-15 8-22q5-5 2-12l2-5q7-4 0-10c-8-9-18-18-20-31l1-6q4-5 1-10-5-7-4-14 0-9-8-16l-2-4-2-5-2-9q0-8-4-15-6-11-9-24l-1-4-11-17-4-3q-7 0-7-6 0-13-14-12v-39l35-2q6 0 5-6-1-9 6-11 4 2 6 1l2-4v-3q-1-11 9-9l29-1q6 0 2-6-2-3 1-5 2-2 2-4 0-3-4-4l-3-1q-9-7-7-17 1-5-3-4l-19 2-5-2 4-5 11-1 5-1 6-2 7-1c8 1 16-4 24-1q3-1 8-5h5q-8 9-20 10l-18 1 10 4 4 2 3 12 4 5 3-5 1-2 4 8 3 7-5 21-2 2c-5-3-8 1-11 4l-3 1-6 3c2 4 4 8-3 9l-1 2-6 3-20-2-5 3 4 2 10 5q5 3 9-1l3-4 2 7c1 8 1 8 9 9l4 1q5 0 5 6v12c0 9 0 9-9 11q-6 0-8 6l-5 4-8 1q-6 6-14 4l-4 2q-1 9 3 17 4 5 0 8-3 3-4 8-2 6 4 9 7 1 7-5l4-2 1 3-2 7 1 31q6 10 1 19-2 4 2 7 6 3 6 10l-2 14q0 8 6 12l8 6q5 10-1 21l-2 7v8q-4 8-7 16-4 5-1 11h-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "M122 1591q-5 4-8 5c-8-3-16 2-24 1l-7 1-6 2-5 1-11 1-4 5 5 2 19-2q4-1 3 4-2 10 7 17l3 1q4 1 4 4 1 2-2 4-3 3-1 5 4 6-2 6l-29 1q-10-2-9 9v3l-2 4q-1 1-6-1-7 2-6 11 1 6-5 6l-35 2v-79l41-4 20-2 3-4h5l42-1 3-3h4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#39373d",
    d: "M1243 1940v11h-69q-2-4-5-4l-24-6-9-1q2-8-5-7l-4-2-2-6q1-7-3-14l1-4 4-1 4 3q5 1 6-4l-1-40 3-4 11 7q4 5 9 8 7 3 10 8 3 2 5 3 6 2 8 8 3 7 12 10 10 6 18 13c6 5 10 11 18 7h3q-2 12 10 15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#303037",
    d: "M1243 1940q-12-3-10-15h-3c-8 4-12-2-18-7q-8-7-18-13-9-3-12-10-3-6-8-8-2-1-5-3-3-5-10-8-5-2-9-8l-11-7 2-1c7 4 15 4 20 12l6 6q-3-13-13-15l-7-4-9-7-30-19-3-5 13 6 14 11q4 4 6-1h5q8-1 7 7l2 4 1-2 10 4 5 5q4 2 7 2 6-1 8 5 2 3 6 4l4-5 2-5-7-1-4-3q1-10-5-18-7-13-22-19-8-3-12-11-3-7-10-10l-10-11q12 5 22 11 11 9 21 20l10 9 8 8c5 8 13 10 20 15l2-1q6-3 10 2 2 2 5 3 2 4 3 1l2 2 3 3h1q2 7 8 8l1 2 2 3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "M1 1958v-3l44 3h44l79 1h119l32-1h474c96-1 192 5 288-4h3l-1 2h-5q-21 5-42 6H53l-19-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m1 1958 33 3 19 1h983q21-2 42-6l4 1-7 4h-2l-6 2h-2l-10 2H33l-3-2-29-3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "M1081 1954c-96 9-192 3-288 4H319l-32 1H168l-79-1H45l-44-3v-3l28 1 60 2h81l4 2h34l4-2h108l29 1 5-1h653l47-1 3-1h2l7-1 8-1h7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m1 1591 30-3 5-1 11-2 17-1q8 1 17-1c14-5 28-2 42-4l17-4 25-4 13-4h2l31-6 63-6q19-1 36-11l19-10q9-6 14-13 7-9 10-19l2-4 2-3 2-27 1-18 2-4h1v9l1 10-1 6v10l-2 5v3l-1 4-1 12-4 7-2 3v1l-2 2-2 3v4l-2 2-2 2-4 2-9 7-24 13q-18 7-38 8h-13l-9 2h-3l-9 1h-15l-4 1h-4l-8 3-1 1h-3l-23 5h-7l-45 9-34 4-20 1-4 2h-6l-27 2-34 4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "M1 1835c5 1 4 6 5 8l6 24 6 28-1 12q0 12 4 22l4 11q1 5-4 8l-4 3-16-1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m175 1572 3 1 15-2 8-4h8l25-3 44-3c20-1 37-11 54-21l1-2h2l10-9 2-2 2-2 10-12-2 7-2 4-5 6-2 1-3 4h-1l-12 9-3 1-3 2-3 2q-13 11-30 14l-51 4-19 1-4 2-5-1-13 4h-10l-4 1h-3l-9 3h-2l-38 9h-3l-3 1h-3l-15 3H89l-26 1-14 3h-3l-8 1-18 3h-3l-8 1H1v-3l51-6 10-2 6 1 34-2 23-2 45-10z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m1114 1771 14 4 27 15c12 5 22 15 32 22l28 22 25 21 3 2v5l-10-8-13-10h-1v-2l-33-27-10-6q-3-7-10-8h-1l-1-3-23-13-24-10z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M1174 1951h3q12 4 22 4h44v4h-10a240 240 0 0 1-68-6h-5l-2-1-5-3h-5l-5-1-6-1h-22l-5 2h-4l-11 3h-3l-3-1 5-3 15-3c18-5 35 0 52 4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m1228 1860-2-2-1-1-2-2-17-12c-5-10-15-13-23-20l-29-23-3-1-5-2-22-11h-3l-2-1v-3l5 1 28 14q13 8 24 17l31 25 15 10 1 1 20 18v5h-2l-1-2-8-8h-1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m1158 1952 3 1h2l2 2h5l1 1 2 3 12 2 31 4h27v3h-37q-8 1-15-3h-8l-7-2h-2q-9-8-21-8l-8-3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m1 1950 16 1h62l1 2 1-2h8v4l-60-2-28-1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "M1243 1955h-44l-22-3 66-1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m1171 1956-1-1-1-2q31 7 64 6h10v3h-7l-35-1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m1171 1956 30 5 35 1h7v3h-27l-31-4-12-2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M17 1598h23l6-4h19l-3 4-20 2-41 4v-3l5-2h3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m62 1588-10 2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m1 1960 32 5h-8l-24-2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m1243 1868-20-19 11 8 9 8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1243 1865-9-8-12-8-2-5 13 10 10 8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m6 1599-5 2v-2zM1241 1873h2v3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M180 808q0-17 6-33l2-11 2-7 1-11-1-16 3-24q2-6 7-11 11-8 21-18 14-17 26-35c9-11 15-24 28-33 6-4 13-4 18-8q10-6 16-16c5-9 8-19 18-25l14-7 16-2q8 0 17-2 10-4 21-5 18-3 29-19 8-12 23-14h2q15 6 32 4 23-1 42-16l18-13 12-2v1q-14 5-26 16-10 8-23 12-7 4-16 5l-36-2q-10-1-18 4l-9 9q-11 16-30 18-8 1-15 7h-2l-3-1h-4l-4 1h-3l-6 1q-5-3-5 2h-1q-4-5-6 1h-3q-15 1-22 13v1l-5 8-1 3-3 3q-8 16-26 21-15 6-25 20l-14 23-2 5v2h-2l-3 4-8 10-8 7-1 3v1l-4 3-4 3-5 3c-2 3-8 4-7 9h-1l-4 5-2 2-1 7v15l1 7-1 12v3l-2 2v8l-3 18-1 2-2 6-2 4-2 15v2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m945 1435-1 5-15 33-20 40-12 23-10 18-7 12-8 11-17 18q-11 10-19 22-3 8 1 17c3 9 12 12 18 17l17 16 14 13 7 2 23 11 14 5 16 8q8 2 16 6l19 8 10 4 16 8 22 10 31 10 3 1q7 0 13 4l6 2q9 0 18 6 2 2 6 2l5 4-20-6-32-11q-13-2-24-6l-36-16-9-3h-1l-15-9-38-15-47-21q-12-6-20-16-3-7-11-8v-1l-7-7h-2l-5-4-3-1-4-5c-8-7-10-24-1-31l5-8 2-2a270 270 0 0 0 42-51v-3l23-39 11-25 4-6 1-4 3-4 4-12v-1l5-11zM1085 905c0 7 2 14-3 20q-6 11-14 21t-19 19q-13 10-24 21-6 7-11 16l-14 24q-5 7-5 13-1 14-8 26l-4 5q-6 5-8 12l-7 15-2 6-2 21q-1 13 2 27c4 12 3 24 5 35q2 13 6 25l1 15 1 25-2 37c-1 3 2 7-3 10v-41l2-14-2-2v-30l-3-6v-5l-2-20-3-3v-13c-1-4 1-9-4-11v-3l-1-8v-20l2-15-1-6v-2l5-10 16-27h2l2-3 4-13v-8q6-18 17-32l7-14v-1l16-15 9-9h1l3-3h1l5-5 1-1 7-6 15-19 1-2q5-5 7-9l1-14v-3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M963 600q9 0 16 5l13 14q2 2 3 5 5 14 2 27-3 16-6 31-1 10 0 18 2 8 9 14l3 4-9-6-7-9v-17l-1-6v-7l1-2 2-10 3-10 3-5q2-15-7-26l-6-5-3-3q-3-8-11-9h-1zM249 1226c-9-18-6-37-5-55q1-11 6-21 4-8 3-17l-2-9-8-11-2-3-2-2v-3l15 19q0 4 2 8 3 6 1 11v4l-2 4v2l-6 16v5l-1 3v3l-1 2v8q-4 5 0 8v11l2 3 1 7 7 18-2-1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m990 1729 9 3 36 16q11 4 24 6l32 11 20 6h3l3 4 24 10 23 13 1 3-10-5-36-18-39-15-37-10-52-22z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m1032 731 8 4 6 4 5 5q9 10 15 21c4 8 9 16 7 26l-1 9 1 25-1 4-4-3v-5l1-5 1-27-3-4q0-19-13-31l-22-21z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m747 500 1 1q8 5 17 4l4 2h8l3 2 1 1-14-1q-22-2-40-15l-18-11-2 1h-2q-7-2-15-1-13 2-25 7l5-6h1q21-8 42-2h4l7 4q9 11 23 14"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M193 979v-5l2-5q-1-10 3-21l4-4-4 15-3 23-9 33q-5 11 3 20l2 3q-12-6-10-16 3-12 7-24z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m193 979-5 19q-4 12-7 24-2 10 10 16l9 11 9 14-5-6-21-21q-8-10-3-22l7-20zM670 484l-5 6h-2l-9 5-16 4-11 3-21-2h-2l-3-1h-2v-2h34q6 0 11-3l14-5 4-3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m868 583 4 3 12 17c3 4 15 4 21 3 7-2 12-8 21-7l-6 5h-2l-13 5q-20 7-27-8l-7-11-3-3-1-2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M772 507h-3l-4-2q-9 1-17-4l34 5 21 4 12 8 7 4 1 4-4-3-5-2-2-2q-12-10-28-9h-3l-1-1-3-2h-5M1072 833l3 2 6 18c5 11 3 22 4 34l-3-3-2-1-1-3 1-2 1-6v-4l-1-3-3-8-4-15 1-4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m814 521 5 2 4 3 1 1 15 20 3 3 2 3 3 4 2 1 2 2 7 7v2l-20-19-10-10v-1l-3-3v-1l-8-9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m974 1301 1 17-1 24q1 4-4 5l-1-1v-4l2-10v-19l1-6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M315 1316v-1l-3-4-1-2-12-15v-2l-5-5-2-2-1-2v-4l8 7 1 5 19 25 10 16-3-3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M359 1391q-4-4-5-9-7-19-20-35v-3h3l3 4 2 3 1 3 4 5v2l3 4 1 1 2 3v3l2 3 1 4q-1 5 3 5v7M717 482h-4q-21-6-42 2c1-7 8-6 12-7h28q3 1 6 5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m209 1063-9-14-9-11q13 9 19 20l12 27-6-8-2-6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M180 808h3l2 1v5l-1 2 2 4v4l1 6 1 9 1 2v5c-5 0-3-5-4-7l-2-18z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M193 899v-3h2l5 8q9 16 2 33l-1-9v-8q1-13-8-21"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m201 928 1 9v7l-4 4q-4 11-3 21l-2 5q0-18 5-34z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M929 599c6-6 14-4 22-4l7 1 3 4-1 1h-5l-6-2h-10l-10 1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M969 1360q0 14-6 27c-1 3 0 7-5 9v-3l3-7v-5l1-4 1-2 3-15z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M1032 731v2l-29-13v-2q12 1 23 8zM258 1243l-1-4v-2l8 9 16 22-3-1-4-5-3-3-1-1-2-3-6-7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M195 896h-2l-4-5q-3-11-1-23l3 2v16q-2 6 2 5z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m974 1301-2 6-1 5 1-29 2-8v26"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m569 485 28 12-2 2h-2l-2-2h-2l-4-2h-1l-12-5zM747 500q-14-2-23-14z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1082 884 3 3v18h-3l-1-3v-15z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m839 547-15-20q6 2 9 8l8 12zM364 1412c-5-1-2-6-4-9q-2-3-1-10h2zM315 1316l11 13 3 3v3l-9-10zM952 1415q1 6-2 10l-5 8v-8l4-7v-3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m191 870-3-2 1-16h3l1 5-1 7v4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M193 899q9 8 8 21l-2-2zM243 1113l8 11 2 9-4-7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M189 846v-5l1-2 1-3 3 5-1 8h-4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M952 1415h-3l6-17 3-2v7l-6 11z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m364 1412-3-19v-1l4 11 3 7v3l-2 1h-2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M945 1430v5l-9 10 1-5 2-3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m299 1294 12 15h-1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m868 583-1 2-4-2v-1l-4-12h3l1 1v3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m569 485 3 5-10-3-3-2 2-1z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M239 1105v2q-8-4-12-14l3 1 1 2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M364 1414h3v3l-2 14-1-5zM288 1279l-1-1-2-2-1-2-3-6h1l9 11z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1072 833 2 5-1 4-4-13v-3l3 4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M969 1360h-3l3-14 1 1v4z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m952 1414 6-11q-1 7-6 11M561 484l-2 1h-6v-1q3-4 8 0M334 1343l-5-8h3l2 3v5M249 1226"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m868 583-5-8 4 2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M929 599v1l-9 4 6-5z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m209 1064 5 7q-5 0-5-7M969 1360l1-9zM281 1268l3 6-6-7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M363 1441v-8h2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M222 1087h3l1 2v3zM365 1433h-2l1-7 1 5zM724 486l-7-4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M960 601zh2l4 3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m849 558-2-1v-3l4 4zM258 1243l4 5zM294 1287l5 5zM867 577l-4-3v-3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M226 1092v-3l4 5-3-1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M363 1441v5h-1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m595 499 2-2h2v2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M288 1279h3v4z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M189 849h3v3h-3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M847 554v3l-3-4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m312 1311 3 4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M334 1343v-2l3 3zM361 1392zh-2v-4l1 1z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M862 570h-3v-1l1-2zM271 1259l3 3zM847 553h-3v-2zM841 547l2 3h-1z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M842 550zl1 1v2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m268 1255 2 3zM257 1237v2l-2-3zM1085 903v-2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M849 558h2v2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m285 1276 2 2zM292 1285l2 2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m860 567-1 2h-1v-2z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "m239 1108 2 2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M52 1965h986v3H52z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd9d2",
    d: "M1038 1968v-3h18l9-2h3l5-2h2q9 1 12-5h2l14-1 4-3h6l18 1 10-1h4l8 3q12 0 21 8l-13-2q-10-4-20-5l-41 1q-5 1-8 3-7 5-18 5zM52 1965v3l-5 1-18-1q-3 0-4-3h27M1176 1963l7 2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "M89 1951h-8q-3-6 1-11 3-8 7-16v-8l2-7q6-11 1-21l-8-6q-6-4-6-12l2-14q0-7-6-10-4-3-2-7 5-9-1-19l-2-3 1-28 2-7-1-3-4 2q0 6-7 5-6-3-4-9 1-5 4-8 5-3 0-8-5-8-3-17l4-2q8 2 14-4l8-1 5-4q2-6 8-6c9-2 9-2 9-11v-12q1-6-5-6l-4-1c-8-1-8-1-9-9l-2-7-3 4q-5 4-9 1l-10-5-4-2 5-3 20 2 6-3 1-2c7-1 5-5 3-9l6-3 3-1c3-3 6-7 11-4l2-2 5-21-3-7-4-8-1 2-3 5-4-5-3-12-4-2-10-4 18-1q12-1 20-10h5l-8 7 1 1 9 12q3 4 8 4l18-2 4-1 7-3q8 1 13-4 2-3 6-3l17 1 25 2 4-2 9-4 17-1c6-1 14 0 15-10q8 1 8 10h-7l-5 2 5 4q6-2 12 3l3-1 18-6q8-2 10-10 1-7 7-6v1l-6 14-2 3q-4 3-5 6 1 4-2 7l-7 11-2 8q-3 6 3 11 2 2 1 5c-3 9 1 16 4 25l2-3 3-5q4 3 6 7l-1 28q-1 3-3 4l-7 1v-12q1-10-5-19l-5-2c-6 5-13 2-19 3l-23 7-4 4-3 4c-8 9-18 15-23 27l-2 1q-16 12-27 29l-13 25-11 19v6l-2 2h-1l-2 2v1l-4 4-8 15-11 23-1 4-5 18-2 1-7 9c-4 6-5 15-14 18l-3 5-5 2-1 2-2 2v6l-2 6q2 5-3 6l-5 6zm157-266c-1-5-5-3-7-2l-21 17-18 21-14 22-3 6q-6 8-11 17l-1 3-15 21-4 10-10 14-2 3-5 9-6 11-5 7-3 6-12 20-4 6q-5 6-2 14l-1 7-4 9q-4 8 2 10c5 2 5-3 6-6q2-7 5-10 15-13 21-31l3-4 5-7 9-24 11-20q4-9 11-19 8-11 14-24l11-21 5-8 11-12 8-9 11-12 7-9 5-8zm-97 68v7q-1 9 3 16c9-7 9-7 15-18q5-6 9-13c5-14 14-27 14-43v-2q0-3-2-7l-9-13q-3-5-8-5h-20v15q-1 5-3 9-5 14-3 28 1 13 4 26"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M132 1591h-10l-3-1 7-3h3l3-1h3l8 1-3 3h-2l-4 1z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m81 1951-1 2-1-2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M89 1590h26l-3 3-41 1 6-1z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m89 1590-12 3-7 1H49l14-3zM115 1590h-4l15-3-7 3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "m1105 1828 3 5 30 19 9 7 7 4q10 2 13 15l-6-6c-5-8-13-8-20-12l-2 1-3 4 1 40q-1 5-6 4l-4-3-4 1-1 4q5 7 3 14l2 6 4 2q7-1 5 7l-33 3-14 2-10 1 6-5 4-2v-2q-6 1-11-1-7-2-8 4l-1 10-3 1h-47c4-7 4-8-1-12l-2-2q-3-4 0-10 2-4 5-3 5 1 6 4l2 8c4 4 18 4 23 2l18-5q7-2 7-10l-2-10-3-16v-7l9 1 3 1-3-6q0-6-5-5-7-1-4-8l2-3q0-5-2-9-11-6-8-19 0-5-4-4-3 1-4 3-4 2-7-1c-3-2 0-18 3-19h1l11-5q7-5 16-5l4 2q6 6 12 9 6 2 9 6"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1089 1945 14-2 33-3 9 1 24 6q3 0 5 4l-13-2c-17-4-34-9-52-4l-15 3-5 3h-7c2-3 7-1 7-6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "M1105 1828q-3-4-9-6-6-3-12-9l-4-2q-9 0-16 5l-11 5h-1c-3 1-6 17-3 19q3 3 7 1 1-2 4-3 4-1 4 4-3 12 8 19 2 4 2 9l-2 3q-3 7 4 8 5 0 5 5l3 6-3-1-9-1v7l3 16 2 10q0 8-7 10l-18 5c-5 2-19 2-23-2l-2-8q-1-4-6-4-3-1-5 3-3 6 0 10l2 2c5 4 5 5 1 12h-10l3-7-7-3-5-1 4-8c2-8-5-16-2-24v-2q-2-10-6-19-3-7 4-9l11-1c11-2 15-3 14-14l1-5 1-5-2-15q0-4-4-5l-4-5q-1-7-7-4l-5-2q-1-6-7-7-2-2-3-5 1-9-7-10l-2-4 2-2q11-2 18 6 2 5 5 1c3-2 9-3 10-8l1-1q6-2 4-7t-4-9l-7-8c-3-4-5-10-12-8l-4-2q-6-6-12-10-10-4-17-12l-6-8h2a33 33 0 0 0 22 11q5 9 15 10l4 3q2 6 6 2 5-4 9 1l6 1h5l3 1h5v3h-8l4 10 1 5q-2 6 4 7 6 0 8 6l4 2h7l3 2c1 8 7 9 13 11s13 2 17 9q2 2 5 3c10-2 13 10 21 11l2 2 5 5q3 1 5 3l6 8q-2 5-6 1l-14-11z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a282c",
    d: "m1138 1844-6-8q-2-2-5-3l-5-5-2-2c-8-1-11-13-21-11q-3-1-5-3c-4-7-11-7-17-9s-12-3-13-11l-3-2h-7l-4-2q-2-6-8-6t-4-7l-1-5-4-10h8q6 8 10 3l14 4 19 7 13 4 10 4q4 10 18 8l10 11q7 3 10 10 4 8 12 11 15 6 22 19 6 8 5 18l4 3 7 1-2 5-4 5q-4-1-6-4-2-6-8-5-3 0-7-2l-5-5-10-4-3-2q1-8-7-7z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#39373d",
    d: "M1206 1843zl5 4 11 10q-3-1-5-3-4-5-10-2l-2 1c-7-5-15-7-20-15l-8-8-10-9q-10-11-21-20-9-6-22-11l-1-4 22 11 5 2 13 13 4 3 14 13 6 6q10 2 16 9z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1232 1863 8 8q-6-1-8-8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "m1163 1857 5 5zM1150 1851l3 2-1 2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1228 1860 3 3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#39373d",
    d: "M1225 1857zq-2 3-3-1z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M1087 1956q-3 6-12 5l7-4 1-1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M1087 1956h-4l1-2 3-3h2l3 2-3 3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1087 1951-3 3h-3v-3h6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m1065 1963-9 2zM1073 1961l-5 2zM1051 1965h-2z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M1009 1951h16l-13 2-5 2h-39l-2-2h-34l-3 2h-8l-2-2h-20l-2 2h-8q-5-4-8 0h-16q-3-4-5 0h-2q-4-4-7 0h-5l-1-1-1 1h-11q-5-4-8 0h-8q-5-4-8 0H487q-3-4-6 0H354l-18-1-11-1v-2h684"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "M170 1955h-6l-5-4h-8l1-10 2-4q8-15 10-31 1-8 4-12 5-3 9-8l8-12q2-8 3-16l3-3q4-3 2-7l-1-14 2-3 9-2v15l-1 6v6l-2 13-7 18v3l-5 6q-7 9-12 20l-11 30 2 4 5 3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M151 1951h8l5 3-5 1q-3-4-6 0H91v-4h2l33 1 6-1h7q3 5 4 0z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2824",
    d: "M265 1955h-17l-5-2h-14l-4-2h17l9 1 13-1h41l-5 2h-30z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m265 1955 5-2h30l5-2h8l7 2v2zM171 1955l1-2 36 1v3h-35z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1007 1955 5-2 13-2h32v2l-3 1zM929 1955l3-2h34l2 2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m225 1951 4 2h14l5 2-36-1 1-1 10-2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M320 1955v-2h5l11 1 18 1-5 1zM897 1955l2-2h20l2 2z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M1082 1951zl-2-1v-4l10-1c0 5-5 3-7 6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M1079 1946v4l-5 1-1-1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1059 1951h7v1l-7 1z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M1066 1952zl3-1h4l1 1z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M809 1955q3-4 8 0zM881 1955q3-4 8 0zM825 1955q3-4 8 0zM851 1955q3-4 7 0zM212 1954zl-4 2v-3zM978 1955q3-4 6 0zM481 1955q3-4 6 0zM153 1955q3-4 6 0zM860 1955q2-5 5 0z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M91 1951v3l-2 1v-4h2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M633 1955h3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M1059 1951v2h-2v-2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m171 1955 2 2zM844 1955l1-1 1 1zM136 1955h2z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m333 1538-1 2c-17 10-34 20-54 21l-44 3-25 3 4-4h4l4-1 24-1h3l9-2h13q20-1 38-8l24-13zM175 1572l-5 3-45 10-23 2-34 2 4-3 20-1 34-4 45-9z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M363 1446v-4l2-9v-2l2-14h2v9l-4 32v7h-1l-1-10z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m359 1513-10 11v-3l2-3 2-2v-1l2-3v-1l4-6 2-19h3l1 3v2l-3 15-2 3zM201 1567l-8 4-15 2zM345 1529l-10 9 6-7z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m341 1531-6 7h-3zM213 1563l-4 4h-3l-1-1zM257 1559"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M363 1481v-5h2l1 5v2h-2z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m245 1561-8 1z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M364 1465h1v7l-1-1z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m363 1471 2 1v4h-2zM359 1505l-4 6zM363 1481l1 2v3h-3zM221 1562l-4 1zM361 1489l-1 3zM355 1512l-2 3zM349 1521v3z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M205 1566zh-2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M270 1559h-2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m347 1527-2 2z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m353 1516-2 2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m220 1570 3-2 19-1 51-4q16-3 30-14l3-2h1v1c-7 6-12 14-21 16l-9 1-33 4h-17l-5 1h-22"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M366 1483v-2h2l1 3v12c-2 8-1 17-5 25l-1 3-2 4c-3 3-3 8-8 9l6-12q2-5-2-5l4-12 1-2v-3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m143 1587-8-1 38-9-8 5h-2l-9 1-9 4z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M357 1520q4 0 2 5l-6 12-1 4-5 2v-3l8-13v-3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M219 1570h15l-3 3h-20l3-4z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m46 1594-6 4H20l18-3z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "m355 1527-8 13-3-2 1-3 3-4 2-1z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M191 1573h10l1 1-1 3h-12z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m165 1582 8-4 2-1h6l-7 5h-9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M344 1535v3l-10 6h-2zM202 1574l-1-1 13-4-3 4zM181 1577h-6l9-2-1 2zM17 1598l-8 1zM108 1590h-8zM355 1527l-5 3 5-6z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "M332 1544h2l-4 3-1-2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m191 1573-2 4h-2v-3z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M187 1574v3l-2 1-2-1 1-2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m348 1531-3 4zM132 1586l-3 1zM329 1545l1 2h-3zM199 1573h-2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m990 1729 1 2 52 22 37 10 39 15 36 18 10 5h1l10 8 1 2 36 29 6 4h1l2 5-15-10-31-25q-11-9-24-17l-28-14-5-1q-11-7-24-10h-1l-5-3-10-2-32-11-1 1-2-1-17-6-45-21-73-30-2-3 10 3 54 23z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1219 1844-6-4-36-29-1-2 10 6 33 27zM1176 1809l-10-8q7 1 10 8"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M1113 1952h-14l7-3h5l4-2h22v2l-18 1z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M1099 1952h8l-4 3-14 1 3-3 3-1z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M1145 1952h-4v-3h12l3 4z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M1131 1947h-11zM1099 1952h-4l11-3zM1169 1953l1 2h-5v-2zM1143 1948l-2 1h-4v-2zM1156 1953l-3-3 5 2zM1115 1947l-4 2zM1163 1953h-2zM1150 1949h-2z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M1165 1953v2l-2-2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M1044 1757h2l10 4 12 4 11 2 10 4 5 1h1l7 4 17 6v3h-1l-11-3-10-4-13-4-19-7-14-4-10-3v-3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1206 1843h-2q-6-7-16-9l-6-6-14-13-4-3-10-12 29 23c8 7 18 10 23 20"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#303037",
    d: "m1107 1782 11 3 2 3 4-2 1 4q-14 2-18-8"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1212 1847-5-4z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#39373d",
    d: "m1121 1786-1 2-2-3h1z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1225 1857h-2v-2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M553 485h5l4 2 10 3h1v3h-2l-9-2h-3q-5-2-8-1-9 1-14 9h-1l-6 4-3 2-4 3-4 3h-2l-4 3-8 1-2 2h-4l-2 2h-5l-2 1h-2l-18 1-17-2h-2q-8-2-14 4l-2 1-15 17h-1l-4 4h-1l-11 4h-5l-2 2h-3l-3 1-10 2q7-7 15-7 19-2 30-18l9-9q7-5 18-4l36 2q9-1 16-5 13-4 23-12 12-11 26-16"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m194 841-3-5v-3c1-4 3-8-2-12v-4q-5-13-2-27 8-13 8-27l-2-2 1-3 1-5v-2q5-10 2-20v-2q-1-16 6-29l3-1-3 7v1l-3 4-1 15v5q4 9 0 20l-2 11q-1 15-7 30-2 7-1 16l6 30z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m245 655 2-5 14-23q10-14 25-20 18-4 26-21l3-3q0 6-4 11l-2 4-1 1q-10 9-21 10l-2 3-2 1q-11 2-16 11l-15 22z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "m380 554 11-2 2-1 5-2h5l11-4h1l4-4h1l10-8h1v2l-2 2q-7 11-17 13l-37 9-30 3 3-4h4l5-1h7l10-2h1l3-1z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m245 655 7-9 15-22q5-9 17-11v1l-1 1q-15 7-20 21l-1 2-5 8-3 3v2l-3 4-5 7-2 3h-3l1-4 1-2 2-2z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m348 558-3 4-11 3-2 2-5 5-2 2-1 2-2 3-4 6-6 9 4-11v-3l5-8v-1q10-9 22-13h5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M223 682zh1l11-11 6-3v1l-8 10-10 11-1 1-11 8-4 1 12-11z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m193 761 2 2q0 14-8 27v-3l2-6 1-2zM223 682l-4 6-12 11h-1l-3 1c-1-5 5-6 7-9l5-3 4-3zM202 700q-6 13-5 29h-2v-15l1-7 2-2zM187 790q-3 13 2 27l-4-3v-5l-2-3 2-15z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M343 558q-12 4-22 13 7-12 22-13"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M197 731q3 10-2 20v-3l1-3zM234 671l-10 10v-3l8-7zM241 667l-6 3v-2l5-7h2l-1 4z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m321 572-5 8z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M364 557h-6v-2l6-1z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M358 555v2h-5q0-5 5-2M242 661h-2l3-4v2zM197 731l-1 4-1-6h2zM348 558zq0-6 5-1v1z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m367 554 4-1 2 2-6 1zM195 753l-1 4-1-4z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M352 558zh5z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M367 554v2h-3v-2zM373 555l-2-2h4v2h-2M219 685l-4 3zM187 790l-2 1 2-4zM235 668v2l-1 1h-2zM196 745l-1 3zM183 806l2 3-2-1z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M375 555v-2l3 1z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M224 678v3h-1zM190 779l-1 2zM198 705l-2 2zM195 714v2z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M243 659v-2h2z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M195 753h-2l2-2zM989 1729l-18-7-54-23-10-3-5-2-13-7q-14-5-22-17-4-5-9-9v-1q8 1 11 8 8 10 20 16l47 21 38 15z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M885 1547v3l-4 7-4 1v-3l1-2 1-2 4-6v-2l1-3 1-1 5-8 4-8 2-2 13-24 4-11 2-5 2-3 1-5 2-3 3-3v1l-4 15-4 4-25 49z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m841 1603-5 8c-9 7-7 24 1 31l4 5q-6-3-9-7c-7-7-8-18-2-25l5-10 4-3zM885 1547l5-11 25-49 4-4a524 524 0 0 1-34 64"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m835 1605-5 10c-6 7-5 18 2 25q3 4 9 7l3 1v3l-6-2-8-5-1-1-2-4v-2q-9-12 0-23l1-2zM873 1568l-6 9-8 5 18-23zM841 1603l-2-1 20-19v2l-5 5-11 11z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m919 1479 5-11 4-8 3-3-4 12-3 4-1 4z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m931 1457-3 3-4 7h-1l4-10v-2l4-4v6"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M931 1456v-7l1-2 4-2zM873 1568l4-9v-1l4-1zM851 1652l7 7h-3l-4-3v-4M859 1585v-3l8-5z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m919 1479 4-2-4 6z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M844 1651v-3l5 4h-3zM881 1555l4-5z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M846 1652h5v3h-2l-2-1z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m924 1473 3-4z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "M855 1659h3v2l-1 1z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m969 1346-3 14v4l-5 9q4-24 7-46a1382 1382 0 0 0 1-106l-6-44-4-30-1-2v-6l-2-3 2-31 4-15 1 2-1 7v2l-2 10 1 11v20l1 8v3c1 4-1 9 4 11v13l3 20 2 3v5l1 14 2 6v49l-2 9z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m1051 958-1 1-5 5h-1l-3 3h-1c-9 7-20 11-25 22l-4 4q-3 15-15 24l-3 1v-3l7-6 1-2q7-5 7-13-1-6 3-8l11-11h1l16-12 2-2h1l5-4 2-2 6-4z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M996 1017q12-9 15-24l4-1-7 14q-11 14-17 32h-1v-5z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M983 1062zc-4 2-9 2-9 8l-2 2-4 9-3 5v1h-3v-4l6-14q6-7 15-10z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M1015 989c5-11 16-15 25-22l-9 9-16 15z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m1074 931-1 2-6 4q9-12 11-26l3-1q-1 6-3 11z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m968 1082 4-9 2-2 3-1-10 19-5 10 1-7 2-4v-1z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1067 937 6-4-15 19-7 6 4-7v-1z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m974 1225-2-6-1-14 3 6z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1074 931 4-10q2-5 3-11v-2h1l-1 14q-2 4-7 9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m971 1200-2-3-3-20 3 3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M983 1062v-2l2-3v-2q2-1 2-3l1-3 3-3-4 13-2 3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m961 1122-1-11 2-10 1 6z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m991 1046-4 3v-3l1-8h3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M974 1257v-16l2 2zM966 1164c-5-2-3-7-4-11 5 2 3 7 4 11"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m977 1070-3 1c0-6 5-6 9-8z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M961 1136v-12z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M1082 908h-3v-6h2l1 3z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m962 1150-1-8zM974 1236v-7z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1045 964 5-5z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M974 1270v-6z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M1015 989v3l-4 1z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m1041 967 3-3z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M966 1171v-3zM985 1062l2-3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m960 601 7 2h1l14 12 4 6 5 11-2-1q-1-7-7-9l-2-2-3-5-5-4h-1l-2-2-4-2-4-3h-5l-3-2 2-1zM989 661l-2 10-1 2v7l-2 1h-1v-14l2-6 1-4 4-6h1v2z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M992 651h-2l1-2q5-7 0-15v-2l-5-11-4-6 6 5q9 11 7 26zM1003 718v2q-16-2-16-16v-1l7 9zM979 612l-11-9q8 1 11 9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M987 686v8l-4 1 1-9z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M983 695h3l1 8v1l-4-6zM987 686h-3v-5l2-1z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m989 661 2-8z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m986 673 1-2zM230 1094l-4-5-1-2-15-29q-6-11-19-20l-2-3q-8-9-3-20l9-33 3-23 4-15v-7q7-17-2-33l-5-8-2-5v-5l-2-12v-4l1-2h3l1 3v2l-1 7v7l3 4 2 6 2 4q6 6 5 15l1 9-4 24-4 14-4 27-1 4v3l-6 22v6q0 10 9 14h1l2 2h1q9 9 14 22h1v2l2 3q3 9 7 15l17 20q9 10 14 22l1 2c5 11 5 14-1 20v-4q2-6-1-11-2-4-2-8l-15-19z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m291 1279-9-11-17-22-7-9-8-18-1-7-2-3v-27l1-2v-3l1-3v-5l6-16h2l-4 16q-6 21-1 42 5 22 21 41l22 27 2 2h2v5zM257 1147c6-6 6-9 1-20l-1-2 16 1 1 2q-5 3-4 7l-5 5-8 11h-1z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M247 1190v8q-4-3 0-8M255 1151h2v2h-2zM249 1174l-1 3zM247 1209l2 3zM247 1202v3zM249 1169v2zM248 1180l-1 2z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m983 698 3 6q1 14 17 16l29 13 22 21q13 12 13 32v7l-1 9 2 7v7l-2 3-1-3-1-32q0-12-8-21l-4-6-8-9-14-11-19-9-2-1-2-1-6-3-10-3q-10-9-8-21z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M1056 763q8 9 8 21l1 32 1 3 1 2 1 5v4l-1 3 7 21 3 6v3l-1 4-3-10-9-30c-3-21-2-43-8-64"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M1068 816v-8l-1-15v-7l3 3z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M1068 816zl-1 5h-1v-1z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M1067 821zv5z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M705 484h2l4 3 14 7q10 9 23 13 20 5 42 7 12 1 21 10h-4q-9-8-20-8-30 0-58-14-3-1-4-3-4-6-9-7l-5-2q-11-7-22 0l-4 1q-11 0-20 4l-10 4v-3l4-1 18-6 4-2z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M811 524q-9-9-21-10-22-2-42-7-13-4-23-13l-14-7-4-3 2-1 18 11q18 13 40 15l14 1 4 1 3 1 17 4 7 3 2 2 3 5 8 9h-3l-3-3-3-3h-1zM705 484l-24 3-4 2-18 6 4-5h2q12-5 25-7 8-1 15 1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m765 505 4 2zM777 507l3 2zM772 507h2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M655 496zl-3 2h-3l-6 2c-11 6-23 4-34 2l7-1h12l10-3 16-4zM595 499h6l3 1h2v3l-13-2-17-5h-1v-3l9 2h1l6 2 2 2z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M655 496zl9-5-4 5zM606 503v-3l10 2-7 1zM604 500l-3-1z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m920 604 9-3 10-2h11v3q-18-1-34 7l-21 8q-9 4-14-3l-5-8-11-18-2-5 4 2 1 2 3 3 9 17q5 8 14 7l22-7 2-3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m918 604-2 3-22 7q-9 1-14-7l-9-17 7 11q8 15 27 8zM871 590l-3-3zM812 519l-7-3-17-4-3-1q15-2 27 8"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1079 902v6l-4 3v-18l1-18h2v3l1 3 1 3-1 3v2l1 3v3z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m1077 859-3-5-7-21 1-3 5 12 4 15zM1078 878v-3l-1-4v-8l3 2 1 3v4l-1 6z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m1080 865-3-2v-6z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m1079 887 1-3h2l-1 3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M1081 872v-4z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M1078 878h1v2zM822 535h3v1l3 3v1q4 9 10 15l9 9q10 5 12 16l-2-1-3-4v-1l-2-3-5-4h-2l-9-8-5-8v-1l-3-3z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M859 580q-2-11-12-16l-9-9q-6-6-10-15l10 10 21 20 4 12zM828 539l-3-3z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m841 547 1 3-3-3zM969 1342l2-9z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M334 1339v-1l-2-3h-1l-2-2v-1l-10-16-19-25-1-5 2 1 2 2 2 2v1l5 5 5 4v1l3 7 2 3 19 28zM361 1392v-2l-2-5v-6l-6-12-7-13-4-5v-1l1-1 12 14 8 27 5 21-3-6z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m353 1367 6 12h-3l-1-4-2-3zM342 1347zh-2l-3-4-3-3v-2l5 1v1l3 3zM347 1355l6 12-2-1-1-1-3-4z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M356 1379h3v5q-4 0-3-5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m342 1349 4 5h-3l-1-3z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M343 1354h3l1 1v4zM347 1361l3 4z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m359 1385 1 5-1-2z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m353 1372 2 3zM342 1349v2l-2-3h2zM351 1366l2 1v2z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m191 833-1 6h-2l-1-9 2-4zM185 814l4 3v7h-3v-4l-2-4z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M186 824h3v2l-2 4zM184 816l2 4zM188 839h2l-1 2z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M947 599h-8zM950 602v-2q2-1 5 1l-2 1z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m945 1429-6 8-3 3-1-2 8-18 5-12 2-2 7-20 4-7v8l-3 6v3l-3 2-6 21-4 6z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m961 1373 5-9-4 11h-1zM958 1393l3-6zM961 1381v-4h1z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M962 1377zv-2h1z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m191 874 2 12h-2z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M191 886h2v5q-4 0-2-5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m584 495-9-2h-2v-3zM589 497l-4-2zM593 499l-2-2z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1079 902 1-6 1 6zM1081 892l-2-3h2z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "M1081 889h-2v-2h2z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "m329 1333 2 2h-2zM945 1425l4-6z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m192 864 1-7 2 1-1 6z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M195 857h-2l-1-5v-3h3v8"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m192 864 2 1 1 3h-3z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M195 849zv-8h1z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "m343 1347-1-3-3-3v-1l-19-28-2-3 9 8 1 2 2 2 2 3 13 17 6 10 10 16v3l7 23v3l3 6v7l2 4v10h-3l-1-4v-2l-1-4v-3l-5-22-8-27z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m368 1413 1 4h-2v-3zM935 1438l1 2v5l-4 2-1-2z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m859 581 4 1v1l2 6-2-1-1-1-2-2-1-2z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M231 1096"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m332 1335 2 3z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d4cb",
    d: "M1137 1949h4v3l-10 1-18-1 6-2z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M151 1951h-19l-4-1c-5-9-4-10 2-17q5-5 6-14l-3-17 1-5 7-8 3-6-3-3-3 5-4 3-3 3q-2 6-9 8l-2 2h-3l3-5c9-3 10-12 14-18l7-9 2-1 5-18 1-4 11-23 8-15 4-4-4 14 14-1h14q7 1 7-7v-3q0-7 6-7h13q7 0 7 7l1 3q7-5 6-10l1-9q1-6 6-5 2 1 2-1c5-4 12-6 11-15l2-1c7-6 13-15 24-14q0-1 0 0v-13q0-4 5-4h12q6-1 5 5l-1 7q0 5 5 5 6 0 7-5v-6l-2-11q0-4-4-4l-3-2-5-13v-13l-1-5-2 1q-5 8-9 0l-4-2q-9 0-11-7l-3-2-18 11q-3 3-4 6 0 5-6 6-5 0-6 7l-2 5-18 14q-7 6-11 13-8 13-15 27-3 5 3 6l6 2v2h-6c-4 0-10-1-12 5l-5 3 11-19 13-25q11-17 27-29l2-1c5-12 15-18 23-27l3-4 4-4 9-4 14-3c6-1 13 2 19-3l5 2q6 9 5 19v12l7-1q2-1 3-4l1-28q-2-4-6-7l-3 5-2 3c-3-9-7-16-4-25q1-3-1-5-6-5-3-11l2-8 7-11q3-3 2-7 1-3 5-6v9c-1 4 3 10-3 13l2 5 6 3 3-5v-5q0-5 6-5 9 3 18-1-2 7 5 6h4l4 4q6 4-1 6l-2 2q-4 5-10 4l-9 2q-5 1-1 5l3 9v7q1 3 4 4h18q3-1 5-4l1-8 17 1 13 6 4 3 2 2h1l5 3 5 4q3 4 7 3c7 0 14-1 19 5l3 1q14 1 14 16-1 8 6 6l34-1q10 2 10 11 0 5 4 5h12q7 0 9 5 3 7 10 4h3l13 2 1 3v6h-8q-11 0-11 10 0 4-4 7-5 4-6 12l-4 3-13 2-6-1-3-2-2 4-1 12 1 4q5 6 13 2h9l7 3q4 1 2 4l-3 7c-3 5-3 4-8 2q-7-3-13-1-6 4-11 4-6 0-6 5 0 6-7 6h-23c-4-6-10-4-15-6l-4-3 5-3 8-1 3-3-2-3-20-2q-5 2-8-4-2-4-5-7l-19-4-4-3q-3-7-4-13v-30l4-1q4 4 8 1l2 1q2 5 4 1 4-4 8 0t9 4h23q7 0 7 6l-1 17q1 3 3 4 8 4 17 1l6-5 1-24-3-4c-6 1-10-3-15-4q-12-2-16-13-1-4-4-4-6 1-7-5l-3-2-17-4-14 2q-7 1-9-7t6-8l5-2-3-2q-7-1-6-8l-3-5-5-2q-3-4-5 1l-5 5-3 2 2 4 5 6 2 14 2 5q4 4 0 8l-2 2q0 5-5 5-5 1-6-4-3-5-7-1l-2 8c0 8 0 8-8 8q-10 1-15 9-3 5-7 5h-11q-4 1-6-5-1-4-5-3l-4 4q-1 4 4 4t4 7l-2 7q0 4-4 4h-7l-10-2q-5 1-5-5v-8l-4-4q-12 1-13 12 0 4-4 4l-6-1q-9-3-11 4c0 9-8 11-12 16q-4 2-7 6l-8 18v2l-2 2-3 5-2 2v1l-5 4-3 10v2l-5 7-1 1-5 7-1 6-12 25-3 2 7-18 2-13v-6l1-6v-15l-9 2-2 3 1 14q2 4-2 7l-3 3q-1 8-3 16l-8 12q-4 5-9 8-3 4-4 12-2 16-10 31l-2 4zm199-231c-2 4 2 4 3 5h7l-1-9-5-2zm-143 90v4h2zm121-86 2-3-2-1zm-19-6 2-1-1-1z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2824",
    d: "m177 1793 5-3c2-6 8-5 12-5h6v-2l-6-2q-6-1-3-6 7-14 15-27 4-7 11-13l18-14 2-5q1-6 6-7 6-1 6-6 1-3 4-6l5-4 13-7 3 2q3 7 11 7l4 2q4 8 9 0l2-1 1 5v13l5 13 3 2q4 0 4 4l2 11v6q-1 5-7 5-5 0-5-5l1-7q1-5-5-5h-12q-5 0-5 4v13q0-1 0 0c-11-1-17 8-24 14l-2 1c1 9-6 11-11 15q0 2-2 1-5-1-6 5l-1 9q1 5-6 10l-1-3q-1-7-7-7h-13q-6 0-6 7v3q0 8-7 7h-14l-14 1 4-14v-1l2-2h1l2-2z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m246 1685-8 15-7 9-11 12-8 9-11 12-5 8-11 21q-6 13-14 24-7 10-11 19l-11 20-9 24-5 7-3 4q-6 18-21 31-3 3-5 10c-1 3-1 8-6 6q-6-2-2-10l4-9 1-7q-3-8 2-14l4-6 12-20 3-6 5-7 6-11 5-9 2-3 10-14 4-10 15-21 1-3q5-9 11-17l3-6 14-22 18-21 21-17c2-1 6-3 7 2"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m185 1578 2-1h14l11-1 2-3h17l7 2h27q3 1 6 4-4 5-10 3t-7 5l-4 4-15 6-3 2 4 4-4 2-25-2-17-1q-4 0-6 3-5 5-13 4l-7 3-4 1-18 2q-5 0-8-4l-9-12-1-1 8-7h2l4-1h2q8 2 14-3h2c6-1 11 0 15-5h3c4-1 10 2 11-4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "M148 1753q-2-13-3-26-2-14 3-28 2-4 3-9v-15h20q6-1 8 5l9 13q3 4 2 7v2c0 16-9 29-14 43q-4 7-9 13c-6 11-6 11-15 18q-4-7-3-16z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#211f23",
    d: "m236 1603-4-4 3-2 15-6 4-4q1-7 7-5t10-3q9 4 16 0 14-7 28-3 9 4 9-5l2-8 17 12 8 4 6 6q-3 3-5 2l-13-8-7-1q-5 0-4 6-6-1-7 6-2 8-10 10l-18 6-3 1q-6-5-12-3l-5-4 5-2h7q0-9-8-10c-1 10-9 9-15 10l-17 1z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a282c",
    d: "M328 1584q-1-6 4-6l7 1 13 8q2 0 5-2l8 5-4 7v2l-3 3v11l-3 3h-3q-9 4-18 1-6-1-6 5v5l-3 5-6-3-2-5c6-3 2-9 3-13v-9l2-3 5-3q6-6 1-11z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "m128 1950 4 1-6 1-32-1 7-16 3-3q10-2 7-11l-2-8v-6l2-2 1-2 5-2h3q8 4 12 7 3 8 1 15-3 10-13 14-5 3-2 8z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "m109 1913 2 8q3 8-7 11l-3 3-8 16h-3l9-20 5-6q5-1 3-6zM328 1585q5 5-1 11l-5 3zM112 1903l-1 2zM111 1905l-2 2zM174 1801l-2 2zM177 1799l-2 2z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "M154 1587q-6 4-14 3l3-3h11M138 1590l-4 1z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M1073 1950h-4l1-10q1-6 8-4 5 2 11 1v2l-4 2-6 5z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M1048 1951"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "M1009 1951h-6l-4-4-3 4h-36l-2-2-28-1q-3 1-6 1c-6-5-14-2-21-3q-5 0-8 5h-26q-7-5-6-13l-3-3-4-4q0-6-6-8l-3-2-6-7-4-3-8-18 9 12c2 4 14 7 17 6l1-1 7-6 2-4q0-7 7-5l9 2 15 2q5 4 10 0l3-1 21-1q10 1 6-8l-1-5q0-5 4-4 2 1 5-1l5-2q4 0 4-4l-2-17q-2-7 4-7l2-5-2-24 2-29q1-7-5-5-4 0-6-4v-5l5-2c9 2 9 2 8-8v-5c-5-8 1-13 4-19q6-6-1-10l-6-4q-4-1-4-5l8 3 2 1h2l6 8q7 7 17 12 6 4 12 10l4 2c7-2 9 4 12 8l7 8q2 4 4 9t-4 7l-1 1c-1 5-7 6-10 8q-3 4-5-1-7-8-18-6l-2 2 2 4q8 1 7 10 1 3 3 5 6 1 7 7l5 2q6-2 7 4l4 5q4 1 4 5l2 15-1 5-1 5c1 11-3 12-14 14l-11 1q-7 2-4 9 4 9 6 19v2c-3 8 4 16 2 24l-4 8 5 1 7 3zm-87-33q-7 0-10-6l-3-1c-9 0-18-1-26 5h-3q-6-3-9 3-2 3-3 5l-1 9h19c7 4 15 2 22 3l13 2q3 0 4-4 1-8-3-16m58-127 1-3h-17v3z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m855 1659 2 3 4 4q9 16 26 23l15 6 5 1 2 3 73 30 45 21 17 6-3 1-10-1-22-12-24-10-15-7h-4l-28-15-20-7-8-4-8-1-3-2-2-1-2-1-12-6-15-10h-1q-10-17-25-26l-12-10 8 5 6 2v1l3 2 2 1 2 2z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m910 1701 8 4 20 7 28 16h-4l-2-1-40-17-9-5zM970 1727l15 7 24 10 19 12-40-17h-3l-5-4q-6-2-10-8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "m988 1739 40 17-6-1q-4-5-9-1-4 4-6-2l-4-3q-10-1-15-10M970 1727q4 6 10 8l5 4q-10-2-19-11v-1z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m1033 1756 2 1z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "m1041 1760 10 3q-4 5-10-3"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "m838 1905-3-4-6-8v-1l-2-9-2-4-2 1q5 7-3 10h-2q-4-3-5 1l-3 1-10 1h-30l-15-2-2-3-9-11v1l-8 2q-12-2-16-13-2-7-7-1l-5 2h-10c-11 0-11 0-11 11q0 11-11 14-4 0-4 4l5 2 9 1 3 3-4 3h-3l-20-2-30 1q-9-1-8 8 1 5-5 6l-16 1c-11 0-10 0-11 10l-3 6-17 2-26-2c-8 0-8 0-7 8l-1 4-11-1h-4l-15 2-3 2h-9q-3-5-4-11l-5-4q-7 0-6-6v-3q1-5-5-5h-38q-4-1-5 3l5 3h8l3 2-1 1h-8q-9-1-8 8l1 4q2 4-2 5h-5l-14-2-25 2-4 3h-4l-15-4-4 4h-18q3-5 8-4t9-2 2-11q-4-8 5-11l1-2h18l10-1q4 0 5-4 3-8 9-11 4-2 10 1c3 3 9-1 9-4l1-32 2-10q2-5 2-9v-2l7-4 1-2 4-5 3-4 3 4v3l-1 21 3 4 3-3v-8q0-4 2-5 6-5 14-6 21-1 44 2 11 0 23-2h40l2 7 1 4q2 3 3 2 4-4 7 0h5l1-3q1-11 9-10l9 6q6 5 10 0c2-2 12-3 14-1q5 3 10 3 9 2 17 6 4 4 11 4h9c4-1 9 1 11-6l4-1 21 1q6-1 9 4 2 6 8 4 5-3 9 3l6 3q8-1 12 7l4 3 9 5c5 3 9 7 15 3h6q6 3 10-2l9-14-5-12-2-4h4q6 2 8 6l6 20q-1 5 2 8 5 8 5 15"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "M433 1849v2l-4 5-11 17h-1c-9 6-7 17-14 24v2q1 9-8 8-8 0-8 8l-2 6h-18c-10 0-11-1-11 11l1 4v4l-3-1-1-3q-4-5-7-1-1 9-8 16h-25c1-3 6-4 4-8l-3-9 4-1q9 1 10-9l3-4q3 0 5 3 5 5 9 0 5-12 18-11h3q11-2 11-12 0-4 3-7 2-3-1-5-4-2-3-5l5-2 5 2 3-17q0-5 5-5h5l5-2-2-5-1 1h-8v-17q0-6-6-5l-11 1h-28l-5 1q-4 5-12 4l-4 2q-3 2-5 1-10-4-9 6 0 7-6 4-7-2-9 4l-4 5c-5 3-8 9-15 9l-1 1q-3 4-6 7c-2 8-11 13-12 22l-1 2q-6 5-8 13l-7 20q-6 7-2 16h-24l11-24 6-21 4-10 4-13 1-5 3-8 3-9 3-6 5-36c1-4 2-8-5-6l-4-1h-3l-13 14q-7 9-11 21l-3 4-10 17-18 34-4 9q-11 16-15 35-2 5 3 5h40l-2 2-1 1h-4l-36-1-5-3 8-27 1-2 17-31v-3l3-2 12-25 1-6 11-15v-2l8-14v-1l2-2 3-5 2-2v-2l2-1q5-13 15-21 8-6 12-13 2-3 6-3h36l9 2h14c4-1 2-5 2-8q0-4 4-4h22q6 0 6-6v-5c0-8 0-8 8-8q9 1 8-8l2-5 2 2c1 8 1 8 8 8q6 0 5 4 0 7-6 9l-1-5-3-4-3 4v24q1 13 13 12 6-1 8 3c5 4 5 4 8 0l10 1 4 3c5 7 10 14 20 12l2 1q-4 11 6 15 1 3-1 6-10 6-12 17l-1 2-9-2z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "m538 1948 1-4c-1-8-1-8 7-8l26 2 17-2 3-6c1-10 0-10 11-10l16-1q6-1 5-6-1-9 8-8l30-1 20 2h3l4-3-3-3-9-1-5-2q0-4 4-4 11-3 11-14c0-11 0-11 11-11h10l5-2q5-6 7 1 4 11 16 13l8-2v-1l9 11 2 3 15 2h30l10-1q-6 7-15 6l-23-2c-5 1-9 3-13-2h-2q-7 3-7-5c0-3-6-8-7-6-4 3-8 1-11 2q-5 2-6-4-2-3-4-3-10 3-20-1l-5 1-5 3-2 3q-3 10 7 9h3q6 0 4 5v4l3 4 5-2 2-3 8 14q1 6 6 5h20q8-2 15 6 4 6 13 6l13 2 3 4q2 9-7 13H665l-15-2-1 2H538zm222-4q2-6-3-7-3 1-5 3v5z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "M785 1951q9-3 7-13l-3-4-13-2q-9 0-13-6-7-7-15-6h-20q-5 1-6-5l-8-14-2 3-5 2-3-4v-4q2-5-4-5h-3q-9 1-7-9l2-3 5-3 5-1q10 4 20 1 2 0 4 3 1 6 6 4c3-1 7 1 11-2 1-2 7 3 7 6q0 8 7 5h2c4 5 8 3 13 2l23 2q9 1 15-6l3-1 7-1 9 2v1l8 18 4 3 6 7 3 2q6 2 6 8l4 4 3 3q-1 8 6 13h-84"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2824",
    d: "m383 1951 4-3 25-2 14 2h5q4-1 2-5l-1-4q-1-9 8-8h8l1-1-3-2h-8l-5-3q1-4 5-3h38q5 0 5 5v3q-2 6 6 6l5 4q1 6 4 11zm90-5h3q4 1 4-3t-4-6h-22l-4 4 3 4z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M338 1951q7-7 8-16 3-4 7 1l1 3 3 1v-4l-1-4c0-12 1-11 11-11l-1 2q-9 3-5 11 3 7-2 11-4 3-9 2-6-1-8 4z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "M895 1951q3-5 8-5c7 1 15-2 21 3q3 0 6-1l28 1 2 2z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2824",
    d: "M538 1948v3l-30-2 15-2h4zM360 1951l4-4 15 4z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "m649 1951 1-2 15 2z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2824",
    d: "M313 1951h12v2h-5zM345 1951h11z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "m996 1951 3-4 4 4z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "m193 1890-17 31-1 2-8 27-2-4 11-30q5-11 12-20z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "M139 1951h4q-1 4-4 0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#241e1b",
    d: "M242 1951q-4-9 2-16l7-20q2-8 8-13l1-2c1-9 10-14 12-22q3-3 6-7l1-1c7 0 10-6 15-9l4-5q2-6 9-4 6 3 6-4-1-10 9-6 2 1 5-1l4-2q8 1 12-4l5-1h28l11-1q6-1 6 5v17h8l1-1 2 5-5 2h-5q-5 0-5 5l-3 17-5-2-5 2q-2 3 3 5 4 2 1 5t-3 7q0 11-11 12h-3q-13-1-18 11-4 5-9 0-2-3-5-3l-3 4q0 10-10 9l-4 1 3 9c2 4-3 5-4 8h-8q-11-9-20 0h-20l4-4c4-3 10-5 8-12l2-3 7-14-1-2q-3-7 5-10 3-2 4-5l-3-11-2-1-11 1q-9 1-9 10-1 4-3 4c-11 4-10 14-13 22q-1 6-5 13-4 6 1 10l2 3z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m251 1952-2-3q-5-4-1-10t5-13c3-8 2-18 13-22q2 0 3-4 0-9 9-10l11-1 2 1 3 11q0 3-4 5-8 3-5 10l1 2-7 14-2 3c2 7-4 9-8 12l-5 4z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "M285 1951q9-9 20 0z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2824",
    d: "M218 1951"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M370 1423h3l1 5-1 21-3 21-2 11h-2l-1-5v-11l1-11 3-28z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m370 1423-1 3v-7zM366 1454v3z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m366 1483-1 6-1-3v-3z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m362 1506-1 2z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m326 1563-2 8q0 9-9 5-14-4-28 3-7 5-16 0-3-3-6-4h-27l-7-2 3-3h8l21 2 49-3 4-2q9-8 11-19v-1h3z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M327 1548q-2 11-11 19l-4 2-49 3-21-2 5-1h17l33-4 9-1c9-2 14-10 21-16"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m368 1481 2-11 6-5 4 18q4 16 1 31-4 17-17 20l-1-10 1-3h5c3-8 9-15 8-25l-1-11q1-6-5-6l-2 4z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m369 1484 2-5q6 0 5 6l1 11c1 10-5 17-8 25h-5c4-8 3-17 5-25z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m363 1524 1 10-9 10q-3 4-3 8l5 20-7-5q-6-5-3-14l5-12 1-4c5-1 5-6 8-9z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "M171 1582c-4 5-9 4-15 5l7-5z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m163 1582-7 5h-11l9-4z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "m326 1563 4-15 4-4 10-6 3 2v3h-1l-3 4v2l-1 2v2q-8 8 1 13l3 3 1 2 4 8-8-4z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m352 1541-5 12q-3 8 3 14l7 5 4 3 9 6 3 4-22-12-1-1-4-5-1-1-2-2v-1l4-18v-2z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "m214 1573-2 3-11 1 1-3 9-1z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2525",
    d: "M185 1578c-1 6-7 3-11 4l7-5h2z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m1079 1767-11-2-12-4-10-4 1-1z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m1119 1782-17-6-7-4q13 3 24 10M1089 1771l-10-4 10 2z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M1089 1771v-2l5 3z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m334 565 11-3 30-3 37-9q10-2 17-13l2-2v-2q11-13 27-10a111 111 0 0 0 57-7q13-4 21-17h1l12-6 10-2 3 1 10 4h1l1 2-1 2-6-2q-12-6-23 1l-5 3q-4 6-10 9l-25 10-9 5h-4l-11 1h-18l-13-2q-11 0-14 9-1 13-13 15-6 1-13 4l-18 3q-16 7-33 7l-16 2-1 2h-7z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M536 499q-8 13-21 17-13 5-27 7-15 3-30 0-16-3-27 10h-1l5-9 2-1 14-4h2q14 6 29 4l6-3h2l2-1h5l2-2h4l2-2 8-1 4-3h2l4-3 4-3 3-2z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m488 520-6 3q-15 2-29-4l17 2z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m559 491-10 2-12 6q5-7 14-9 3-1 8 1"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m435 524-5 9-10 8zM451 519l-14 4q5-6 14-4"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m572 496-10-4q4 0 9 2z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m419 541-4 4z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M572 496v-2l1-1h2v3z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m517 511-4 3zM523 508l-4 3zM530 503l-3 2zM492 519l-2 1zM393 551l-2 1zM398 549l-2 2zM499 517l-2 2zM505 515l-2 2z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M195 849v-11l2-5-5-20q-4-8-1-16 6-11 7-24c2-10 1-20 5-29q2-5 0-11l-1-12 1-14v-1l8-8 6-1 2-2 3-5 1-1 10-11 8-10 3-3 2-3 4-2 3-6 1-3 3-2 2-1-5 12-4 5-4 3-5 9-5 3-3 3-8 10q-3 5-7 7-14 4-14 18v9l2 8v12l-3 6-3 26-1 7q2 7-4 12c-4 3-3 11 0 14v3l4 10q3 9 0 17v2l1 5v16l3 5v1l2 4-1 9q-2 12 7 14l1 4c5 5 4 12 5 17l-1 4q-5 4-5 9v-7c2-10 4-20-6-27l-4-7q1-14-3-28l-3-10z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m203 707-1 14 1 12q1 6 0 11c-4 9-3 19-5 29q-1 13-7 24-3 8 1 16l5 20-2 5-6-30q-1-9 1-16 6-15 7-30l2-11q5-11 0-20v-5l1-15zM211 698l-8 8 3-7h1z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M189 826v-4c5 3 3 7 2 11z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m285 612 2-3q11-1 21-10l1 3-1 2-5 2-8 5h-4z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M285 612h6v2h-7v-1z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m309 598 2-4h1v1l1 2-1 1v1h-1z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m309 598 2 1v1l-2 2-1-3z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M373 555zl-10 2v-1h3z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m431 535-2 2z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M284 614h7q7-1 11 5l4 6 4 2 1-1-1-3q-5-13 3-19-3 10 0 20v3q0 6-5 3l-8-9-5-4q-18 1-23 16h-1l-4 2 1-4 15-16z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m283 615-15 16-1 4-4 1q6-14 20-21"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m263 636 4-1v5l-2 3-2 3-4 2v-3z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m262 638-3 7-2 1zM250 660l-4 2 5-7zM254 651l-1 3-2 1zM244 665l-3 3v-3zM254 649l3-3v3z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M254 649h3l-3 2z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m322 579 2-3 2-1-1-1 2-2 2 1v3l-2 4q-4 13-12 24h-2v-5l3-3v-1l5-9z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m322 579-1 7-5 9 2-10z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m318 585-2 10v1h-3l-1-1v-1z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m329 573-2-1 5-5h2zM325 574l1 1-2 1z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M334 567h-2l2-2zM217 697l-6 1 11-8-3 5zM223 689z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M902 1694q-7-1-15-5-17-7-26-23l-4-4 1-1q5 4 9 9 8 11 22 17z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M931 1445v2l-1 1-1 1-2 3v3h-1l-4 6v2l-3 5v2l-1 3-4 6q-11 16-19 36l-9 20-3 5v3l-3 2-1 6h-1l-1 2-1 2-9 13-2 3-42 40-7 4-2 2-11 6-2-1v-5l7-3 5-4 17-11 15-12 19-21 15-26 9-20 5-9 7-16v-1l4-4 1-3 2-4 1-1 3-5 5-7 15-37 6-15 6-15 4-11 2-7 5-18 4-9h1l2 1-1 3-11 33-18 45z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m803 1623 11-6 2-2 7-4 42-40 2-3 9-12 1 2v1h-1l-17 23v1l-20 19-4 3-7 7c-6 3-8 9-15 9l-3 5 4 2 6 4 7 7 2 4-6-3-16-9-4 1-2-7z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m891 1523 4-8q8-19 20-36v2l-2 6-7 10-12 26z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m894 1523 12-26 6-10-3 10-13 24zM920 1470l-1-2 3-5v-2l5-4-4 10z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M891 1523h3l-5 8zM886 1535l1-3 2-1-4 8zM879 1551l1-6h3z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m915 1479 2-6v4zM886 1535l-1 4-1 1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m915 1479 2-1-2 3z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M878 1553v-2zM883 1545h-3l2-2z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m807 1631 16 9 6 3 1 1 12 10q16 9 25 26l-8-6-1-1q-3-9-11-10l-1-1-3-3-19-13-3-4-12-6h-4z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "m827 1639-7-7-6-4-4-2 3-5c7 0 9-6 15-9l-1 2q-9 11 0 23z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m927 1457-5 4 4-6z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M929 1449h1l1 2-4 4v-3z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "m851 1656-2-1h2zM847 1654l-3-2h2z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "M961 1362v-3l3-23v-19l1-29q2-17 3-35l-4-45-3-11v-3l1-5-6-35-3-24 2-19 1 2v24l2 2v6l1 2 4 30 8 77q-1 37-3 73-3 22-7 46v6l-4 7-7 20-2 2 10-31z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M962 1086v4l-4 15-2-3 1-2 1-3zM957 1113l-2-2 1-3h1z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "M957 1108h-1l-1-6h1l1 3z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M962 1090v-2h3l-2 4z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m959 1147-1-2zM958 1139l-2-2z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M987 1038v8l-7 11q-4 6-8 0l-2-5-2 2-2 4q-1-5 2-7 3-1 5 3 4 5 6 0l6-15-1-6 1-4c-1-10 0-12 9-17l3-3h3l-7 6q-4 3-5 6zM1022 975l-11 11q-4 3-3 8 0 8-7 13v-4l4-8c-2-7 3-10 7-14l2-2h1l2-2 2-2h3"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M988 1038v-17q1-3 5-6v3l-2 7-1 8v5z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1038 963-15 12 6-6 6-6h3"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1035 963-6 6-6 6h-3z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m990 1033 1-8 2-7 3-1z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1049 955-2 2-5 4h-3l10-9z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M1049 955v-3l2-3 4-1v3z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1001 1004v3l-1 2-2-1v-4z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1042 961 5-4zM1039 961h2l-2 2h-1z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m985 1040-6 14q-2 4-6 0-2-4-5-3-3 2-2 7v2l-4 8v17l-6 15v2h-1l-1-1 2-11v-3l2-2 1-6v-13l1-1v-2l4-9c2-7 2-7 9-5h1q3 4 5 1z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m962 1084 1-17q4-2 3-7v-2l2-4 2-2 2 5q4 6 8 0l7-11v7l-2 2v2l-2 3q-9 3-15 10z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "m968 1082-3 5zM974 1071l-2 2z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1075 911 3-3h2l1 1-3 2q-2 14-11 26l-2 3-8 5v-3l8-8v-1l2-2 1-1 3-5v-2l4-10z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m1057 945 8-5-10 10v-3z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m983 1060 2-3zM985 1055l2-2z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m865 589 11 17 5 8q6 7 14 3l21-8q16-8 34-7l6 2h5l4 3 4 2 2 2h1l3 4-12-6-16-4h-10l-5 3h-8l-2 2-4 1-2 3h-5l-16 6-12 7-6 3-2-7q1-9-2-18z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m963 610 17 10 2 2v3q9 10 5 22l-1 10-1 4-4 2v-1l1-5 3-10q3-14-7-22l-9-8z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m986 657 1-10q4-12-5-22v-3q6 2 7 9l2 5-1 13v2zM980 620l-5-5h2z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "m956 604-6-2h3zM977 615h-2l-3-4zM965 607l-4-3zM991 635l-2-4 2 1v3M971 611l-2-2z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m983 667-2 18-1 14-1 2c-5 5-1 11-1 16l6 4q-12 4-11-8l2-11 4-11-1-4 1-9 2-13z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m983 667-2-2v-2l4-2z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "m981 685 1-4h2v4z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "M991 636v-2q4 8 0 15z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M981 685h2l1 1-1 9v4h-3z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m273 1126-16-1q-5-12-14-22l-17-20q-4-6-7-15l-2-3v-2l-2-7-10-15q12 5 15 18l3 13q5 12 15 20l4 5 2 2 11 14 4 5c1 6 5 5 8 5zM195 853l3 10q4 14 3 28l4 7c10 7 8 17 6 27l-1 7v4l-3 17h-2v-4l3-24c2-11 3-21-8-28l-2-10v-14l-2-2-1-3v-15M195 997l1-4h3v14c-1 5 1 10-2 14q-6 7 2 12l4 3 1 3 1 2h-4l-2-2h-1l-8-14 4-7 2-14z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M200 897c11 7 10 17 8 28l-1-9q1-9-5-15zM195 997l1 7-7 19v-4zM202 1041h3l10 15 2 7h-1q-5-13-14-22M196 990l5-27v16z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "m189 1023 7-19-2 14-4 7h-1z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M189 1025zl8 14q-9-4-9-14"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "m204 949 1 4-1 5-1 3v2h-2zM198 876v11h-3v-7z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m198 876-3 4 1-7h2z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "M196 990h3v3h-3z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M195 887h3v4zM217 1065l2 3z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "M198 873h-2v-2z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m199 1039 2 2z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "M315 1302zq-4-12-14-17l-2-1v-2l-4-7-20-25q-10-15-17-31c-6-11-4-24-4-37l5-14-1 10-2 21 3 5h2v-5q0-10 3-18 7-18 16-34 2-5-2-5l-10 1 5-4 11 1-1 9-2 6-3 4v1l-2 3-5 15-6 22q1 6 4 12l2 7q-1 12 8 18c3 3 5 8 9 1l3-1h1v2q1 8 5 14 7 12 12 23 3 8 9 12 6 7 16 8h2l4 1 7 2-4 7-16 8-4-4z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m273 1138-7 6q-7 9-7 20v3l-5 14c0 13-2 26 4 37q7 16 17 31l20 25 4 7h-2l-2-2-22-27a99 99 0 0 1-21-41q-5-21 1-42l4-16v-2l8-11 5-5h3l2 1z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "m299 1283 2 1v3l-2-1zM295 1279l2 2z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "M273 1135h-3q-1-4 4-7l11 1 12 2 1-1 1 1 6 2 4 2 4 3 12 6 5 11q3 5-4 3l-11-5-5-2h-2l-1-3-14-11-9-1-3-1z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m296 1131-11-2-11-1-1-2 1-1 20 4h2z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1030 737 14 11 8 9-1 2-13-12q-9-9-22-13l-4-4 7 2z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#898784",
    d: "M980 699h2q-1 12 9 21l-5-1c-4-3-7-13-6-18z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m986 719 5 1h1l9 3 6 3v2h-1l-15-4-1-1-4-2z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1030 737-11-5-7-2-1-2z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "m1067 793 1 15-2-6z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1001 723-9-3zM1051 759l1-2 4 6z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1011 728 1 2-5-2 2-1z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1009 727-2 1v-2z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1051 760 4 3c7 21 6 43 9 64l9 30 3 10 1 4-2 2h-1v-2l-6-20-2-4v-2l-3-6-1-3-1-11v-8l-3-14v-3l-2-2-11 1h-2l-5-5-1 1 1 4-1 7-2-1q-2-6-8-8v-1l3-1 3-1v-6h1q3 6 8 5l2 1q5 6 9 1l2-5q2-3 3-5l-4-17q-1-4-3-8M655 499l10-4q9-4 20-4l4-1q11-7 22 0l5 2q5 1 9 7 0 2 4 3 28 14 58 14 11 0 20 8h-1l-11-4h-2l-12-2q-23 0-43-9l-6-2q-9 0-11-8l-5-4h-3l-6-4h-2l-11 1c-2 8-10 4-12 9q-2-5-4-6c-2 0-4-3-6 1h-3l-4 2-17 8q-7 2-12 8-2 2-6 1-7-5-18-5l-11-3h12c11 2 22 4 32-2z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m811 524 4 5-5-3-1-2z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m677 489 4-2z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m809 524 1 2h-3v-2z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M655 499zh-1l2-2z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m822 535 6 12-5-4-4-4q1-5-3-5v-3l3 1z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M807 526h3l5 3v1l-4 1z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M815 530zl3 3z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M613 507h-3l-3-2q-13 0-25-5h-2l-4-2v-2l17 5 13 2h3c11 2 23 4 34-2l6-1c-8 4-16 9-26 7z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M613 507h10c10 2 18-3 26-7l3-1h2l-9 6c-10 6-21 4-32 2M576 496v2h-2l-1-2h3"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "M1074 871v2c-4 7 0 14 1 20v5h-1l-4-11q1-5-5-6-5 0-5 5-5 14-2 28v4l-2 13h2l9-7v2l-7 8-3 5v1l-6 7-24 17-8 6-11 9-8 10q0 2 1 5l-1 5-2 5v1l-8 4 1-2 3-4 3-4 1-6v-8q7-7-1-10-8-4-12-12-2-4-7-9-5-3-5-9l-2-4q-10-9-13-23l-5-12-10-16q-1-6-4-7-8-4-13-9-5-4-6-9l-1-4q-6-8-13-15-5-5-8-11-2-5-6-6l-11-3-1-8-6-2q-7-3-12-8l-5-4q-3-5-7-2l-17-10-33-13-12-2v-4l21 4 8 2 19 7c5 2 9 7 16 7l4 3 12 10 17 8q6 3 13 10 9 11 20 21l3 3 6 8q5 3 7 8 1 8 9 9l5 2 6 2 3 2-2 2-3 1v1l4 2c11 0 9 4 8 11l-2 3 6 3c3-4 9-5 9-11q1-6 5-3l5 5 3 4 3 4q6 2 5 9 3 7 2 16l1 2 9 11 4 3q8 3 15 1 5 0 7-4l4-3q7 1 9-5l1-4q6-5 3-12l-5-19q-2-5-1-7 3-7 1-14 0-6 5-5l6 1-3-6-2-2q-11-1-14-10-4-9-13-14-7-4 0-10 5-4 9 0 8 2 9-6v-2q5 3 2 7c-7 8-1 17 0 25l2 2 11 9 11 5z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "m1067 924-9 7h-2l2-13v-4q-3-14 2-28 0-5 5-5 5 1 5 6l4 11 1 7v3h-1z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M1075 893c-1-6-5-13-1-20h1v20M1075 905l-1-7h1z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1076 875-1-2 2-2 1 4z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M1074 908zv5h-2z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m819 539 4 4 5 4 3 3v1l1 5-6-5-2 3q-3 5-8 3c-4-2-1-5 0-8z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M854 574v1l3 4v4l-10-11v-2l5 1z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m836 559 9 8h-4q-6-2-5-8M832 556l-1-5 5 8-4-1zM852 571l-5-1v-3zM857 579l-3-4z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M847 567v3h-3v-3h3"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m831 550-3-3zM857 583v-4l2 1v3zM854 574l-2-3z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M301 1287v-3q10 6 14 17l-5-4-5-5v-1l-2-2zM315 1302l12 11v4l-9-8z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "m305 1292 5 5zM303 1289l2 2z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa098",
    d: "m339 1341 3 3z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m960 1362-2 15-11 31-4 12-8 18-4 7v-5l18-45z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "M373 1415v-6l1-4v-8l-3-7v-5l4-6 4 5 7 7q7 5 13 11c4 6 4 7 12 4l2 1v8q1 3 3 5 6 2 7 10c0 6 6 12 7 18q1 3 3 4l2 3 3-3-1-4c-2-8 9-5 10-11l3-1 2 2q3 5 10 0l1 12 3 7q5-3 9-7l-3-10v-3h3l5 8q-1 6 2 11v3l-8 20-2-1c-1-5 2-12-4-17q-5 5-1 9l2 6q1 6 5 9c6 3 5 9 5 14l-2 5 2 7h5l6 1v4q-1 4-1 7l9 10 3-1q2-8 10-5l6-3c-4-4-2-11-8-13l7-7q4-4 7 2l2 3-1 12 5 6q6-3 11 2l3-1q5-2 6 3l5 13 7-8q3-6 8-4 6 1 4 7l2 3q3 3 1 6l-1 15 3 4 4-2-1-6q-4-3-2-6l1-5 3-11 8 5-3 6-2 6q1 5 7 5v2c-2 3-5 5-1 7q4 0 7-3v-4l5-3 3 7v5l-1 3 1 5 3 2 3-5 5-9 2 1-1 5q-4 2 0 6l6 4h3q2-6 8-6 6-4 10 3l5 5c7 6 16 7 19 17q1 2 5 3l3-3c-2-5 0-11-5-15l-3-4q-2-4 2-6l11-3 4 2q3 4 7 2t9-1q4 2 8-1 6-5 6 3l1 6 1 5h2l4-10q1-6 7-5 8 4 5 11-3 5-3 10 0 9 8 4l5-3q4-3 7 1 5 7 12 3c5-2 8-8 14-6q2 0 3-4 0-5 5-3l5-2 9-8h3v3l-2 4 6 4q-7 6-16 3l-2 1-6 3q-8 3-16 6c-5 3-11 7-16-1q-3-3-6 1-4 6-9 4l-7-8-3-8h-1l-4 10q-1 6-7 7-7 1-6 8l-3 6h-2l-11-6-5-2q-7-6-15-6-5 0-9-5-2-5-7-1l-4 3c-5-1-11-1-11-8l-1-2-2 6-10-5-8-8q-2-6-9-2-5 4-7-3l-4-7-3-3-4 3 1 7q1 4 3 7l-7-1q-9 1-7-8 1-6-6-6-4-2-7-5-3-6-9-5l-8 5-3 4-4-5-1-12q-1-3-4-5l-3 3-4 8-2-5v-8l-3-7q-5-1-8 6l-2 6-4 4q-3-2-4-5-1-6-7-7l-13-7-1-3-2-3-5 2-5-6-2 10 5 3h1l15 10v4h-8q-4-2-4 2l-5-2q-4-6-9-8l-15-13-5-4q-5-4-11-9l-6-7c-4-4-5-10-11-13v-1q11 4 15-1 4-7-2-16l-3-3-2-5v-11q1-6-5-10l-14-10q-5-3-5-9l-3-6q-9-5-7-15l-1-4-3 3-1 4q-8 9-5 19 3 5-2 8l-1-3-3-5-1-5-3-4-1-2-4-6v-2zm103 108 4 1v-2z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m361 1367-10-16 3-5q6-3 5-9l1-2 5-18v-2q2-7 3-14l-2-42-3-41v-21l-2-10v-2l1-4 3 13v5l1 40 1 9q3 14 2 27l1 7 1 12-6 33v2l-2 7-4 11q-4 6 0 11 5 3 2 9M374 1417v2l4 6 1 2 3 4 1 5 3 5 1 3 3 9q8 21 23 37l4 10-2-1-2-2-8-11q-17-22-25-48l-6-10-1-11z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M361 1367q3-6-2-9-4-5 0-11l4-11 2-6 1 7v8l1 11v6l1 21-3-10-4-3z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "M359 1335v2q-6 6-14 4l-13-17 6-13 5-6h2l-2 6q-7 4-3 10l3 8q6 12 14 3l2-1z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m343 1305-5 6-6 13-2-3-2-2-1-2v-4z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M345 1341q8 2 14-4 1 6-5 9l-3 5z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m361 1370 4 3 3 10v10z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M368 1393v-8l3 3v2q-2 5 3 7l-1 6h-2v-2l-3-5zM374 1405l-1 4h-2v-3z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m368 1396 3 5zM374 1405l-3 1v-3h2zM371 1409h2v4z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m328 1319 2 2z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M374 1417zv-2z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m865 589 8 16q3 9 2 18l2 7 6-3 12-7 16-5q-2 3-6 5-13 5-24 14h-8l-2-5v-11q1-9-5-17v-3l-3-10z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m863 588 3 10-3 1h-1v-2l1-2-2-2-4-10h2l1 2 2 2z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m862 587-2-2z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M441 1843q1-11 12-17 2-3 1-6-11-4-6-15l-2-1c-10 2-15-5-20-12l-4-3-10-1c-3 4-3 4-8 0q-2-4-8-3-12 1-13-12v-24l3-4 3 4 1 5q6-2 6-9 1-4-5-4c-7 0-7 0-8-8l-2-2-2 5q1 9-8 8c-8 0-8 0-8 8v5q0 6-6 6h-22q-4 0-4 4c0 3 2 7-2 8h-14l-9-2h-36q-4 0-6 3-4 7-12 13-10 8-15 21l-2 1 8-18q3-4 7-6c4-5 12-7 12-16q2-7 11-4l6 1q4 0 4-4 1-11 13-12l4 4v8q0 5 5 5l10 2h7q4 0 4-4l2-7q1-7-4-7t-4-4l4-4q4-1 5 3 1 5 6 5h11q4 0 7-5 5-8 15-9c8 0 8 0 8-8l2-8q4-4 7 1 2 5 6 4 5 1 5-5l2-2q4-4 0-8l-2-5-2-14-5-6-2-4 3-2 5-5q2-5 5-1l5 2 3 5q-2 7 6 8l3 2-5 2q-8 0-6 8t9 7l14-2 17 4 3 2q1 6 7 5 4 1 4 4 3 11 16 13c5 1 9 5 15 4l3 4-1 24-6 5q-9 3-17-1-2-1-3-4l1-17q0-6-7-6h-23q-5 0-9-4t-8 0-4-1c6-1 4-5 4-8q0-6 6-3l5 4q2 2 5 3h23l3-2-2-3-4-3q-9-1-10-10-1-3-3-3l-15-3c-6-3-13 0-13 6l-1 21q-4 2-8-1l-4 1v30q1 6 4 13l4 3 19 4q3 3 5 7 3 6 8 4l20 2 2 3-3 3-8 1-5 3 4 3c5 2 11 0 15 6h23q7 0 7-6 0-5 6-5 5 0 11-4 6-3 13 1c5 2 5 3 8-2l3-7q2-3-2-4l-7-3h-9q-8 4-13-2l-1-4 1-12 2-4 3 2 6 1 13-2 4-3q1-8 6-12 4-3 4-7 0-10 11-10h8q8 6-1 8-4 1-4 5 2 8 9 8 6 1 8-5 0-9 5-14l1-4-1-6 13-3q7 0 3-6-5-4 0-8l3 6 1 14q0 5-4 5l-3 2 1 2h9l2-5q-1-9 6-13l17-4h22q5-1 5 5 0 3 3 4c3 3 10 0 13-3q4-2 9-1l5 2-6 5-4 1q-5 0-2 4v5q-7 9 4 7h2q9 0 7 8l-1 4-2 3-4-1-5-3-3-4q-1-7-8-6l-12 1q-3-1-4-3-1-9-10-5h-4l-6 3q-2 3-6 4l-18 1q-11-1-20 6c-8 5-7 17 0 21q5 3 6 6-1 5 4 4h7q7 5 10 11c3 9 2 9 11 9q10 1 8 10-1 6 6 7l5 4q1 12 12 11l4 1q7 4 15 4 9-1 18 2h3c4-4 7-1 11 1q6 4 12 5 17 0 33 8l8 2 7 4 5 5q9 2 14 8l9 3 8-1q4 2 7-3l3-4q5-5 2-10-3-7-11-5h-7q-5 0-3-5l9-14 3 1 2 4q0 7 7 7l6 2 13 8h1q-2 14 12 9 4 0 7 2l17 10 5 3q10 1 15 7l-24-8-8-6-6-3h-4l-2 4 3 12q3 5 0 11c-3 4-6 1-10 1q0-7-5-15-2-2-2-8l-6-20q-2-4-8-6h-4l2 4 5 12-1 3-8 11q-4 5-10 2h-6c-6 4-10 0-15-3l-9-5-4-3q-4-8-12-7l-6-3q-4-6-9-3-6 2-8-4-3-5-9-4l-21-1-4 1c-2 7-7 5-11 6h-9q-7 0-11-4-8-5-17-6-5 0-10-3c-2-2-12-1-14 1q-4 5-10 0l-9-6q-8-1-9 10l-1 3h-5q-3-4-7 0-1 1-3-2l-1-4-2-7h-40q-12 2-23 2-23-3-44-2-8 1-14 6-3 1-2 5v8l-3 3-3-4 1-21v-3l-3-4-3 4zm136-31v11h2l4-5 10-2h8q6 1 8-4 1-8-2-15l-3-2-5-3-4-2-1 3q0 5-5 4-3-2-6 2zm-98-41 5-5 3-4 3-3 1-13-3-3-17-4-6 1c6 6 6 6 6 12v11q-1 9 8 8m360 112q-6 0-4 5 0 6 6 5 1-1 1-4zm-242-52c-4-5-7 2-10 1 3 1 7 5 10-1m-302-67-8-2 2 5q4 2 6-3m252 60q6 2 11 0v-1zm-146-44 1-3h-2zm-1-78 1 1 1-3h-2zm188 141h3v-2zm-186-118h-2l1 1z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "M595 1788q-5 1-4-4-1-3-6-6c-7-4-8-16 0-21q9-7 20-6l18-1q4-1 6-4l6-3h4q9-3 10 5 1 2 4 3l12-1q7-1 8 6l3 4 5 3 4 1 2-3 1-4q2-9-7-8h-2q-11 2-4-7v-5q-3-4 2-4l4-1 6-5-5-2q-5-1-9 1c-3 3-10 6-13 3q-3-1-3-4 0-5-5-5h-22l-17 4q-7 4-6 13l-2 5h-9l-1-2 3-2q4 0 4-5l-1-14-3-6-3-3-8-1-11-1h-24q-8-1-13-4-10-6-19-1-6 2-8-4-2-4-7-6l-12-1-4-1q-5-6-14-8-6-5-14-6-13 0-23-9l-5-2-16-1-5-5q-4-3-6-7 1-5 6-3 5 0 5-6c0-5-4-3-6-3l-8-1-9-2-9-1v-2l3-5-11-6-11-1-5-1h-4l-2-6 3-3 4-8q3-4-1-6v-2q9 3 5 10v9h6q9-3 15 5 3 7 11 7 5 0 7 5 1 4 5 4h18l-1 5q-3 5 2 6l6 1q5-3 9 1l-1 2q-5 6 2 7l3 3q7 12 18 7 7-3 10 5l3 3 13 8 7 1q5-2 9 3c3 5 15 8 20 5q11-7 19 1l15 7 3 1 9 2h34q8-3 17 2l3 5 4 4h37q11-5 19 4l7 7q5 1 5 7l3 4q8 2 8 11 0 6 5 6v11l-3 2-12 2-7 2q-7 0-13-5h-5l-1 1 6 2q-16 3-29 2-6-3-4-9l-1-4q-3-3-5 2l-2 3q-12 1-24-1-6-2-5 4t-5 5l-6-4-4-6q-2 10-11 10l7 6q5 1 4 6zm71-22q5 5 6-3-5-3-6 3"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2525",
    d: "m417 1665 16 1 5 2q10 9 23 9 8 1 14 6 9 2 14 8l4 1 12 1q5 1 7 6 2 6 8 4 9-6 19 1 5 4 13 4h24l11 1 8 1 3 3q-4 4 0 8 4 6-3 6l-13 3c-6-2-12-5-18-1l-13-2h-3q-7 2-10-4-2-5-9-5h-12q-4 0-4-5 0-9-10-11l-34 1q-7 1-6-6 0-15-14-16l-3-1c-5-6-12-5-19-5q-4 1-7-3l-5-4-5-3zm155 51c-4-4-9-2-13-2q-5 0-5 4 0 5 5 5 9 0 13-7m-96-21zl2-1-1-1z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "m361 1622 5 1 11 1 11 6-3 5-7-1-8 1q-5-3-8 2-2 8 4 12l7 4-1 8q-2 4-5 4h-18q-3-1-4-4v-7l-3-9q-4-4 1-5l9-2q6 1 10-4l2-2q7-1 1-6z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "m415 1739 1-21c0-6 7-9 13-6l15 3q2 0 3 3 1 9 10 10l4 3 2 3-3 2h-23q-3-1-5-3l-5-4q-6-3-6 3c0 3 2 7-4 8z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M417 1665h-8l-2-2-4-3q-2-7-8-6h-5l-2-1-3-16 9 1 9 2 8 1c2 0 6-2 6 3q0 6-5 6-5-1-6 3 2 4 6 7z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M564 1729c6-4 12-1 18 1l1 6-1 4q-5 6-5 14-2 5-8 5-7 0-9-8 0-4 4-5 9-2 1-8v-2l3-3-3-1z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2525",
    d: "m385 1637 3 16h-15l-7-4q-6-4-4-12 3-5 8-2l8-1 7 1z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2824",
    d: "m128 1950-10-5q-3-5 2-8 10-4 13-14 3-8-1-15-5-3-12-7l2-2q7-2 9-8l3-3 4-3 3-5 3 3-3 6-7 8-1 5 3 17q-1 9-6 14c-6 7-7 8-2 17"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m350 1720 4-6 5 2 1 9h-7c-1-1-5-1-3-5"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "m228 1823-8 14 3-10z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2525",
    d: "M390 1654h5q6-1 8 6z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "m355 1616 2 6q-7 2-5-6zM214 1847l-5 7zM207 1810l2 4h-2zM220 1839l-5 7z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m327 1724 1-4 2 1z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "m565 1732 3 1-3 3z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m309 1718 1-2 1 1z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "m230 1820-2 2zM235 1813l-2 2z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2525",
    d: "m407 1663 2 2z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "m350 1572 1 1 14 12q8 3 18 5l-1 2-17-2-8-5-6-6-4-7z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#211f23",
    d: "m365 1590 17 2q-1 14 10 12 7 0 14 4 3 1 4 4l5 6 12 7 12 11q4 5 10 2h5q3 5 5 7l16 3q5 1 10 3l11 4c12 3 23 10 36 10l3 2 13 5 29 8 17 5 7 2 24 8 2 1 21 5 20 6q13 2 28 5 14 4 26 10l2 1 4 10c-7 0-12-6-19-2l6 7 10 16-9 1q-5 0-5-6 1-9-8-11l-3-4q0-6-5-7l-7-7q-8-9-19-4h-37l-4-4-3-5q-8-5-17-2h-34l-9-2-3-1-15-7q-8-8-19-1c-5 3-17 0-20-5q-5-5-9-3l-7-1-13-8-3-3q-3-8-10-5-11 5-18-7l-3-3q-7-1-2-7l1-2q-4-4-9-1l-6-1q-6-1-2-6l1-5h-18q-4 0-5-4-2-5-7-5-8 0-11-7-6-8-15-5h-6v-9q4-7-5-10z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M361 1599q4 2 1 6l-4 8v-11z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M838 1905c4 0 7 3 10-1q3-5 0-11l-3-12 2-4h4l6 3 8 6 24 8 6-2h16l12-2q4-1 5-3t-1-6q-3-3 2-4l4-3q-1-8 6-12v-1h1q2-3 1-5l-4-12 1-4 5-1q2 2 3 6 4-3 2-5l-1-3q-1-7 3-12l1-6-2-10v-15l-5-8q-2-1-6 2l-3 1q-7 0-7 7-1 5-4 7l-11-2-6-2 2-3 5-4-6-4-1-1q-6-4-8 2-4 6-10 2-9-5-19-9-3-2-1-4l4-2q5-3 9-7 0-2-1-6l-1-5 5 4q4 3 7-1l8-11q2-6 8-6 6-1 8-6l6-8-2-20 6 1q2 7 8 7 4 0 7 2 4 4 10 3l1 1q0 4 4 5l6 4q6 3 1 10c-3 6-9 11-4 19v5c1 10 1 10-8 8l-5 2v5q2 4 6 4 6-2 5 5l-2 29 2 24-2 5q-6 0-4 7l2 17q0 4-4 4l-5 2q-3 2-5 1-4-1-4 4l1 5q4 9-6 8l-21 1-3 1q-5 4-10 0l-15-2-9-2q-7-2-7 5l-2 4-7 6-1 1c-3 1-15-2-17-6"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2b2c",
    d: "M922 1918q5 8 3 16-1 3-4 4l-13-2c-7-1-15 1-22-3h-19l1-9q1-2 3-5 3-6 9-3h3c8-6 17-5 26-5l3 1q4 6 10 6M980 1791h-16v-3h17zM960 1727l2 1z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m859 1674 8 6h1l9 11-5 1q-7 2-9-3z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m877 1691-9-11 15 10 12 7h-4l-7-3z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M894 1697zh2l2 1 3 2 3 4-4 1-1-1-3-3h-1z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m905 1704-3-4 8 1 1 4h-3zM899 1698l-2-1z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M908 1705h3l9 5 2 20-6 8q-2 5-8 6-5 0-8 6l-8 11q-3 4-7 1l-5-4 1 5q1 4 1 6-4 4-9 7l-4 2q-2 2 1 4 10 4 19 9 6 4 10-2 3-6 8-2l1 1 6 4-5 4-2 3-2 3q-9-1-8 7l-1 5-5-6q-1-4-5-4l-9-1q-7-2-5-10l-2-4-15-6-1 1-17 9-5-2-30-11-9-7q-6-8-9 0h-2l-15-3-3-2v-7q2-7-5-9l-6-4-9-8-4-9 11 11 18 11 4 3 2 1 7 5 8 1-3-7 7 2 12 1h3l3 2 11 2q4 6 10 3h3c9 4 17 11 27 6h3q5-1 3-6l-3-8c-1-3 3-12 6-12q6 0 13 3 6 6 11-2l6-7 7-10 1-3q5-4 5-10 2-6-3-8z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "M951 1723q-6 2-10-3-3-3-7-2-6 0-8-7z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "m385 1921 2-6q0-8 8-8 9 0 8-8v-2c7-7 5-18 14-24h1l11-17 4-5q0 4-2 9l-2 10-1 32c0 3-6 7-9 4q-6-3-10-1-6 3-9 11-1 4-5 4zm29-25-2-1v2z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "m829 1892-9-2q8-3 3-10l2-1 2 4z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "m433 1849-2-6 9 2z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2828",
    d: "m818 1890-5 1q1-4 5-1"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "M218 1951h-5l4-13q5-9 3-18-2-4-3-10 11 2 9-8l1-1q3-6 0-12-2-6 3-8l2-3 2-17q-1-6-6-5-6 0-5 5l2 6h-5l-9 9-8 13-8 16-14 28-2 4q-7 5-4 14-5 0-3-5 5-19 15-35l4-9 18-34 10-17 3-4q4-12 11-21l13-14h3l4 1c7-2 6 2 5 6l-5 36-3 6-3 9-3 8-1 5-4 13-4 10-6 21z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "#191411",
    d: "M175 1951q-2-8 4-14l2-4 14-28 8-16 8-13 9-9h5l-2-6q-1-5 5-5 5-1 6 5l-4 20q-5 2-3 8 3 6 0 12l-1 1q1 10-9 8 1 6 3 10 2 9-3 18l-4 13z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2525",
    d: "m760 1944-8 1v-5q2-2 5-3 5 1 3 7"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "m473 1946-20-1-3-4 4-4h22q4 1 4 6 0 4-4 3z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m374 1428 6 10q8 26 25 48l8 11 2 2 2 3v1l3 4v1l8 10 21 22 17 15 26 24-5-2-10-7q-9-9-20-15l-10-11-19-20-9-12-14-22-17-23-5-6h-1q-2 6-1 11 1 15 7 29c5 7 3 16 5 24 2 6-1 14 5 20q2 5-3 6-10-1-19 8c-6 5-6 15 1 19l6 1h6c4 2 10-1 12 6l-15-2-11-2-14-6-4-3-5-20q0-4 3-8l9-10q13-3 17-20 3-15-1-31l-4-18-6 5 3-21z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m347 1545-4 17c-5-2-1-6-1-9v-2l1-2v-2z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M342 1553c0 3-4 7 1 10v3q-10-5-1-13M347 1545l-4 2 3-4z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m350 1572-3-1-1-2v-2z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M346 1567v2l-3-3h2zM343 1549l-1 2z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "M383 1590q-10-2-18-5l-14-12 11 7 11 5 5 1 7 1 8 1-6 2z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M378 1585h-5l-3-4-9-6 14 6 11 2 15 2h2l4 5q-15-8-29-5"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "M345 1566h-2v-2z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M705 491h2l2 4-7 4q-2 9-11 11-7 4-1 7c5 3 4 7 5 11v3c2 5-1 18-6 21l-7 7q-5 6-9-1l-6-11q-7-8-3-16 6-12-7-16c-8-3-8-3-14 4l-2 4c-2 2-13 3-15 1l-9-7c-7-6-17-2-25-4l-2 2q-3 3-8 2l-5-2v-1l-5-8-5-6v-2l6 2 2 3q6 10 16 5h4l2 2 16 2q8 0 12 5 9 8 16-2 1-4 4-6l18-9 6-4h3q3 1 3 4-1 8-3 14-3 12-5 24 3 8 9 16h4l11-10 2-4q2-12-7-20l-4-5q-4-5 2-8l6-2 9-8q1-4 6-6"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "M567 498v2h-4q-6-2-12-1-3 3-4 8 0 4 5 4l10 4q3 2 3 6v15q3 12-8 14-4 0-5 4l-5 4q-7-4-14-4l-2-1-5-13 1-14q0-4-4-3l-19 3h-1l24-11q11-4 17-16 11-7 23-1m-33 32q-3 6 2 11c3 2 4 7 6 7q3 0 8-3 7-2 6-8-1-7 3-14 2-4-3-7-8-3-14 3z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m341 567 1-2 16-2q17 0 33-7l18-3q7-3 13-4 12-2 13-15 2-9 14-9l13 2h18l11-1-5 3h-3l-2 1-3 1-15-1-14-3q-12 1-13 13l-1 10-4 7q-3 7-11 3-5-3-12-4l-15 3q-16 6-33 6l-9 2h-10M544 499q-6 12-17 16l-24 11h-8l9-5 25-10q6-3 10-9z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M595 508h-4l-13-4-3-1-2-3 1-2h2l4 2 5 3 13 4z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M341 567h4v4l-9 1 2-5z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m338 567-2 5-4 2-3 2v-3l5-6z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "m486 529 5-3h4v3z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M195 815v-6q8 4 9 12l8 16q3 7-3 13-5 2-3 9l4 13 5 16 5 14 6 13q3 7 12 6c6-3 6-3 4-10v-24q-1-8 6-10-3-8-10-9l-3-4-1-7q-6-8 0-17 3-4 2-9-1-6 3-12 6-6 5-16v-13q1-10-1-21-3-9-2-17 0-6-1-12l1-20q1-7 9-7h10c4 0 10-5 10-9l-1-16q0-6 4-9l1-5c-4 0-8-3-12 0l-21 9 3-4 5-6 4-1 13-12c6-5 5-12 5-19v-7h1l4-2-2 11q-2 7 3 8 4 3 8 2 6-3 12-7 7-4 3-12l-5-10h3l6 7 3 6-2 8-4 5-14 10q-4 4 0 9l7 5-7 6-4 4c1 7-4 15 3 21l1 3 1 4 2-4 3-2 4 1q0 7-2 13-5 10-15 7-8-1-8 6-2 6-8 3l3-7q6-9-5-11h-4q-7-6-9 1l-5 4 2 6 8 13q4 3 1 7-3 2-3 6v13q0 11-1 23v26l-3 4c-3 3-8 5-6 10q1 7 3 13l8 10 1 4q-2 9 7 9l5 5c-3 6 3 13-2 20l-4 5-3 2-2 14 1 7v10l-6 7 2 10q1 7-3 13-3 4-3 8l-1 10 1 14q3 6 3 13l-1 14-1 4-2 5-4 15-3 3-3 5c12 1 7 10 10 15l5-2 6 10q3 5 8 1l1-2q8 2 11 4 9 9 20 16l25 12 6 6 2 8q1 6 7 6l2-1 5 3-4 4h-5l-7-1-4-1 1-5q6-9-5-11-5 0-9-3-5-4-10 0-6 5-11-2-5-6-10 0-4 5-11 8l-3-12-3-3-15-6-5-3-1-3q-2-12-12-16l-1-4c-1-5 4-8 5-12l1-4-13-12q-3-5-7-2l-2-1-5-11v-4l2-7-1-9v-3l-1-15v-8l1-2v-2q5-8 3-17v-21l2-4 3-4q2-1 4 2l4 4q3 6 8 2 7-5 2-10l-6-6q-8-5-8-13-4-7-9-12l-1-4 1-6-2-8v-1q1-8-6-8v-1l-1-12q2-5-2-5v-4l1-4 8-4-4-6v-2l-1-3-1-2-2-3c-2-4-1-9-6-10m37 211q12-10 8-25c-3-9 1-18-1-28q0-16-13-27-3-3-6-3l-5 8 1 13-2 15-3 16q0 4 4 6c5 2 2 3 1 6q-4 3-4 6l2 17 4 2q8 2 14-6m49 67c2-4 0-11-4-10q-5 1-10 5c-2 2 3 13 4 14z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M195 809v3c-3-3-4-11 0-14q6-5 4-12l1-7 3-26 3-6v-12l-2-8v-9q0-14 14-18 4-2 7-7l8-10h2l-13 25q-9-7-11-1-4 6-5 11-1 11 4 20v6q-4 8-6 17l-1 15 1 9c3 9 3 8-5 13l-4 6v5M211 898q5 5 9 12 0 8 8 13l6 6q5 5-2 10-5 3-8-2l-4-4q-2-2-4-2l-3 4-2 4-1-3 1-4q0-5 5-9l1-4c-1-5 0-12-5-17z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "M211 707q2-6 11 1l13-25 1-3 5-3 8-4-5 6-3 4c-5 4-11 8-9 14q2 10-4 15-6 6-11-1-1-4-6-4"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m249 673-8 4 5-9 4-3 4-5 1-1q10-3 8-13l2-3 2-3v-5l4-2v8l-3 6q0 7-4 10l-13 12zM195 815c5 1 4 6 6 10l2 3 2 5v2l-6 7q3-9 0-17zM209 879v1l-1 5c-1 3-4 8 2 9l1 4q-9-3-7-14l1-8q3 1 4 3"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m199 842 6-7 4 6-8 4-2-1z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M263 646q2 10-8 13l4-11z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m202 858 1 12-3-5v-8z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m209 879-4-4-2-4q7 0 6 8"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m199 844 2 1-1 4z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m202 858-2-1v-4q4 0 2 5"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m254 660-4 5z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m251 655 2-1-3 6z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m250 665-4 3zM236 680l-1 3h-2z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M257 649v-3l2-1v3zM217 697l2-2zM313 599v5q-8 7-3 19l1 3-1 1-4-2-4-6q-4-6-11-5v-2l4-1 1 1q8 5 12-8l1-2 2-2 1-1z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M308 604q-4 13-12 7 7 1 7-5z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M303 606q0 6-7 5h-1z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M313 596h3l-3 3v-3"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M313 596z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M312 599z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M312 598z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m304 631-6-7-3-7 5 4 8 9q5 3 5-3v-3q-3-10 0-20h2l-1 13 1 2v6q2 10-7 7h-2z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m295 617 3 7h-3q-1-5-6-4-9 3-13 12l-4 2v-1q5-15 23-16"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M272 633zh-1zM267 640l-2 3z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M315 625v-6l-1-2 1-13q8-10 12-24v7l5 6q-5 2-3 6l5 8 5 4 2-4 1-3 1 5q1 6-5 7-5-1-5-6-3-6-7-9-5-5-7 3v2l-3 7q5 8 3 16z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M327 585v-5l2-4 3-2z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "M705 1620h2l7-5q2-6 8-3 3 2 8 1 5-3 12-1l9-1c10-1 19-10 31-3q0-7 7-9l8-2 19-9 6-3q7 0 6-8v-2q4-4 8 1l3 1q4-2 6-5l1-2 13-15v-2l1-3q6-4 8-9l11-22 1-2c5-1 4-6 5-10l1-11 1-1h1v3q-3 6 2 7 2 0 6-5v-1l4-4-7 16-5 9-9 20-15 26a191 191 0 0 1-34 33l-17 11-5 4-7 3c-4-7-13-6-17 0h-2l-8 1-33 5-8-1-9-1q-11 4-24 2-10-1-20 3-12 3-24 1c-6 1-13-1-18 2q-12 7-25 3l-5 1 13 11-18-7-10-4q-8-6-18-9l-14-8-18-11-7-11c-5-6-5-6 1-10h1l8-1 14 5h2c3 8 4 8 12 4q6-3 7 4l4 8 2 7q0 6 5 3 9-4 16 2l2 1 8 1q9 4 13-5l3-7q8 8 15 3l6 2q4 2 8 3 6 0 7 5l2 3 3-2 2-3q2-6 6-2l4 3z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "m900 1495-4 4v1q-4 5-6 5-5-1-2-7v-3l10-14 3-6 7-13 7-18 16-33 2-9 12-29v-3l4-5 4-12 6 2-1 3-4 9-5 18-2 7-4 11-6 15-6 15-15 37-5 7-3 5-1 1-2 4-1 3z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m803 1623-2 2q-11 1-20 3-13 4-25 9l-28 9q-21 8-45 8h-34l-22-3-8-1-2-1v-2h2q19 3 37 4 21 1 41-1 14 0 26-6 10-3 20-5 10-3 18-8h2q18-8 38-9z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "M763 1631h-2l-7 1-7 3 5-6 11-3c7-3 14-3 19-9h19v2l-20 3-15 5z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m763 1631 3-4 15-5 20-3v3q-20 1-38 9"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M959 1358v-3l1-1 1-9v-8h3l-3 22z"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m954 1367 4-9z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "m908 1482 3-5zM900 1494l4-4zM905 1487l2-4z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m922 1463-3 5zM889 1531l-2 1 3-5zM867 1568l-2 3zM929 1449l-2 3z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m816 1615-2 2z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m619 1650 8 1 22 3h34q24 0 45-8l28-9q12-5 25-9 9-2 20-3l2 7-4 7v-5q0-5-5-5-21 0-37 11-6 3-10 6l-18 4-12 4-56 3-4 2h-3l-9-3q-14 2-26-6"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m799 1639 4-7 4-1-2 5-7 17-3 6v2l-8 20-5 11-7 22q-5 10-2 20l2 9v2h-2q-7-15-2-30l11-30 1-5 2-2 5-14 7-18z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "M809 1759h-3c-3-5-7-2-11-3v-5c7 5 14 2 21 0l15-4 6-3-6-3q-9-1-7-9v-4l-12-15-4-7q2-8 0-16l-1-5c-3-6-9-5-14-5l2-14 5-4 10 2 21 1 1 1 16 11 7 3-4-12 7 5 1 1 4 15q2 4 9 3l5-1 7 3 8 6c7 5 7 13 10 19v3l-9 12-4 4q-3-5-7-7-5-4-10-4-7 2-13 6l-6 2q-1-5-3-8l-27-20h-5l1 5 10 11q11 10 24 12c3 9 8 17 0 26-3 3-3 5-8 3q-7-5-16-1h-2l-15-5z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "m851 1668 4 12-7-3-16-11-1-1-21-1-10-2q-1-15 9-22l15 6q8 11 19 16h3l1 1v2l2 2z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "M809 1640q-10 7-9 22l-5 4v-7l3-6 7-17h4z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "M843 1662q-11-5-19-16l19 13zM809 1640v-4l12 6 3 4z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M847 1665v-2q8 1 11 10l-7-5-2-1zM843 1662v-3l3 3z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M961 1194v18l1 7-2 30v26l-1 19-3 12-2 18q-1 3-3 5v-9l4-43v-12l1-30-5-38v-2l-8-30v-6l-4-18-3-20q-1-7-7-6v-9q2-8-6-8v-4q6 2 5-3l-2-5q2 0 5 3c4-2 6-9 12-7l-2 11 1 23 3 35 1 6 5 29 5 20h2l1-5z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M951 1329q2-2 3-5l2-18 3-12 1-19v-26l2-30-1-7v-14l3 10 4 45q-1 18-3 35l-1 29q-6 1-7 6l-6 20zM961 1194zl-3-22-2-9q-5-22-5-44l1-16 3-1h1v9l-2 19 3 24 6 35z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m951 1343 6-20q0-5 7-6v19l-3 1-2-3-2 2-6 16-6 14-2 1 4-12v-4l4-6z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "m957 1100 1-2z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m985 1039-6 11q-2 3-5-1l3-3 2-3v-2l1-2 1-8 1-4 2 6zM990 1009l8-4v3l-1 1q-14 3-15 16h-2v-3l1-3v-4z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M982 1025q2-13 15-16l-3 3c-9 5-10 7-9 17l-1 4-2-6z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m998 1004 2-5 1-5q-1-3-1-5l8-10 11-9 8-6 24-17v2l-2 3-10 9-3 2h-1l-16 12-2 2-2 2h-1q-11 4-12 13l-1 11v1z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1001 1003 1-11q1-9 12-13l-2 2c-4 4-9 7-7 14zM1017 977l2-2zM1015 979l2-2zM1036 963l3-2-1 2zM1051 949v-2l1-2h3v3z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "M960 1063v2l-1 1-1 14-4 2-4-27-2-13-1-5v-6l1-4v-29l-1-13 2 3 2 14c1 11 5 22-1 32v7l2 12 2 4v4l5-1z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m954 1101-3 2-1-7-2-31 2 4 3 18 3 3z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m956 1090-3-3-3-18-2-4-1-8v-11l1-4 2 13 4 27 4-2v5l-2 2z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m960 1063-1-3c3-13 4-14 14-14v3c-7-2-7-2-9 5z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M966 1060q1 5-3 7 0-3 3-7"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M973 1049v-3h4l-3 3z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m956 1087 2-2z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m959 1066 1-1zM1057 939l3-5 7-7v4l-2 2v1z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1073 913h2l-4 10v-3l2-5zM1057 939l8-5-8 8z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M1071 920v5l-4 1v-4zM1057 940v3l-2 2h-3z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m1067 927 4-2-3 5zM1055 945l2-2v2zM1065 933l2-2z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M1055 945h2l-2 2z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M866 601q6 8 5 17v11l2 5h8q11-9 24-14 4-2 6-5l4-1v2l-2 3-3 1-3 3-4 1q-4 1-7 3l-17 11q-5 2-10 1-5-2-4-7 4-12 0-25z"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M929 608h22l2 1h2l4 2v3q-11-4-21-4l-9 1z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M955 609h-2l-2-1h-3v-3l15 5h-4z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m947 605 1 3h-11v-3zM929 608v3h-2l-7 3h-2v-3l4-1 2-2z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M937 605v3h-4z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "M918 611v3h-2z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M916 614zl-2 2z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m924 608-2 2z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M981 657v5l-4 4-9 5q-7 5-7 12l-1 8c-1 7 4 13 5 19l7-5-1 13c-1 7 5 5 8 8q-1 7 4 13l2 5q2 8 10 6l9 1-1 4 1 2 4 2q2 5 5 4l2 1 4 5v3q-4-1-6-3-6-5-15-3-13 2-6 15 5 7 14 10 7 5 13-1l3 6h-4q-5 4-12 0l-2-1-5-4-9-2-13-4-4-3q-4-11-1-23v-5c-5-3-5-10-12-12l-1-1-2-12c-1-8 0-16-6-23v-5q2-7 6-14v-5q-2-9 3-15l9-9 3-4-1-1c-7 5-7 5-12-2l-1-2q-7-6 0-12l1-3v-5l-5-1-9-1-3-4-1-1-5-3q6-3 9 2 3 3 6 4l9-5q0-2-1-6l5 2 11 9c6 4 10 14 7 19q-3 7-1 13"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "M982 657q-4-6 0-13c3-5-1-15-7-19l-11-9-5-2v-4h4l6 7 9 8q10 8 7 22zM977 666l3-4 1 1v2l-2 13-1 9h-2zM979 726c-3-3-9-1-8-8l1-13 4-14h3l-4 11-2 11q-1 12 11 8h2l3 2c-2 1-6-2-7 3z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M986 721h-2l-6-4c0-5-4-11 1-16 0 5 3 15 7 18z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M979 691h-3v-4h2z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m296 1129-2-1-3-1-18-4h5q15 1 30 7l27 11 16 4 7 10 2 6v2h-1q-3-7-7-12c-5-7-13-7-21-9h-2l-16-7-4-1-4-1-6-2-1-1z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m205 1041-1-2h5q15 8 14 24l2 4v1q-1 6 4 7v1l2 5 7 11q-10-8-15-20l-3-13q-3-13-15-18"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m244 1099-2-2v-2h5q12 11 19 23l2 1 1 2h-5l-3-2-2-4-4-2-1-3z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "M244 1099"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m265 1121 8 2-1 1-5-1z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m265 1121 2 2c-3 0-7 1-8-5l2 1zM255 1113l4 2v3zM242 1095v2l-4-5z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m210 936 1 3v15h-3v-1z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m207 953 1 1v3l-3 2v-5z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m203 1036-4-3c0-4-5-7 0-9q4-4 3-9l-1-5v-22h2v24l1 4v3l-1 6q-4 4 0 7z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M201 990v20l1 5q1 5-3 9c-5 2 0 5 0 9q-8-5-2-12c3-4 1-9 2-14v-17z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M205 1039zl-1-3z"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M201 990h-4l4-11 2 1v5l-2 3z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M203 963v-2h2l-1 9h-3l1-4z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M201 970h3v7h-3z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m201 978 3-1h1v2l-2 1z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m203 963-1 2-1-2zM205 961h-2l1-3 1 1z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M340 1295h-4q-1-5-5-4h-1l-9-10-8-10 6 3h7l1-7q-4-14-15-25-7-4-10-12c-2-5 2-19 7-21l18-4-12 6c-7 4-13 14-6 23l10 11q7 8 12-1l4-3-2 4v5l5 1 3-2q8-2 8 6v4c-2 4 2 7 4 9l2 2c-9-2-9-2-8-11l-1-7h-2l-9 11q-3 6-1 13 0 6 6 7c10 3 10 3 6 11v1z"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M308 1151h2l5 5 2 2v2c-5 1-2 3-2 5l6 12q-5-4-7-9-5-14-20-20-3-1-6 2l-7 11-4 8q-3 7-3 13 2 4 6 8l7 11q-6-4-10 1-2 3-7 3-4-1-2-6l3-17v-5l5-15 2-3v-1l3-4 2-6 9-4-8-5-11-1 2-2h9l21 12zm-14-7q1 0 0 0"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m267 1144 1-1 10-2q4 0 2 5-10 16-16 34-3 8-3 18v5h-2l-3-5 2-21 1-10v-3l2-5z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M271 1177v5l-3 17q-2 5 2 6 5 0 7-3 4-5 10-1v3h-1l-6 2c-3 4-2 12 0 16l4 8 2 3 3-4v1l2 2v4l-3 1c-4 7-6 2-9-1q-9-6-8-18l-2-7q-3-6-4-12z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M330 1291zl3 4q-9-1-16-8-6-5-9-12-5-11-12-23-4-6-5-14l1 2 2 2 1 2 1 3 2 2h1v3l3 4 2 5 4 7q4 9 9 15 5 5 12 8M340 1296l6-1h5l-2 4-1 3-3 3h-2l4-7z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m284 1139 8 5-9 4z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m293 1240-1-2v-3l-1-1v-4l1-1 5 12v2l-1 1-1-2z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m334 1295-3-4q4-1 5 3z"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m281 1154-3 4zM278 1159l-2 3z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M292 1235zh-1z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m266 1144-7 20q0-11 7-20"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "m281 1135-6 1-2-1zM317 1158l-2-2v-3l11 5q7 2 4-3l-5-11 2-1 2 1q5 5 11 3h2q1 5 4 7 10 9 10 22l3 7v2l1 5-1 5v15q1 8-6 4l-10-25-13-22q-6-5-13-9M305 1148l-21-12 9 1 14 11z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m327 1143-2 1-12-6v-1z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m299 1131 6 2z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M315 1153v3l-5-5z"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M313 1137zl-4-3h4z"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M305 1148h2l1 3z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m296 1129 2 1-1 1zM291 1127l3 1z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "M1051 760q2 4 3 8l4 17q-1 3-3 4l-3-3-1-3-8-17 11 10q-1-10-9-18l-6-6-13-10-21-11-14-5v-2l15 4 5 2 5 4q12 4 22 13l13 12z"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M991 724v2h-9c1-5 5-2 8-3z"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M1007 796q6 4 11 0h9l-1 1-7 3q-7 1-3 7l9 8h8l5 2 1-1-3-4 2-2 4 5 3 5v3c-4 2-7 5-9-1q-2-3-5-3-8 2-13-4-2-4-8-5-12-1-25-5l-3-2q-3-4-8-1l-7 3-8 3q-4 5-4 12-1 9-9 7l-22-4q-7 0-5-6 3-7-3-10l-3-4 12-6c3-1 6-8 5-11q-2-5-8-5-4 0-8-2-5-4-11-3-5 0-5-4l-1-22 9 1q7 3 8-3l1-8v-6l5 2q4 1 6 1 2-1 3-5 0-5 5-5 17-2 12-18c-4-8 4-19 11-22q-4 7-6 14v5c6 7 5 15 6 23l2 12 1 1c7 2 7 9 12 12v5q-3 11 1 23l4 3 13 4 9 2 5 4h-2q-5-2-7 2 0 3 2 6 5 6 9 2 2-3 1-9"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "M1045 821v-1l-3-5-4-5-1-2v-2l1-7h7v1q1 7 6 5l2-1h4l1 13-1 10v3l6 11 3 4v2l1 9c1 4-2 9 4 10v3l-11-5-11-9-2-2c-1-8-7-17 0-25q4-4-2-7"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "M1027 796h-5l-3-6q-6 6-13 1-9-3-14-10-7-13 6-15 9-2 15 3 2 2 6 3l1 1v4l1 6 4 3h2l4 4-1 5z"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m1051 783 1 3 1 9-9-1-2-1-8-5-1-5 16 9v-6q-6-15-18-25-2-2-5-1l-2 5 5 11 3 6-19-28 3-2q11-1 18 8l15 21z"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m1051 783-2-2-15-21q-7-8-18-8l-3 2 1 4 10 13 8 11 1 1 1 5h-1l-1-1-1-1-11-13-1-1v-3l-4-5-2-1-5-4 1-10 2 1 3-1h11v1l13 8 5 8z"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "m1019 800 7-2q8 1 9 7v4l-5 3q-8 0-11-7v-5m9 9q6 1 4-5-3-2-7-3l-4 2 4 6z"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M1071 869v-3l-4-10-1-9 2 4z"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m1058 817-1-13 1-1 3 14zM1045 800zl11-1 2 2-5 4-2 1z"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M1058 817h3v8l-4 2z"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m1057 827 4-2 1 11-5-6z"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m1057 830 5 6 1 3v2z"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M1043 799h-5l-1-4 1-1z"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m1034 788 8 5q-5 1-8-5"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M1032 787zv6l-3 1 1-5z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m1044 794 9 1q-4 5-9-1M1053 795l-1-9 3 4z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m1053 804 5-4v3l-1 1z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M1063 841v-2l3 6zM1035 809v-3h2v2z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M345 571v-3l6-1v1q5 2 8 2 11-1 14 8l4 5q11 3 16 13 3 5 8 2c3-2 2-10-2-13l-7-8q-4-9 1-14 6-2 12-1l14 5q14 6 16-9l1-3 3-13q0-13 13-11c6 0 12 5 18 3q-3 3-5 3l-16-2q-4-2-4 3l-1 10q-4 12 5 21 4 3-1 5l-5 3q-6 5-10 0-9-5-14 2-4 4-9 3-6-2-4 4l6 10q3 6-1 10l-6 3q-14-2-12 11 0 6 4 7 8 1 9-6l2-4 6-3 3 4 3 3q7-1 10-4 6-5 11-4c4 0 9-2 9 4l2 2q11 4 11-7 0-6 4-7 6-1 10 4l6 7 2-7 1-5q3-9 11-5 6 4 10 0 8-6 14 2l8 9 5 2q9 0 8-10l1-3v2l8-2q5-2 5 3l-1 5q-2 5 3 5h13q7 1 6-6 0-6-6-5l-4-3q0-2 2-5 2-2 3-5v-7q1-6 8-4l7 2q3 1 5 1 5-1 7-6v-20q2-5 0-10l-2-8c-2-5-2-11-10-12q-8 0-10-9l5 2q5 1 8-2l2-2c8 2 18-2 25 4l9 7c2 2 13 1 15-1l2-4c6-7 6-7 14-4q12 4 7 16-4 8 3 16l6 11q4 7 9 1l7-7c5-3 8-16 6-21v-3c-1-4 0-8-5-11q-5-4 1-7 8-2 11-11l7-4h5l5 7 3 5v9l2 8h5l-3 6-5-4-3-10q2-8-4-14-2-3-6-4l-3 5c-3 4-9 7-8 14l2 16-2 10q-1 10-9 16l-5 5q-6 7-11 1l-3-3q-5-2-6-7l-1-5-2-17q-1-7-5-13h-5q-4 2-6 6t-8 3q-12-1-10 11v6l4 21 2 12q0 8 11 8c5 0 2-4 3-7l2-1 3 5q0 6 5 3l8-6 5 2q9 1 8 10-1 8 3 15c2 4 2 9 9 9l1 6 3 4 2-4v-6q0-8 3-15 5-5 5-14l3-4 7 2v4l5 12q0 6 5 4c6 0 12-2 17 4q6 4 9-3l2-6 4-4 8-5h1l10-3q5-1 6 4l1 5q1 7 6 11c7 4 14 2 21 3l18 1c4 0 8 2 11-3l4-10 5-5q6 0 8 6c-3 1-7-3-9 1q-4 10 6 12 7 2 6 9l-4 15-3 3q-11-5-20-12-6-5-12-2c-9 3-18-1-27-3l-7-2q-4-3-6-7 0-8 1-15l-5-6c-2-1-7-3-8 2l-3 1q-4 1-6 3l-2 4v4l-2 1-2 3-1 2-7 11q-2 4-7 5-15 3-23 16l-9 15-3 1-4 5q-3 8-9 14c-9 5-10 15-11 24q2 13 11 22 6 3 2 9t1 10l9 10 2 4-4 2h-2l-3-1h-8c-3-2-6-6-8 0h-2l-3-2c1-7 6-6 10-6q8 1 5-8-2-1-3-4-2-2-1-5 2-4-2-8-6-6-10-15-2-13-15-11l-33 4-12 3h-4q-17-5-34-4l-3-1-11-2-10 1-14-1q-5-1-6 5-2 3-5 3t-5 3l-4 8h-3q-4-5-6-10-3-7-10-6h-33q-10 0-13 8l2 7q-2 5-6 8-5 2-11 1v2l7 1 5 3-4 5-8-1q-8-5-14 0l-7 4q-9-1-18 4c-3 2-9 4-10 7q-2 8-2 16c1 2 1 7 5 7q7 1 3 6l-3 6q-3 9-2 19 6 15 9 29l-4-9-8-27q-2-11-3-23l-2-5q-2-6-2-11 4-6-1-10l-1-2-2-34 1-14-1-31q0-18 6-34 2-4-1-9t-2-9q2-7 8-6l3-4-2-3-8 1q-8 6-16 10h-11l-2-6-2-2-3-7-4-5v-3l8 8c4 5 5 5 11 1l2-1q4 0 4-4 1-5 1-8c-3-3-1-7-2-11l-3-4zm276-42-2-7q-5-7-15-3-5 3-1 11l2 6q1 9 10 11c2 1 7-2 7-4q1-6-1-14"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m722 507-3-5-3-7 5 4q2 9 11 8l6 2q20 9 43 9l11 2-8 1q-8 3-5 10l-1 14v8l1 6c-3 10-16 18-26 16v-1l-2-7v-3l4-9 6-8 6-10h3q1 7-4 10l-5 6q-5 6-5 13 2 6 6 4 9-3 13-11v-5q-2-5 0-11l1-8-6 2-1-5v-2q3-3 2-6l-5-3h-4q-9-3-18-4-4-1-7-3l-10-5z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M705 491q-4 2-6 6l-9 8-6 2q-6 3-2 8l4 5q9 8 7 20l-2 4-11 10h-4q-6-8-9-16 2-12 5-24 2-6 3-14 0-3-3-4c2-4 4-1 6-1q2 2 4 6c2-5 10-1 12-9zm-16 47q1-10-6-17l-6-3-2 5-3 8q-3 9 3 17h3zM595 508l3-1h3l11 3q11 0 18 5 4 1 6-1 5-6 12-8l17-8 4-2-6 4-18 9q-3 2-4 6-7 10-16 2-4-5-12-5l-16-2z"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b746e",
    d: "M601 507h-3l-18-7h2q13 5 25 5l3 2z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M779 531q-3-7 5-10l9-1h2v3h-4q-9-2-11 7z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M795 523v-3l11 4 1 2h-4l-5-1z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m716 495 3 7-5-7z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M713 495h-4l-2-4z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m857 583 4 10h-3l-10-16q-4-2-7-2-8 3-11-3-4-7-11-6-3-1-5-4-6-3-9 2-2 6-6 7-3 1-6-1-4-6-3-16c1-7 1-8 9-6h2l9 8 1-6 1-3h1l2-2v-6l-4-5v-3l4-1v1l1 3 3 5-3 10c-1 3-4 6 0 8q6 2 8-3l2-3 6 5v5q-3 12 8 10l4-1h1l2 2z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m819 539-3-5q4 0 3 5"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "M811 531v3l-8-8h2z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "m913 803 3 4q6 3 3 10-2 6 5 6l22 4q8 2 9-7 0-7 4-12l8-3 7-3q5-3 8 1l3 2q13 4 25 5 6 1 8 5 5 6 13 4 3 0 5 3c2 6 5 3 9 1q-1 8-9 6-4-4-9 0-7 6 0 10 9 5 13 14 3 9 14 10l2 2 3 6-6-1q-5-1-5 5 2 7-1 14-1 2 1 7l5 19q3 7-3 12l-1 4q-2 6-9 5l-4 3q-2 4-7 4-7 2-15-1l-4-3-9-11-1-2q1-9-2-16 1-7-5-9l-3-4v-7l6 1 6-2v-8l-2-5q3-6-4-5h-3q-8-2-7 6 2 8-7 7-7 0-7 7l-1 5q-4-13-14-21l-3-1q-3 1-5-2l-8-15-11-11-9-7q-10-10-22-19l-14-11q-9-10-22-13l-2-3q5-3 9-1l7 4 3 3 9 10 7 2 3-7-1-6q1-3 3-4l4 2 3 7zm127 117q11 3 8-7-2-12-17-10l-4 2q-1 2 1 4zm-99-85 4-2-2-1z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "#080708",
    d: "m954 1057-2-4-2-12v-7c6-10 2-21 1-32l-2-14-2-3v-2l1-7 2-1-2-1v-2l1-13-4-31 1-1 3 3q0 11 6 20 4 8 12 13l5 4 13 10 10 8 3 5v3l-1 6-3 4-3 4q-10 0-10 8v2c-6 3-3 8-4 12l-2 15c-6-4-10-1-14 1q-5 3-4 8 2 4-3 4"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m698 762 4-2-2-4-9-10q-5-4-1-10t-2-9q-9-10-11-22c1-9 2-19 11-24q6-6 9-14l4-5 3-1 9-15q8-13 23-16 5-1 7-5l7-11-1 10q0 5 7 5h4v2l-5 1q-5 1-9 4-3 4-7 3c-12-2-19 7-26 14q-11 12-20 26l-1 2q-8 6-8 15l-1 8c-2 3 1 12 4 13h2c11-2 11-2 11 9q-1 10 9 9l3 1q8 5 17 3l3 1 12 5q5 1 4 6l-3 7 1 5h10l8 5 18 3h3l3 2v4l-21-2c-8-1-17 1-25-5l-2-1-12-3-9-2z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m788 773-3-2 6-3 10 1c4 2 7 5 10 0h6l8 4 17 9 10 4 9 7 2 3q13 3 22 13l14 11q13 9 22 19l9 7 11 11 8 15q2 2 5 2l3 1q10 8 14 21l1-5q0-7 7-7 9 1 7-7-1-8 7-6h3q7-1 4 5l2 5v8l-6 2-6-1v7l-3-4-5-5q-4-3-5 3c0 6-6 7-9 11l-6-3 2-3c1-7 3-11-8-11l-4-2v-1l3-1 2-2-3-2-6-2-5-2q-8-2-9-9-2-5-7-8l-6-8-3-3q-11-10-20-21-7-7-13-10l-17-8-12-10-4-3c-7 0-11-5-16-7l-19-7-8-2z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "m998 990-3-5-10-8-13-10-5-4q-7-5-12-13-6-9-6-20l-3-3-1 1 4 31-1 12-6-29-6-20-4-16-6-14-2-6q3-4 5 0l4 2q6 1 8 8 1 3 3 5 13 16 14 37-1 5 2 10 2 3 8 2l1 1 13 15 6 7c3 4 11 4 10 12z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m698 762 21 2 9 2 12 3 2 1c8 6 17 4 25 5l21 2h3l9 2 33 13 17 10 5 4 22 20 4 7-9-6h-1l-1-1-2-3-2-3q-18-20-43-29-18-7-38-11h-14l-5-1-9-1-29-7-24-4h-36l-7-1-19-2-9 2h-5l-6 1h-11l-22 4h-2l-10 4h-3l-3 2-2-1-3-1-15 5-13 7h-1l-8 4h-2l-5 2-24 11 2-3 22-11c14-6 28-14 44-16l30-7 22-4q20-3 41-1 8 2 16-1h18l3 1z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "M998 985c1-8-7-8-10-12l-6-7-14-16q-5 1-8-2-3-5-2-10-1-21-14-37-2-2-3-5-2-7-8-8l-4-2q-2-4-5 0l-3-5c1-9-7-13-10-19q-6-10-16-18l-6-5-1-1-7-12 11 3q4 2 6 6 2 6 8 11 7 7 13 15l1 4q1 5 6 9 5 5 13 9 3 1 4 7l10 16 5 12q3 14 13 23l2 4q0 6 5 9 5 4 7 9 4 8 12 12 8 3 1 10"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "m881 826 7 11-7-4-4-7-22-20-5-4q4-3 7 2l5 4q5 5 12 8l6 2z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M981 1015q0-8 10-8l-1 2z"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m800 779-9-2z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "m997 999 1-6zM994 1003l3-4z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m1071 920-4 2 7-14-1 5v2z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m847 572-2-2h2zM844 570l-4 1q-11 2-8-10l2 4q3 5 7 2h3z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M841 567q-4 3-7-2l-2-4v-3l3 1q1 6 6 8"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m371 1388-3-3v-2l-1-21v-6l-1-11v-8l-1-8v-2l4-3 7 3q5 0 3 6l1 12h2l3-7 4-5q2 0 6 3l7 5q7 0 7 8l2 8 3-1h1v2l1 19 5 27q1 5 5 2l5-6 1 8c0 4 5 10 6 9q5-3 11 2v-10l4-8q1-7 7-4l5 2 2 10-1 4h5q4-2 6 2l2 5 3 11q6 8 7 17l1 1 4-2-4 21 2 22 2 5 3-5 1-7 3-7 4-2v3l-3 7-1 15q-1 13 8 12c6 2 4 9 8 13l-6 3q-8-3-10 5l-3 1-9-10q0-3 1-7v-4l-6-1h-5l-2-7 2-5c0-5 1-11-5-14q-4-3-5-9l-2-6q-4-5 1-9c6 5 3 12 4 17l2 1 8-20v-3q-3-5-2-11l-5-8h-3v3l3 10q-4 4-9 7l-3-7-1-12q-7 5-10 0l-2-2-3 1c-1 6-12 3-10 11l1 4-3 3-2-3q-2-1-3-4c-1-6-7-12-7-18q-1-8-7-10-2-2-3-5v-8l-2-1c-8 3-8 2-12-4q-6-6-13-11l-7-7-4-5-4 6z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m705 1620-18-2-4-3q-4-3-6 2l-2 3-3 2-2-3q-1-5-7-5-4-1-8-3l-6-2q-7 4-15-3l-3 7q-4 9-13 5l-8-1-2-1q-7-6-16-2-5 3-5-3l-2-7-4-8q-1-7-7-4c-8 4-9 4-12-4h-2l-14-5-8 1h-1c-6 4-6 4-1 10l7 11-13-11q-15-7-24-22l-3-3-16-12q0-4 4-2h8v-4l-15-10h-1l-5-3 2-10 5 6 5-2 2 3 1 3 13 7q6 1 7 7 1 3 4 5l4-4 2-6q3-7 8-6l3 7v8l2 5 4-8 3-3q4 2 4 5l1 12 4 5 3-4 8-5q6-1 9 5 3 3 7 5 7 0 6 6-2 9 7 8l7 1q-2-3-3-7l-1-7 4-3 3 3 4 7q2 7 7 3 7-4 9 2l8 8 10 5 2-6 1 2c0 7 6 7 11 8l4-3q5-4 7 1 4 5 9 5 8 0 15 6l5 2z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "m809 1588-6-4 2-4v-3h-3l-9 8-5 2q-5-2-5 3-1 4-3 4c-6-2-9 4-14 6q-8 4-12-3-3-4-7-1l-5 3q-8 5-8-4 0-5 3-10 3-7-5-11-6-1-7 5l-4 10h-2l-1-5-1-6q0-8-6-3-4 3-8 1-5-1-9 1t-7-2l-4-2-11 3q-4 1-2 6l3 4c5 4 3 10 5 15l-3 3q-4-1-5-3c-3-10-12-11-19-17l-5-5q-3-7-10-3-6 0-8 6h-3l-6-4q-4-4 0-6l1-5-2-1-5 9-3 5-3-2-1-5 1-3v-5l-3-7-5 3v-3q-1-5 3-6 3 1 5 5l5 5 3-2v-3q-5-6 0-12h5l1 8v3h4l2-3q4-5 9 0l5 1h4c6 5 9 5 3 12l-2 4c-1 7 5 7 9 11l4-17h5l5 2q4 1 6-3 14-4 14 7 2 6 6 3 6-5 11-2l5-1q6-7 7 2 1 4 4 2l14-6 7-4c3-3 13-5 17-4l6-1q6-5 11-1v14q2 11 12 6l3-2c7-1 7-1 4-8q-3-3 2-5c4-2 11 3 11 7v11h6z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M509 1511q-9 1-8-12l1-15 3-7v-3l1-2q14-9 9-25l1-8q4-6 3-14l4-17q4 4 6 4 6 2 5 8 1 6 5 2 3-1 5 2 3 3-1 7-8 8 0 14l2 3q1 6-2 11c-2 8-1 10 6 14l4 4-4 4-2 3-1 8q-1 6-7 1 4-6-2-7l-4-4-2-9q-2-6-6-5-5 1-3 6 3 12 2 23l4 8 10 4 5-4 3 5q3 4 6 0l6-9v-5c-4-6-2-13-3-19 5 1 10-2 11 5l-2 6 1 7 6-3 1-3 2-2v-1l3-2 5 1 1 7-12 4-3 4 4 5 5 1v16q1 8-6 6h-5q-6 3-12-1l-10-5-9-1q-6-1-6-7 0-5-4-5l-2-3q-3-6-7-2zm4-18-1-4-3 2zm-5 10 2 1 1-1z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M413 1490a97 97 0 0 1-23-37l-3-9q5-3 2-8-4-10 5-19l1-4 3-3 1 4q-2 10 7 15l3 6q0 6 5 9l14 10q5 4 5 10v11l2 5 3 3q6 9 2 16-4 5-15 1l-4-1z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m421 1499 4 1v1c6 3 7 9 11 13l6 7q5 5 11 9l5 4 15 13q5 2 9 8l5 2 16 12 3 3q9 15 24 22l13 11h1l2 2 15 9 14 8q10 3 18 9l10 4 18 7h2l21 4h58l7-3c7-3 12-8 20-7 5 0 10 2 13-3h5l7-3 7-1q-8 5-18 8-10 2-20 5-12 6-26 6-20 2-41 1-18-1-37-4l-2-2-8-1h-2l-4-3-2-2-12-3-2-1v-1l-6-3-8-4h-2l-2-3-5-1-18-12h-4l-1-1-2-1h-2v-1l1-1-3-3-4-3-10-8h-3v-1l-2-4-7-5-21-20h-2l-5-4-5-4-3-2-2-2-13-10-2-2-5-2h-1l-1-2v-1l-3-3-5-5-3-3-13-19-4-1-1-2z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "M525 1509q4 0 4 5 0 6 6 7l9 1 10 5q6 3 12 1h5q7 2 6-6v-16l-5-1-4-5 3-4 12-4 2 3v2l-3 2q-3 8 4 12 5 3 4 9l-2 8 1 9 1 4-7-4-3 11-1 5q-2 3 2 6l1 6-4 2-3-4 1-15q2-3-1-6l-2-3q2-6-4-7-5-2-8 4l-7 8-5-13q-1-5-6-3l-3 1q-6-5-11-2l-5-6z"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m809 1588 6-7 2-1q8 4 11-3 2 8-6 8l-6 3-19 9-8 2q-7 2-7 9c-12-7-21 2-31 3l-9 1q-7-2-12 1-5 1-8-1-5-3-8 3l-7 5 3-6q-1-7 6-8 6-1 7-7l4-10h1l3 8 7 8q5 2 9-4 3-4 6-1c5 8 11 4 16 1q8-3 16-6l6-3 2-1q9 3 16-3"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m590 1541-1-4-1-9 2-8q1-6-4-9-7-4-4-12l1 2 3 4h1q2 3 3 5l3 6 1 18q1 8 7 11l18-10-4 4q-6 3 0 6-5 6 0 12v3l-3 2-5-5q-2-4-5-5-4 1-3 6v7l-6-4v-10q2-6-2-9z"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "M591 1542q4 3 2 9v8q-6 0-7-5l2-6zM593 1561l6 4q-3 3-7 3c-4-2-1-4 1-7"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m476 1523 4-1v2z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M374 1397q-5-2-3-7zM386 1441l-3-5z"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m378 1425-4-6z"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m382 1431-3-4z"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m351 1145-16-4-27-11q-15-6-31-7v-2l-1-2 23 4 20 8q8 2 16 2 12 2 21 9c6 6 5 13 8 19 2 4-1 9 4 12l1 31-4-5v-5c4-6-1-12 0-18l-3-1-2-1 1-5 1-4-2-2v-2l-2-6q0-9-7-10"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m369 1324-4 3 6-33-1-12-1-7q1-14-2-27l-1-9 3-2q4 4 3 6-3 11 2 22l1 9-2 35z"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m359 1195 1-5 1-3 2 10v21l3 41 2 42q-1 7-3 14l-2-2v-3l1-5v-3l2-5-2-38v-2l-4-33 1-25z"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m369 1237-3 2-1-40 4 5v3l2 10v5l-2 7zM362 1175l3 1c-1 6 4 12 0 18l-3-13-1-4z"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m363 1313 2 2v2l-4 10h-3v-1z"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m361 1327 3-10-4 18-1-4v-2zM361 1177v8h-2v-8z"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M359 1185h2v2l-1 3z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m421 1499-1 2-3-1-4-10z"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m417 1502-2-3 2 1zM415 1499l-2-2z"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "m363 1313-5 13q-14-1-15-15l2-6 3-3q8-4 9-12l2-2 1-1 4 4v8l-5-3-9 9q-6 7 2 13 4 3 7-2l4-7v4"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "M343 1311q1 14 15 15v1l1 2v2l-2 1q-8 9-14-3l-3-8q-4-7 3-10"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m866 601-1 6q5 13 0 25-1 5 4 7 5 1 10-1l17-11q3-2 7-3-18 17-41 24v-37l1-5v-7l3-1z"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "m848 577 10 16 4 4v2l-6 2h-2q-2-6-8-6l-5 5-4 10c-3 5-7 3-11 3l-18-1c-7-1-14 1-21-3q-5-4-6-11l-1-5q-2-5-6-4l-10 3v-6l-6 1h-1l2-4 2-1q7-4 14-6 5-2 6-7l3-5q4 1 6 4 7 11 16 3 6-5 13-2l-10 6q-10 5-19-1-4-5-6 1l-2 16 4 3 8 4q5 4 9 3h27l5-2 1-6-3-9c3 2 2 7 8 6v-9c0-7 5-3 7-4"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m856 601 6-2h1v3c-3 0-6 3-7-1M862 597l-4-4h3l2 2z"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m863 595-2-2z"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "#241e1b",
    d: "m764 1768 3 2 14 3-5 1-25-2q-15-1-14 14v1q-2 5 4 7l-1 4-5 1q0-10-8-8-3-1-5-3l-3-5c-8-3-16 2-16 11q0 5-6 5l-54 1-5 1 4 5h9q8 0 9 7 1 4 4 5 13 3 28 3 3 0 5 3l13 11q5 4 10 6l13 6 9 3 21 3 2 1q5 5 9 2 5-4 2-10-4-15 9-25h8l21 18 17 9 20 9 2 3 4 2 5 1q4 4 8 0 5-8 12-3 4 2 9 0l1-3q-3-13 1-25 3-6 0-10l-9-3-14 2q-6-1-10 4l-2 2-14 1-5-4q0-6-5-9l-2-3v-6l3-2 3 5q2 5 5 8c1 0 6-1 7-3q3-8-3-12h-1q-9 0-9-9l17-9 1-1 15 6 2 4q-2 8 5 10l9 1q4 0 5 4l5 6q4 2 5 5c1 6 0 12 7 15l1 5v18q0 7-5 6-5 0-6 3-3 6-9 5l-9-1-6 2q-3 6-8 1l-3-4-17-5q-6-1-9-6-1-3-4-4-7 0-13-7l-3-1-5-3q-5-9-15-15-6-4-12 0-7 5-4 13l1 5 2 13q-8 5-17 2c-5-1-9-6-16-3l-1-1-9-3-8-3c-9-2-16-9-25-9l-6-3q-3-2-8-3h-26l-5-1v-2h16q-4-3-6-5-2-3-7-3-7 0-10-7-1-5-6-4l-10-1-18-16h-8v-7l-12-2h-7l1-4q1-4-4-6l-7-6q9 0 11-10l4 6 6 4q5 1 5-5-1-6 5-4 12 2 24 1l2-3q2-5 5-2l1 4q-2 6 4 9 13 1 29-2l-6-2 1-1h5q6 5 13 5l7-2 12-2 3-2v-11l9-1 7-8 4 2 3 3 7 3q-1 7 1 9 3 4 10 6zm88 45 2 6 2-5 2-4 2-7-7 1zm24-4zv-1z"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m602 1788 12 2v7h8l18 16 10 1q5-1 6 4 3 7 10 7 5 0 7 3 2 2 6 5h-16v2l5 1h26q5 1 8 3l6 3c9 0 16 7 25 9l8 3 9 3 1 1c7-3 11 2 16 3q9 3 17-2l-2-13-1-5q-3-8 4-13 6-4 12 0 10 6 15 15l5 3 3 1q6 7 13 7 3 1 4 4 3 5 9 6l17 5 3 4q5 5 8-1l6-2 9 1q6 1 9-5 1-3 6-3 5 1 5-6v-18l-1-5c-7-3-6-9-7-15q-1-3-5-5l1-5q-1-8 8-7c-1 8 9 5 9 12l4 1h10c7 3 7 3 10-4l4-3 3 4 1 5q3 4 0 8-2 5-3 10l-3 1h-7q-4 2-2 5c7 5 7 13 9 20h-1l-3 1q-7 1-6 8l-3 4c-3 6-12 7-15 14l-5 2h-8l-4 2-6 2q-5-7-15-7l-5-3-17-10q-3-2-7-2-14 5-12-9h-1l-13-8-6-2q-6 0-7-7l-2-4-3-1-9 14q-2 6 3 5h7q8-2 11 5 3 5-2 10l-3 4q-3 5-7 3l-8 1-9-3q-5-6-14-8l-5-5-7-4-8-2q-16-8-33-8-6-1-12-5c-4-2-7-5-11-1h-3q-9-3-18-2-8 0-15-4l-4-1q-11 1-12-11l-5-4q-7 0-6-7 2-10-8-10c-9 0-8 0-11-9q-3-6-10-11"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M584 1799q2-4 5-2 5 1 5-4l1-3 4 2 5 3 3 2q3 8 2 15-2 5-8 4h-8l-11 2-5-4v-3l4-2q10-3 3-10"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "M479 1771q-9 0-8-8v-11c0-6 0-6-6-12l6-1 17 4 3 3-1 13-3 3-3 4z"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m839 1883 3 6q0 3-1 4-6 1-6-5-2-5 4-5"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M584 1799q7 7-3 10l-4 2zM597 1831c-3 6-7 2-10 1 3 1 6-6 10-1M577 1814l5 4-3 5h-2z"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "M295 1764q-2 4-6 3l-2-5z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M547 1823h11v1q-5 3-11-1"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "m401 1780-1-3h2zM400 1702v-2h2l-1 3z"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "m588 1843 3-2v2z"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "#29231f",
    d: "m402 1725-1 1-1-1z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M666 1766q1-6 6-3-1 8-6 3M572 1716q-4 7-13 7-5 0-5-5 0-4 5-4c4 0 9-2 13 2"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M476 1694h2l1 1-2 1z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "M383 1590h4q15 1 23 14 3 4 8 6l1 1 2 6 6 7v1l-12-7-5-6q-1-3-4-4-7-3-14-4-11 1-10-12z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M722 1722q-12-6-26-10-15-3-28-5l-20-6-21-5-2-1-24-8-7-2-17-5-29-8-13-5-3-2c-13 0-24-7-36-10l-11-4q-5-2-10-3l-16-3q-3-2-5-7h5l1 1 7 3h2l10 4h3l5 2 22 7 4 2 27 8 11 1 2 1c3 5 9 4 14 5l26 8h6l18 7 19 6 20 4h2l3 2 37 8 5 3q18 5 32 17l-11-4z"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m724 1723 11 4 5 4 4 9c-4 2-6 7-11 3l-1 3-7 8-10-16-6-7c7-4 12 2 19 2z"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "M459 1638h-8l-14-10-2-1-4-6 5 1 1 1 10 7z"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m435 1627 2 1q4 8 12 10-6 3-10-2l-12-11v-1z"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "M449 1638q-8-2-12-10l14 10z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m722 1722 2 1z"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M940 1861c-2-7-2-15-9-20q-2-3 2-5h7l3-1q1-5 3-10 3-4 0-8l-1-5-3-4-4 3c-3 7-3 7-10 4h-10l-4-1c0-7-10-4-9-12l2-3 6 2 11 2q3-2 4-7 0-7 7-7l3-1q4-2 6-2l5 8v15l2 10-1 6q-4 5-3 12l1 3q2 2-2 5-1-4-3-6l-5 1-1 4 4 12q1 2-1 5M895 1892l4-2h8l5-2c3-7 12-8 15-14l3-4q-1-7 6-8l3-1v1q-8 4-6 12l-4 3q-5 1-2 4 2 4 1 6t-5 3l-12 2z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m891 1700-7-6 7 3z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M891 1700v-3h3l2 4zM908 1705l4 4q5 2 3 8 0 6-5 10l-1 3-7 10-6 7q-5 8-11 2-7-3-13-3c-3 0-7 9-6 12l3 8q2 4-3 6h-3c-10 5-18-2-27-6l14 3q9 3 11-7l1-12q0-9 9-12 6-3 11 2c4 4 13 2 15-3q2-9 10-14 4-3 1-7l-7-11 4-1z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m901 1705 7 11q3 4-1 7-8 5-10 14c-2 5-11 7-15 3q-5-5-11-2-9 3-9 12l-1 12q-2 10-11 7l-17-3-4-3q9-4 16 1c5 2 5 0 8-3 8-9 3-17 0-26l6-2q6-4 13-6 5 0 10 4 4 2 7 7l4-4 9-15c-3-6-3-14-10-19l4 1h1z"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m900 1704-3-3z"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m844 1828 14-1 2-2q3-5 10-4l14-2 9 3q3 4 0 10-3 12-1 25l-1 3q-5 2-9 0-7-4-12 3-4 4-8 0l-5-1-4-2-2-3-20-9-17-9-21-18h-8q-13 10-9 25 3 6-2 10-4 4-9-2l-2-1-21-3-9-3-13-6q-5-2-10-6l-13-11q-3-3-5-3-15 0-28-3-3-1-4-5-1-7-9-7h-9l-4-5 5-1 54-1q6 1 6-5c0-9 8-14 16-11l3 5q2 2 5 3 9-2 8 8l5-1 1-4q-6-2-4-7v-1q-1-15 14-14l25 2 6-1h2c4 4 6-1 9 0l9 7-10 1-9 1q-9 3-14-4c-3-2-13-1-15 2q-3 8 7 11l17 1q7-1 7 6l3 12 6-4 4 6-1 3 2 5 11 10 11 8q7 6 19 3l-5-5q-9-5-7-14l-2-5c-6-1-5-7-3-9q8-9 0-17l6 2 2 3-3 9-1 6 7 17q2 3 6 4 2 0 4-4m-78-7 5 1v-9l-4-2c-1 3-4 5-1 10m81 20-1 1z"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M823 1791q8 9 0 17c-2 2-3 8 3 9l2 5q-2 9 7 14l5 5q-12 3-19-3l-11-8-11-10-2-5 1-3-4-6-6 4-3-12q0-7-7-6l-17-1q-10-3-7-11c2-3 12-4 15-2q6 7 14 4l9-1 10-1 11 5z"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m823 1791-10-6 19 6 5 2q0 9 9 9h1q6 4 3 12c-1 2-6 3-7 3q-3-3-5-8l-3-5-3 2v6l2 3q6 3 5 9l5 4q-2 4-4 4-4-1-6-4l-7-17 1-6 3-9-2-3z"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "m795 1669-2 11q-1 7-3 10c-7 9-8 21-11 31-2 11 5 26 16 30v5l-1 2-7-2-5-6-2-5-5-20q1-8 4-14l9-27q2-7 7-15"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "#211f23",
    d: "m732 1746 1-3c5 4 7-1 11-3l9 8 6 4q7 2 5 9v7l-7 1v-4c4-6-3-7-5-10l-6-1-7-3-3-3z"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m740 1731-5-4q-14-12-32-17l-5-3h3l6 1h8l17 10 3 3 1 1 3 3 3 1q8 14 21 20l6 7-18-11z"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m769 1753-6-7v-1l7-1 3 1h2l4 3v1l1 1 2 8-7-1-2-1z"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m775 1757 7 1-2-8h2l5 6 3 7-8-1z"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "#241e1b",
    d: "M793 1773c-3-1-5 4-9 0q3-8 9 0"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m812 1758 15 5h-4l-11-2z"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M823 1763h6l4 3q-6 3-10-3"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m794 1758 1-2c4 1 8-2 11 3z"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m769 1753 4 3z"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M812 1758v3l-3-2z"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "m414 1896-2 1v-2z"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "m388 1467 17 23 14 22 1 11q1 3 3 5l10 7 3 3 3 4 12 10q2 2 6 3 11 6 20 15l10 7 3 5-2-1c-6-6-17-7-22-16l-6-1 2 5q8 7 15 18 4 7 9 13 4 4 9 6 11 9 23 14l4 2c3 5 10 5 13 11l1 1 13 8c4 3 15 6 19 4v-1l-13-17h4q5 7 12 11 13 6 24 15-1 5-6 2-5 0-4 4 1 3 3 5h12l6 3 11 5q8 0 9 8h-5l-4-2-13-2h-1l-11-4-17-5-12-4h-2l-5-1-3-2-9-2-15-3-1-1-5-3h-2l-8-4-5 1h-3v-1l-10-3-5-2-1-3 5 1q8 4 15 3l-9-8 5 1 13 4 4-2-1-3-4-3q-4-1-7-4c-4-5-10-3-15-6l-7-2-15-7-33-22-17-14q-6-2-5-7c2-3 5 0 8 1q6 2 10-3 3-6-3-8l-3-3c-6-10-10-20-20-27l-8-7q-5-2-5-8l-5-17-7-18q-3-8 3-14"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "#de6641",
    d: "M388 1467q-6 6-3 14l7 18 5 17q0 6 5 8l8 7c10 7 14 17 20 27l3 3q6 2 3 8-4 5-10 3c-3-1-6-4-8-1q-1 5 5 7l17 14 33 22 15 7 7 2c5 3 11 1 15 6q3 3 7 4l4 3 1 3-4 2-13-4-5-1h-3l-3-3h-2l-9-6h-2l-3-2-11-6-2-2h-2l-13-10-20-13q-5-3-8 0-1 4 1 9 1 3 3 4l-6-3-8-11q-2-8-9-8h-2c-2-7-8-4-12-6h-6l-6-1c-7-4-7-14-1-19q9-9 19-8 5-2 3-6c-6-6-3-14-5-20-2-8 0-17-5-24q-7-14-7-29-1-5 1-11h1z"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M450 1537zl6 6 21 18 23 21 12 9 5 2 9 10h-6l-23-19-5-5h-1l-7-7-19-17-17-15-21-22-8-10 6 3 4 5c2 2 3 7 8 7l1 3 7 7 1 1z"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "#de6641",
    d: "M457 1555q-4-1-6-3l-12-10-3-4-3-3-10-7q-2-2-3-5l-1-11 9 12 19 20z"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m426 1511-6-3v-1l-3-4v-3l3 1 1 2z"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M492 1579zl1 4h-2l-2-1-3-5z"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m417 1503 3 4z"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M378 1586q15-4 29 4l1 1 3 5 6 7-6-3-5-6-5-3-6-3h-2l-8-1z"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "M401 1591zl4 3 5 6 6 6h2v2l-1 2q-5-2-8-6-8-13-23-14l6-2h2z"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "M408 1591zl-4-5q7 0 9 7z"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "#190f0d",
    d: "M577 515q2 9 10 9c8 1 8 7 10 12l2 8q2 5 0 10v20q-2 5-7 6-2 0-5-1l-7-2q-7-2-8 4v7q-1 3-3 5-2 3-2 5l4 3q6 0 6 5 1 7-6 6h-13q-5 1-3-5l1-5q0-5-5-3l-8 2v-2l-1 3q1 10-8 10l-5-2-8-9q-6-8-14-2-4 4-10 0-8-4-11 5l-1 5-2 7-6-7q-4-5-10-4-4 1-4 7 0 11-11 7l-2-2c0-6-5-4-9-4q-5-1-11 4-3 3-10 4l-3-3-3-4-6 3-2 4q-2 7-9 6-4-1-4-7-2-13 12-11l6-3q4-4 1-10l-6-10q-2-6 4-4 5 1 9-3 5-7 14-2 4 4 10 0l5-3q5-2 1-5-9-9-5-21l1-10q0-4 4-3l16 2q3 0 5-3h5q4 10 3 19-1 8 4 14 3 4 0 7-2 2-4 7l4-1q13-3 19 9 3 2 12 3l3-2 5-13-2-9v-4q0-15-10-25-6-4-5-13l19-3q4-1 4 3l-1 14 5 13 2 1q7 0 14 4l5-4q1-4 5-4 12-2 8-14v-15q0-4-3-6l-10-4q-5 0-5-4 1-6 4-8 6-1 12 1h4l5 6zm-99 69 1 3 2-1z"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m575 503 3 1 13 4q-10 5-16-5"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M577 514"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "m534 530 8-11q6-6 14-3 5 4 3 7-4 7-3 14 1 6-6 8-5 3-8 3c-2 0-3-5-6-7q-5-5-2-11m19-1v-2q-1-4-4-6-2 0-6 2c-6 4-4 10-4 15q3 5 8 2 4-4 6-11"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M504 526q-1 9 5 13 10 10 10 25l-12-17-9-10-5-8h2l5-3h4"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "m493 529 5 8 9 10 12 17v4l-3 6q-7 11-16 2l-3-2-13-11c-5-5-2-11-3-17l1-12h-4v-3l3-1 2-1zm-9 11 3 9 7 8 8 11q5 5 11 2 4-4-2-10l-10-12-7-9q-5-5-10 1"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M478 531v3h-8c-6 2-12-3-18-3q-13-2-13 11l-3 13-1 3q-2 15-16 9l-14-5q-6-1-12 1-8 2-8 9l-2 5-6-3q-3-4-7-5l-19-1v-1l9-2q17 0 33-6l15-3q7 1 12 4 8 5 11-3l4-7 1-10q1-12 13-13l14 3zM483 529l-2 1z"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "m500 526-5 3v-3z"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "m345 571 15 4 3 4c1 4-1 8 2 11q0 3-1 8 0 4-4 4l-2 1c-6 4-7 4-11-1l-8-8c-4-3-6-8-12-7v-2l5-11 4-2z"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "M195 809v-2l7-2q5-3 11 0l6 3h5l-3-5q-3-4-3-6 4-10-7-12-5-1-5-7l1-17q-1-10 6-15 4-5 0-9-2-3-3-8l-1-8q-2-5 1-11l5 4 2 3q9 2 16-5l3-2q6-3 4-7-5-9 1-18v-2l21-9c4-3 8 0 12 0l-1 5q-4 3-4 9l1 16c0 4-6 9-10 9h-10q-8 0-9 7l-1 20q1 6 1 12-1 8 2 17 2 10 1 21v13q0 10-5 16-4 6-3 12 1 5-2 9-6 9 0 17l1 7 3 4q7 1 10 9-7 2-6 10v24c2 7 2 7-4 10q-9 1-12-6l-6-13-5-14-5-16-4-13q-2-7 3-9 6-6 3-13l-8-16q-2-7-9-12"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "#241e1b",
    d: "M256 930v-10l-1-7 2-14 3-2 4-5c5-7-1-14 2-20l-5-5q-9 0-7-9l-1-4-8-10q-2-6-3-13c-2-5 3-7 6-10l3-4v-26q1-11 1-23v-13q0-4 3-6 3-4-1-7l-8-13 6 6 6 7 4 3 1-5q-3-4 0-7c3-5 6-10-1-14v-1q11 2 5 11l-3 7q6 3 8-3 0-7 8-6 10 3 15-7 2-6 2-13l-4-1-3 2-2 4-1-4-1-3c-7-6-2-14-3-21l4-4 7-6-7-5q-5-5 0-9l14-10 4-5 2-8h2l1 1v2l-1 9q1 5-5 4-8 0-11 8-4 7 6 14l-2 4q-5 7 3 10c6 3 6 3 2 9l-1 4 4 1 7-1-7 20c0 5-1 10-9 7v6q0 8-8 9h-19l-2 1-7 3q-4 2-5 5c0 10-1 20 7 27q3 5-1 8t-5 6q-1 8 1 15 3 6 0 10-5 5-4 12l-1 10q-3 9 3 12 5 1 8-1l1-5-1-7q6 2 5 6-2 7 1 13l1 4 2 5c2 5 8 9 7 14q2 12 6 23 3 12-8 13-7 0-7 6-1 7-7 6zm6-72-5 1 1 4h3z"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M256 930h7q-4 7 0 15 4 9-3 17l-6 9v5q3 8 2 18-2 6 3 10l2 3-1 5-4 1-4-2v6l-2 16-3 10 2 4q6 1 4 6 0 7 5 11l4 1 2-3 1-4h1l1 3q0 9 7 8 3 1 5 3l9 12q2 3 5 3l19-2 2-2 4-2 3 6v4q5 3 4 10l2 3 9 8 10-10q2-3 5-3 3 2 1 6l-1 6 3 3 3-1 2-11-2-4c4-8 2-17 9-24q3 3 0 8-2 2-2 6 5 9-1 17v4q0 14-14 12l-3 1-1 3q6 5 13 9 4 0 5 4-6-2-7 4-9-8-21-9l-1-2h5l4-4-5-3-2 1q-6 0-7-6a14 14 0 0 0-8-14l-25-12q-11-7-20-16-3-2-11-4l-1 2q-5 4-8-1l-6-10-5 2c-3-5 2-14-10-15l3-5 3-3 4-15 2-5 1-4 1-14q0-7-3-13l-1-14 1-10q0-4 3-8 4-6 3-13l-2-10z"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "M232 1026q-6 8-14 6l-4-2-2-17q1-3 4-6c1-3 4-4-1-6q-3-2-4-6l3-16 2-15-1-13 5-8q3 0 6 3 12 11 13 27c2 10-2 19 1 28q4 15-8 25"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m334 1131 1 2q-8 0-16-2l-20-8-23-4h-8v-3q7-2 11-8 5-6 10 0 5 7 11 2 5-4 10 0 4 3 9 3 11 2 5 11l-1 5 4 1z"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M276 632q4-9 13-12 4-1 6 4l5 10q4 8-3 12-6 4-12 7-4 1-8-2-5-1-3-8z"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M262 718zc7 4 4 9 1 14q-3 3 0 7l-1 5-4-3-6-7-6-6-2-6 5-4 9-1z"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m280 1093-9 9c-1-1-6-12-4-14q5-4 10-5c4-1 6 6 3 10"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M225 1068v-1l2-9v-5l-13-14q4-3 7 2l13 12-1 4c-1 4-6 7-5 12z"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M268 1116v3l-2-1q-7-12-19-23l15 6 3 3z"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "m249 673 2-4 13-12q4-4 4-10l3-6c0 7 1 14-5 19l-13 12z"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M203 1009v-16l4-4 1 15v3l1 9-2 7v-4l-3-3-1-4z"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "m214 1039 13 14v5l-2 9-2-4q1-17-14-24l3-1zM242 1095l-4-3-9-16 3 2 9 11 1 3z"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M211 960q2 9-3 17h-1v-12l2-2v-2zM212 1038l-3 1h-4l-1-3-1-4v-3l4-2zM241 1089l-9-11-3-2v-3q10 4 12 16"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "M210 894c-6-1-3-6-2-9l1-5 2 8z"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m207 989-4 4v-5l1-2 3-4z"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "#241e1b",
    d: "m258 718-9 1q2-7 9-1"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M229 1073v2q-5-1-4-7l3 1z"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m211 960-2 1-1-4v-3h3zM207 1027l-4 2v-4l4-2z"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m207 982-4 4v-6l2-1 2 1z"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M242 1095v-3l5 3zM309 637h-2l-3-6 2 1z"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m207 980-2-1v-2h3v2z"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m205 833-1-3zM203 828l-2-3z"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M211 947v-2z"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2320",
    d: "M207 980z"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m207 761-1 17q0 6 5 7 11 1 7 12 0 2 3 6l3 5h-5l-6-3q-5-3-11 0l-7 2v-3l15-7q4-2 4-5l-4-4-6-3-1-9 1-15z"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "M207 761h-3q2-9 6-17v-6q-5-9-4-20 1-5 5-11l-1 3q-3 6-1 11l1 8q1 5 3 8 4 5 0 9-7 5-6 15M204 785l6 3 4 4q0 3-4 5l-15 7 4-6c8-5 8-4 5-13"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m210 710 1-3q5 0 6 4 5 7 11 1 6-5 4-15c-2-6 4-10 9-14v2q-6 9-1 18 2 4-4 7l-3 2q-7 7-16 5l-2-3z"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m309 637-3-5h2q9 3 7-7l4 4v8q3 6-2 10l-4-3v-2l-3-4zM314 617l1 2z"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m346 609 2 2 2 6h11q8-4 16-10l8-1 2 3-3 4q-6-1-8 6-1 4 2 9 3 4 1 9-6 16-6 34l1 31-1 14 2 34 1 2q5 4 1 10 0 5 2 11l2 5q1 12 3 23l8 27 4 10 3 6 2 5v2l1 4 9 13v5l-19 22q-4 7 4 8l21-2q-4 5-9 3h-3l-11 4-5 4q-5 6-12 2-6-3-8 3-2 2-5 3-2-2-3-5 1-4-1-8c-5-7 3-13 1-19l2-2h11l-2 5 2 6 5-2 17-16q6-5 0-10-4-4-7-9c-3-8 1-16-3-23q3-9-5-16-4-3-2-8v-15l-2-11-4-20-4-17-1-33 1-24v-4q4-12 0-22v-6q5-7 2-15-3-3-7-4l-28 11q-6 2-7-2 0-12-6-22-4-11-4-23v-2q10-2 10 5 0 9 8 15 4 3 6-2z"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "M319 606q0 12 4 23 6 10 6 22 1 4 7 2l28-11q4 1 7 4 3 8-2 15l-7-8q-5-6-11-1l-10 10-2 2c-7 1-15-5-16-13l1-3v-6l-1-3v-2l-2-4-2-1v-3q2-8-3-16z"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "m346 609-3 13q-1 5-6 2-8-6-8-15 0-7-10-5 2-7 7-3 4 3 7 9 0 5 5 6 6-1 5-7l-1-5v-2h1z"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M342 602v2l-1 3-2 4-5-4-5-8q-2-4 3-6l7 3v1z"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m339 596-7-3-5-6c6-1 8 4 12 7z"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "M657 1648h-13q-4-3-7-3l-14-1h-2l-13-11 5-1q13 5 25-3c5-3 12-1 18-2q12 2 24-1 10-4 20-3 13 2 24-2l9 1 8 1 33-5-6 3-20 5-5 3-7 4-15 1-18 3q-14 4-26-1l-6-1-13-1h-13q-5 2-1 6c4 2 8 7 15 4q5 0 10 1v1z"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "m817 1580-2 1q1-10 6-17l4-7q1-5 6-7c5-3 11-4 10-12q1-4 3-5 8-4 6-9-3-5-1-11 4 1 4 4 1 10 11 7l4 2-3 5-3-5-5 4v7q-2 6 4 6l-1 4v3l-3 3-11 17-1 2-3-1-9-2q-5-3-5 2v2q-3 8-10 5z"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "m887 1495-1 1q-9 0-5 6v7l-7 9c-11-5-7-20 0-24q3-2 3-6t-3-6q-5-3-9 4l-5 7 1-6 2-4 2-2 1-2v-1l5-3 8-13 5-2 3 5-4 12q-3 6 3 8 7 0 8-5 2-6 6-10l-3 11z"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m860 1493 5-7q4-7 9-4 3 2 3 6t-3 6c-7 4-11 19 0 24l7-9v-7q-3-6 5-6l-1 11c-1 4 0 9-5 10l-1 2-11 22q-3 5-8 9v-3l3-4 4-6 5-10q5-4 0-8l-2 1q-7 1-11-1c-2-2-5-9-3-10 4-5 2-10 4-15z"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "m736 1633 7-4 5-3 20-5 6-3 8-1c-5 6-12 6-19 9l-11 3-5 6h-10zM801 1617h-17c4-6 13-7 17 0"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M828 1573v-2l5-2 2 2h2q3 5 5 0l3 1q-2 3-6 5l-3-1q-4-5-8-1zM846 1570l11-17h2v2zM887 1495l10-14h1l-10 14z"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "M828 1573v4q-3 7-11 3l1-2q7 3 10-5M859 1553h-2l3-3z"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m546 1607-2-2z"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "M945 1370v3l-12 29-2 9-2 2v1l-3 5-3 7-2 2-6 16-5 6-5 7v-2l2-7 3-7 8-12q2-12 10-20l2-3 10-32 3-3z"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m945 1366 6-14 6-16 2-2 2 3v8l-2 9v1l-6-2-4 12-4 5z"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "m905 1457 5-7 5-6-7 18-7 13-3 6h-1l3-11v-3l2-2zM926 1419l3-5zM929 1413l2-2zM921 1428l2-2z"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M619 1650q12 8 26 6 5 0 8 3h-20q-11-1-19-10h3z"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M617 1649h-3l-5-5 8 1v4"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M617 1647v-2l2 2z"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M960 1354v-9z"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M614 1649q8 9 19 10h24l15-1 45-4 12-4 18-4q4-3 10-6 16-11 37-11l1 7q-10 2-15 11c-3 3-4 10-12 7l-2 2 7 3 6 6 11-9-5 15-2 3-4 7h-2q-3 8-12 7c-6-2-14-4-15-10q-2-4-6-5-9-3-17-1-8 3-15-1-5-3-8 1t-7 4q-10-2-19 1l-5 2 1 1q6 2 14 3 9 2 14 9 1 2-1 5l-4 2h-4l-10-1-2-1h-2l-7-2h-8c-3-1-8 1-9-4h5c6 1 11-2 15 2q6-2 8 2l6-2q2-4-3-4l-2-1-10-4q-8 0-8-6-2-13-14-13l-27-2q-10-9-23-13l-8-4-5-5 8 3z"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m795 1636-1-7q5-1 5 5v5l-2 7-2-1z"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m672 1658-15 1 4-2z"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M782 1750h-2l-1-1v-1l-4-5-2-9q-3-10 2-20l7-22 5-11 8-20v8q-5 8-7 15l-9 27q-3 6-4 14l5 20z"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m773 1745-3-1q-6-8-4-17 0-13 6-23l5-14 5-5-11 30q-5 15 2 30"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m782 1685-5 5v-4l2-4v-1l4-7 2-3 5-15 3-6 2-5 2 1-14 34z"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m775 1743 4 5-4-3z"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m798 1653-3 6z"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m783 1680 2-2z"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "M795 1751c-11-4-18-19-16-30 3-10 4-22 11-31q2-3 3-10c5 0 11-1 14 5l1 5q2 8 0 16l4 7 12 15v4q-2 8 7 9l6 3-6 3-15 4c-7 2-14 5-21 0"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "M853 1735q-13-2-24-12l-10-11-1-5h5l27 20q2 3 3 8"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "m847 1665 2 2z"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "M929 1115q7-1 7 6l3 20 4 18v6l8 30v2l5 38-1 30v12l-4 43v5h-4c-1-11 2-21-1-31v-4l3-16q1-9-1-18v-3l1-11-1-8q-2-10-1-20 0-5-1-8 1-8-3-15l-2-5-3-11q-2-6-3-14l-3-33-4-7-2-4z"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m947 1066 3 30 1 7-1 16q0 22 5 44l2 9 3 22-1 7-1 5h-2l-5-20-5-29-1-6-3-35-1-23 2-11 1-5 1-9z"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m929 1115-3 2-20 2q-7-1-14 2-6 1-4 7l-2 6c-6 1-11 6-18 3l-14-2q-9 0-5-8 3-3 0-6v-3l5 1q14 4 29 0l10-3 11-1h9l3-2h4l3 1 6-2z"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m926 1086 2 5q1 5-5 3l-4-5-6-6-4-2-6-5q-4-4-10-6l-13-5h-21l-10 1-5 3h-3l8-7h-6l5-3 6-1h8l33 3 8 5 6 3 14 15z"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M947 1325h4v20l-4 6v4l-8 12-7 9q-12 21-30 37-3 4-6 0l-4-11v-6l1-1 1 4q2 12 11 5 12-9 19-22l6-11 2-1 1-2v-2l6-8v-2q9-15 8-31"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m926 1086-3-2-14-15 11 7q8 5 15 1 6-8 6-17l4 8-1 9-1 5c-6-2-8 5-12 7q-3-3-5-3"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m929 1112-6 2-3-1q8 0 6-7-3-4-7-6l-1-1 5-1q7 0 6 8z"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m923 1098-5 1v1l-1-1-2-4 1-1-1-6-2-5 6 6 4 5z"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m892 1402 4 11q3 4 6 0 18-16 30-37l7-9 8-12-4 12v1l-10 13-10 15-11 13-7 9c-6 0-12 5-15-2zM947 1351l4-6z"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M943 1368zl2-1v4h-2z"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M954 1057q5 0 3-4-1-5 4-8c4-2 8-5 14-1l2-15c1-4-2-9 3-12l1 2-1 3v3l1 6-1 8-1 2v2l-2 3h-4c-10 0-11 1-14 14l-5 1z"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m981 1031-1-6h2v2zM977 1046l2-3zM979 1041l1-2zM980 1022l1-3z"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m948 1006-1 6c-3 3-5-1-8-1v-2l-3-6-5-8v-4l10 12 1-8-4-23-8-39 1-4 4 6v2l1 2v3l3 23 4 22 2 3v8c1 3-2 7 3 8"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m948 1042-2 4q-3-8-11-12l-2-4 8-1 2 2 4 6z"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M939 1011c3 0 5 4 8 2l1 8h-5l-1-2-2-2z"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "M943 1021h4l1 6-1 4h-4l-2-2z"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M945 993v-10l2 2 1 13h-3v-5"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M945 998h3v8c-5-1-2-5-3-8"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "M943 1031h3l1 3v3z"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m948 1027-1-6h1zM947 1034l-1-3h1z"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m933 1030 2 4q8 4 11 12l1 8v3l1 8-1 1-2 2-4-8 1-4c-1-6 1-13-6-17l-1-1-4-3-2-2q-7-5-15-8l-27-1-27 5h-3l-5 2h-2l-2 2h-9l2-2 40-9c14-1 29-3 44 4l4 1z"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M947 1057v-3z"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m1071 920 2-5z"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M862 629v19q24-7 41-24l4-1 3-3 3-1q-3 6-7 9-8 4-15 11l-3 4 7 2 6 1q4 4 6-2l6-5-3 10q0 8-8 9l-32 3q-6-10-17-9v-4l5-12z"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m913 639-6 5q-2 6-6 2l-6-1-7-2 3-4q7-7 15-11 4-3 7-9l2-3 2-2h3v1l-1 2-1 6h6l8-4v3l-4 3q-6 1-7 7v1l-3 2-2 2z"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m910 620-3 3z"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "m932 619-8 4h-6l1-6 1-2q6 0 7-4h2l9-1q10 0 21 4 1 4 1 6l-9 5q-3 0-6-4-3-6-9-2z"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M959 610zl-4-2zM951 608l2 1z"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M927 611q-1 4-7 4v-1z"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m913 639 3-2h2q-3 12 5 17c4 1 13-2 16-5q8-9 6-19 7 1 4 7-2 5-1 9 2 9 6 17 3 6-3 8l-4 2v4l10 5v5c-7 3-15 14-11 22q5 16-12 18-5 0-5 5-1 4-3 5-2 0-6-1l-5-2v6l-1 8q-9 2-13-3c-2 0-1-5-2-7l-4-11-5-1-4-3 3-3 3-1q6-1 5-7 0-6-7-6-6 1-10-4l-4-2q-6 0-5-4 0-12-12-9-7 3-6-5v-4q-1-5 6-5 11 0 11-12l32-3q8-1 8-9z"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "M982 726h9l14 5 21 11 13 10 6 6q8 8 9 18l-11-10-5-8q-5-8-13-9-8-7-12-1h-2l-2 1-5 2-9-1q-8 2-10-6l-2-5q-5-6-4-13z"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M976 687v4l-4 14-7 5c-1-6-6-12-5-19l1-8q0-7 7-12l9-5z"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M945 630q1 10-6 19c-3 3-12 6-16 5q-9-5-5-17l3-4v-1l11-10h9l1 1zm-5-3q-5-6-9 0-3 2-4 5-1 5 1 8 3 2 8-1 4-4 4-12"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M945 630v-3l9 1 5 1v5l-1 3q-8 6 0 12l1 2c5 7 5 7 12 2l1 1-3 4-9 9q-5 6-3 15l-10-5v-4l4-2q6-2 3-8-4-8-6-17-1-4 1-9 3-6-4-7"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1006 796q2 6 0 9-4 4-9-2-3-3-2-6 2-4 7-2h2z"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m1004 751 5-2-1 10-4-2-1-2zM941 622h-9v-3h4zM1008 759l5 4q-3 1-5-4M945 627v2l-3-6zM1015 764l4 5z"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m1003 755 1 2z"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M342 1147h-2l-9-5c8 2 16 2 21 9q4 5 7 12v4l-4-7q-4-9-13-13M313 1137v-2l16 7v1h-2z"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M329 1144v-2h2l9 5q-6 2-11-3"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "M351 1145q7 1 7 10zM358 1155l2 6z"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M277 1121v2h-4v-2z"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "M359 1165v-2h1l1 2z"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M277 1121h-8l-1-2h8z"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M259 1118v-3l2 4zM264 1121l-3-2z"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M207 977h-3v-7l1-9v-2l3-2 1 4v2l-2 2z"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "m207 1023-4 2 1-6h3zM203 1025v7q-4-3 0-7"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "M207 1019h-3v-3zM203 1009v3z"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M203 985zv2h-2z"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m297 1241-5-12v-2l1-7-4-25v-26q0-7 6-6 13 0 10 13l-5 19q0 6 5 8 5 1 6-5v-2q4-11 14-11h2l3 2h1l2 4v2l-4-3q-6-5-11 1l-2 9q0 5 5 4l8-1-1 2h-1l-18 4c-5 2-9 16-7 21q3 8 10 12 11 11 15 25l-1 7h-7l-6-3-1-2c2-2 5 1 6-4 3-9-9-26-21-24"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M327 1205h1l3-2h1c7-4 7-4 4-10l-1-2 4-4-8-11v-2l-2-2v-1l-3-3-9-8v-2q7 4 13 9l13 22 10 25 1 4q2 7-1 12t-6 1q7-5 5-11l-5-17-5-7-7 9-14 7-4 3h-1l-4 3c-3 6-1 16 5 21 7 5 8 5 15 0l7-3v1l-4 4-4 3q-5 9-12 1l-10-11c-7-9-1-19 6-23z"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M339 1237zl1-1h2l16 1 4 33-5 2-2-1-2-2c-2-2-6-5-4-9v-4q0-8-8-6l-3 2-5-1v-5l2-4z"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m355 1270 2 1 3 2-1 15-2 2q-1 8-9 12l1-3 2-4h-5v-1c4-8 4-8-6-11q-6-1-6-7-2-7 1-13l9-11h2l1 7c-1 9-1 9 8 11m-7 13h2q6 4 9-1 1-6-6-9l-7-1q-4 0-5 3l2 6zM312 1270zl8 10 9 10q-7-3-12-8-5-6-9-15h1z"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M331 1187zl-3-2h-2l-6-4q-8-2-8-9c0-10-8-13-16-16q-8 0-11 5h-3l7-11q3-3 6-2 15 6 20 20 2 5 7 9l8 6 1 1z"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M281 1161h3l-3 11v3l4 12 4 18-2-1v-3l-7-11q-4-4-6-8 0-6 3-13z"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m330 1184-1-1-8-6-6-12c0-2-3-4 2-5l12 11v1l2 2v2l2 4q3 4-3 4"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M294 1144q1 0 0 0"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m289 1229-3 4-2-3-4-8c-2-4-3-12 0-16l6-2 3 5-1 3-1 5 1 5z"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m289 1229-1-7h2l2 5v2l-1 1z"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m289 1209-3-5h1l2 1zM289 1230h2v2z"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "M292 1235z"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1997a",
    d: "m312 1269-2-1-5-7-2-5-3-4v-3l-1-2-2-4v-2c12-2 24 15 21 24-1 5-4 2-6 4"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m305 1261 5 7h-1z"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m297 1243 2 4h-2l-1-3z"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m300 1252 3 4zM297 1247h2v2z"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M299 1249v-2z"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m293 1240 2 2z"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M360 1287v-14l2-4-4-33-15-1v-2l2-2h2q3 4 6-1 4-5 1-12l-1-4q8 4 6-4v-15l2 4-1 25 4 33v2l2 38-2 5v-11zM342 1147q10 4 13 13l4 7v16l-3-7q0-13-10-22-3-2-4-7"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "M853 648v4q-1 10-9 7l-20-2q-12 1-24-4-6-3-7 4 0 5-5 5-7-1-11 5l-4 1-12 8-2 5q5 4 7 8 2 5 1 10 5-2 7-1 2 2 2 6v8l2 5q10 2 12 12t11 12l1 1 4 2 3-4 4-6q6 0 7 7 1 3 3 5l14 3c5 1 10 5 14-3l8 10c4-7 10-6 15-6l8-1q8-3 15 1l1 22q0 4 5 4 6-1 11 3 4 3 8 2 6-1 8 5c1 3-2 10-5 11l-12 6h-5l-3-7-4-2q-2 1-3 4l1 6-3 7-7-2-9-10q3-5-2-8l-1 5-7-4q-4-2-9 1l-9-7q-1-7-10-4l-17-9q-3-6-8-4h-6l-6-1-4 1-10-1-6 3h-3l-5-4q-3-1-4-4 1-3 4-5 5-5 12-2l4-1-2-4-7-3-6 5q-5 2-8-3l-3-7q0-8-8-5-10 3-9-7v-4q-1-3-4-4h-20l-3-2-7-6q5-7-1-11l-2-1q-1-6-6-4-4 0-6-4l-1-5-5 2q-2-1-5-3 3-2 5-3l7 1-1-4q-3-7 4-11c5-2 12-3 12-11l3-2q8-6 18-3 8 2 9-5 1-3 3-4 6-5 12-2 8 4 7-5 1-7 4-9l11 2 3 4q1 6 6 5l18-1q12-3 20 5 3 4 7 5zm40 153-1-3h-7q3 7 8 3m-125-82-2 2 2 1z"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M897 750q-8-4-15-1l-8 1c-5 0-11-1-15 6l-8-10c-4 8-9 4-14 3l-14-3q-2-2-3-5-1-6-7-7l-4 6-3 4-4-2-1-1q-9-1-11-12-2-10-12-12l-2-5v-8q0-4-2-6-2-1-7 1 1-5-1-10-2-4-7-8l2-5 12-8 4-1q4-6 11-5 6 0 5-5 1-7 7-4 12 5 24 4l20 2q8 3 9-7 11-1 17 9 0 12-11 12-7 0-6 5v4q-1 9 6 5 12-3 12 9 0 4 5 4l4 2q4 5 10 4 7 0 7 6 1 6-5 7l-3 1-3 3 4 3 5 1 4 11c1 2 0 7 2 7q4 4 13 3-1 6-8 3z"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M1019 805q2 7 11 7v3h-5l-9-8q-4-6 3-7v5M1036 812l3 4-1 1-5-2z"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "m1036 812-3 2-3 1v-3l5-3h2v1z"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m1042 815 3 5zM1067 856l4 10c-6-1-3-6-4-10"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m1045 800 6 5q-5 2-6-5"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m1020 773 10 13h-3l-2-4-5-5z"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m1020 777 5 5v4l-4-3zM1027 786h4l1 1-1 3z"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M1025 786v-4l2 4z"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M1033 783zl-4-6-5-11 2-5q3-1 5 1 12 10 18 25v6z"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "M1013 748q4-6 12 1h-11z"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "M1025 750q8 0 13 8zM1038 758l5 8zM1013 748zh-3v-1z"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "M1011 748v1h-2z"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "M1021 749h2z"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M1027 809h-2l-4-6 4-2q4 1 7 3 2 5-5 5"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "M1019 805v-3z"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "#191411",
    d: "M512 721h3l12 3c12 0 12 0 13-13q0-5 5-5h18q7 0 6 6 0 6 5 5l9 1 12 2q4-1 7 3 3 2 5 1 4-3 6-7 0-5 7-5 8 1 15-2 8-4 16-5l12 2 1 7 1 1 7 9c6 7 6 7 5 15l5 4q3 4 0 5l-10 2q-6-1-9 1-6 3-10 2 0-8 7-8 7 1 10-5 0-6-5-9l-3-1-6-6q-3-2-5-3l-4 4q-2 4-5 1-6-4-12 0-8 2-5 11v5q-1 4-3 4l-10 3q-6 0-11 5l-3 2c-9 2-18-6-18-16q2-12-8-8c-8 2-14 10-10 18l1 3-4-3q-4-6-10-9c-7-3-14 1-21 3l-10 5-5 3 4 2 4 3q-1 2-4 3l-6-2c-4 0-10-3-12-1l-17 12v1l-9 8-13 10q-5 5-11 5c-5 1-9 1-9 8l-2 4-18 19-1 1c-4 4-10 8-10 15v15l-5-5c2-6-2-10-4-15l1-5q1-4-2-6c-10-8-9-20-8-31l2-2 8-6q5-1 2-5t0-7l2-3q-6-3-14-2-6 1-5-5l3-7 4-3c5 2 8-2 11-4l5-2q6 3 11-2 4-5 7 0 2 3 6 3h10q7 1 6-7l2-14 8 1 11-3q4-2 3-6l-4-1-4-4 4-3h6q4 1 4 3 5 9 12 2 2-2 4-1 4 1 8 5 4 5 9 1"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "#190f0d",
    d: "M757 587h1l6-1v6h-1q-7-1-8 5l-4 4c-6 6-6 6-11-1l-7-3h-7q-7 0-10-7l-3-4-7-2-3 4q1 9-5 14-3 8-3 15v6l-2 4-3-4-1-6c-7 0-7-5-9-9q-4-7-3-15 1-9-8-10l-5-2-8 6q-5 3-5-3l-3-5-2 1c-1 3 2 7-3 7q-11 0-11-8l-2-12-4-21v-6q-2-12 10-11 6 1 8-3 2-5 6-6h5q4 6 5 13l2 17 1 5q1 5 6 7l3 3q5 6 11-1l5-5q8-6 9-16l2-10-2-16c-1-7 5-10 8-14q-3 6-4 10-2 13 4 25 2 4 6 4t7 3l4 14v16q7 2 10 6c3 6 11 7 15 13l2 1-2-12v-19l5-18c2-8 2-17-9-17l-3-1q-8-5-7 4 0 4-3 5t-5-1l-4-10 5 4 3-6v-2l9 1 4 1 17 1q9 0 8 7v2q-10 2-10 11l-1 3-7 12 2 1v2q-6 4-1 7v14q2 8 6 3zm-110-12v-2z"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "m853 648-15 3q-4-1-7-5-8-8-20-5l-18 1q-5 0-6-5l-3-4-11-2q-4 1-4 9 1 9-7 5-6-3-12 2-2 1-3 4-1 7-9 5-10-3-18 3l-3 2c0 8-7 9-12 11q-7 4-4 11l1 4-7-1q-2 1-5 3 3 2 5 3l5-2 1 5q1 4 6 4 5-2 6 4l2 1q6 4 1 11l7 6 3 2h20q3 1 4 4v4q-2 10 9 7 8-4 8 5l3 7q3 5 8 3l6-5 7 3 2 4-4 1q-7-3-12 2-3 2-4 5 1 3 4 4l5 4-18-3-8-5h-10l-1-5 3-7q1-5-4-6l-12-5-3-1q-8 2-17-3l-3-1q-10 1-9-9c0-11 0-11-11-9h-2c-3-1-6-10-4-13l1-8q0-9 8-15l1-2q9-14 20-26c7-7 14-16 26-14q4 1 7-3 4-3 9-4l5-1v-2h-4q-6 1-7-5l1-10 1-2 2-3 2-1v7l-4 4 2 3q3 6 7 2 11-5 14-17l2-5q1-6-6-7l-4 1c1-5 6-3 8-2l5 6q-1 8-1 15 2 3 6 7l7 2c9 2 18 6 27 3q6-3 12 2 9 7 20 12l3-3 4-15q1-7-6-9-10-1-6-12c2-4 6 0 9-1h2c1 4 4 1 7 1v4l-1 5v2q-5 6 0 12v4l-4 7zm-89 106q2-7-5-4 0 4 5 4m-72-49 4-1-1-2zm19 20 2 1v-2z"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "m721 526 4 10q2 2 5 1t3-5q-1-10 7-4l3 1c11 0 11 9 9 17l-5 18v19l2 12-2-1c-4-6-12-7-15-13q-4-4-10-6v-16l-4-14q-3-3-7-3t-6-4q-6-12-4-25 1-4 4-10l3-5q4 1 6 4 6 5 4 14z"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "M512 721q-5 4-9-1-4-4-8-5-2-1-4 1-7 7-12-2 0-2-4-3h-6l-4 3 4 4 4 1q1 4-3 6l-11 3-8-1-2 14q1 8-6 7h-10q-4 0-6-3-3-5-7 0-5 5-11 2l-5 2c-3 2-6 6-11 4l-4 3-3 7q-1 6 5 5 8-1 14 2l-2 3q-3 3 0 7t-2 5l-8 6-2 2c-1 11-2 23 8 31q3 2 2 6l-1 5c2 5 6 9 4 15l5 5v4l-8-8v-2l-2-5-3-6v-1q-3-14-9-29-1-9 2-19l3-6q4-5-3-6c-4 0-4-5-5-7q0-8 2-16c1-3 7-5 10-7q9-5 18-4l7-4q6-5 14 0l8 1 4-5-5-3-7-1v-2q6 1 11-1 4-2 6-8l-2-7q3-8 13-8h33q7-1 10 6 2 5 6 10m-55 1 3-1-1-2zM653 753q4 1 10-2 3-2 9-1l10-2q3-1 0-5l-5-4c1-8 1-8-5-15l-7-9-1-1-1-7-12-2q-8 1-16 5-7 3-15 2-6-1-7 5-2 4-6 7-2 1-5-1-3-4-7-3l-12-2-9-1q-5 1-5-5 1-6-6-6h-18q-5 0-5 5c-1 13-1 13-13 13l-12-3 4-8q2-3 5-3t5-3 6-5l14 1 10-1 11 2 3 1q17-1 34 4h4l12-3 33-4q13-2 15 11 4 9 10 15 4 4 2 8-1 3 1 5 1 3 3 4 3 9-5 8c-4 0-9-1-10 6-9 1-17-3-25-4z"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "M647 755c8 1 16 5 25 4l3 2q-8 3-16 1-21-2-41 1l-22 4-30 7c-16 2-30 10-44 16l-22 11-2 3h-1l-16 6q-5 2-8 6l-22 25-4 11-12 24-4 1v-3l2-3 4-16 3-5 9-13v-1l12-14 4-5v-2l14-8 6-3 12-8 8-2q11-7 23-11l7-2q16-9 34-11 6 0 10-2c7-6 16-5 24-6q8 0 15-2 15-6 29-5"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "#190f0d",
    d: "M621 529q2 8 1 14c0 2-5 5-7 4q-9-3-10-11l-2-6q-4-8 1-11 10-4 15 3z"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m351 568 19 1q4 1 7 5l6 3 2-5q0-7 8-9-5 6-1 14l7 8c4 3 5 11 2 13q-5 3-8-2-5-10-16-13l-4-5q-3-9-14-8-3 1-8-2"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "m713 586 3 4q3 7 10 7h7l7 3c5 7 5 7 11 1l-2 6q-3 7-9 3c-5-6-11-4-17-4q-5 2-5-4l-5-12z"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M729 522v2h-5l-2-8v-9l5 2 10 5q3 2 7 3 9 1 18 4h4l5 3q0 3-2 6 0-6-5-7l-18-3-12-4q-4-1-5 2z"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m751 619 4-4q4 9 9 2l8-10 1-5-2-4q-2-1-5 1l-7 11-4 4v-10l8-7 3-1 4-1q7 0 6 7l-2 5q-3 12-14 17-3 4-7-2z"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "m763 597-8 7 2-4q1-2 6-3"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M685 761h-8c2-6 5-2 8 0"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "M755 597q1-6 8-5z"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "m342 602-3-5z"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m753 609-2 3zM696 762l-3-1z"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m770 537 6-2-1 8q-2 6 0 11v5q-4 8-13 11-4 2-6-4 0-7 5-13l5-6q5-3 4-10"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "M801 548h-2q-6-9-14-3l-6 4-1-4 1-14 1-1q2-9 11-7h4l3 2-3 1c-9-1-11-1-13 8v8q8-2 12-1 6 3 10 7z"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m778 545 1 4q5 13-5 22l-8 5-5 6-2 1-6 1v-9c10 2 23-6 26-16l-1-6z"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M729 522v-4q1-3 5-2l12 4 18 3q5 1 5 7v2h-2q0-7-8-7l-17-1-4-1z"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m756 548 1-3 4-3 6-5-6 10-6 8z"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M753 575v9h-3v-10h3z"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M751 563v-2l4-6z"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M751 563zv3l-1 3q-5-4 1-7"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m750 570 1-3 2 7h-3zM767 532h2l1 5h-3v-5"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m689 538-11 10h-3q-6-8-3-17l3-8 2-5 6 3q8 7 6 17"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "M804 548q-4-4-10-7-4-1-12 1v-8c2-9 4-9 13-8l3-1 5 1 8 8q4 6 0 11l1 2-1 3z"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m761 582 5-6 8-5q10-9 5-22l6-4q8-6 14 3c-8-2-8-1-9 6q-1 10 3 16 3 2 6 1 5-1 6-7 3-5 9-2 2 4 5 4 7-1 11 6 3 6 11 3 3-1 7 2c-2 1-7-3-7 4h-5l-6-2-6-9-3-1-15 2q-9 8-16-3-2-3-6-4l-3 5q-1 5-6 7-7 2-14 6"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m804 548 7 2-1 6-9-8z"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "m812 547-1-2q4-5 0-11l4 5v6l-2 2z"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m813 547 2-2z"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m1040 920-12-11q-2-2-1-4l4-2q15-2 17 10 4 9-8 7"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m877 796 1-5q5 3 2 8zM941 835l2-3 2 1z"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "M947 983h-2v-8l-6-34-4-7v-3l-4-11v-5l-4-14-3-3-1-4-5-14-8-10v-1l-8-10v-1l-4-4-2-3-1-2-6-10 6 5q10 8 16 18c3 6 11 10 10 19l3 5 2 6 6 14 4 16 6 20 6 30v4z"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M948 976v-2l2 1z"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "#28201d",
    d: "M842 782q9-3 10 4zM801 769l4-1 6 1c-3 5-6 2-10 0M817 769q5-2 8 4z"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M771 780h14q20 4 38 11 25 9 43 29l2 3h-3l-2-1-6-7h-2l-3-4-3-2-1-1h-1l-4-3-22-12h-4l-2-1-5-3h-4l-8-3-5-2-4-1h-8l-5-1z"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M661 767h7l17 2h8l4 2h8l10 1 16 3h6l3 2h2l3 2h5l6 2h-8l-19-4-29-4-20-1-17-1-3-3z"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M687 769h-2v-2h19l24 4 29 7 9 1v1h-10l-8-1h-3l-3-2h-2l-3-2h-6l-26-4h-8l-4-2h-6"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M569 777h5l3-2h2l2 2-3 2-22 6-14 5h-2l5-5h2l3-2 13-4zM620 767h2l1 2-6 3-16 2-3 2-10 1h-5v-2h2l6-3 14-1 4-2h8z"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m661 766-1 2h-11l-2-1h-14v-1l9-2zM547 785h-2l-7 2 13-7 15-5 3 1-6 3-13 4zM497 804zl24-11 5-1v2l-3 1-4 3-5 1-6 4h-2l-4 3h-2l-4 1zM611 769h-2l-4 2h-16l22-4zM872 827l9 6 5 8-4-2-2-1-2-3-2-2h-2v-2z"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M685 767v2l-17-2z"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m623 769-1-2 6-1v3zM585 775h-8q4-2 10-3zM529 791l8-4v3l-6 1z"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m537 790 1-3 7-2-5 5z"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M865 823h3l2 3v1h-5z"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m585 775 2-3 2-1 2 1zM628 769v-3h5v1l-1 2z"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M617 769h-3l-1-2h4z"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M771 780zl-5-1zM529 791h2l-4 3v-2zM872 827l2 4h-2l-2-4zM613 767l1 2h-3v-1z"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M574 777h-2l2-2z"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M574 777v-2h3zM617 769v-2h3z"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M871 827z"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m886 841-5-8 7 5 1 1 6 10-6-4z"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M415 1358v-2q4-7 5-13-1-16-5-31-3-10-11-18-3-5-9-7-9-2-3-10l2-6-1-6 3 9q0 11 10 11v2l4 10 5 7q6 14 7 30l1 6 1 9 1 7 2 5v13l2 5 5 1c3-5 7-3 11-3q6 0 8 4t5 4q7 1 10 7 1 4 4 4 5 2 10 3l5 8 12 13q9 2 10 10l2 4 2-1v-9q1-12 10-20 4-2 8-3 5-3 6 2 3 9 12 10l2 2 2 8 3 2 10-3 2-3c2-9-1-19 6-27v-4q2-4 3-7v-2l3-10v-2l2-6v-7l5-9h3l-4 14-1 15q0 9-2 13-7 8-7 18l3 5q4-1 6-4l7-15 7-8v4l-3 3-4 9q-9 13-10 27l-1 7v5l-2 1c1 8-1 16 4 24q2 4 2 7l-8-10-3-18-1-9-5-5c-3 0-8 3-7 4q0 7-3 14h-2c0-7-4-6-8-5l2-9-2-3v-7l-4-4q-6 1-7-5-2-5-6-7-6-3-10 3l-6 15-2 20q-1 6-7 8l-1-3q2-9-6-15l-3-7-4-4q-9-2-9-12-1-7-9-8-7 1-7-7 0-5-7-6-8 1-12-7-6 5-1 9 3 3 2 5l-8 4 3 7q-6 2-9-3l-9-22-4 1-1-6q-6-8-4-16z"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m550 1432-2 9v19c-4 7-4 7 3 9l7 1q9 2 11 11-1 6 5 5v1l-2 2q-6 0-5-4l-1-3c-1-7-6-4-11-5h-2l-4-4c-7-4-8-6-6-14q3-5 2-11l-2-3q-8-6 0-14 4-4 1-7-2-3-5-2-4 4-5-2 1-6-5-8-2 0-6-4l-4 17q1 8-3 14l-1 8q5 16-9 25l-1 2-4 2v-23q2-6-3-12l-4 6-4 2-1-1q0-9-7-17l-3-11-2-5q-2-4-6-2h-5l1-4-2-10-5-2q-6-3-7 4l-4 8v10q-6-5-11-2c-1 1-6-5-6-9l-1-8-5 6q-4 3-5-2l-5-26 5 10 1-4 4-1 9 22q3 5 9 3l-3-7 8-4q1-2-2-5-5-4 1-9 4 8 12 7 7 1 7 6 1 8 7 7 8 1 9 8 0 10 9 12l4 4 3 7q8 6 6 15l1 3q6-2 7-8l2-20 6-15q4-6 10-3 5 2 6 7t7 5l4 4v7z"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M369 1237v-8c4 1 8 8 8 12 0 6 5 8 7 13l1-1 5 6-6 3 1 14 4 14q4 3 5 5c1 8 3 16-4 22q-2 1-2 4l2 5 4-3 8-15 4-3 3 4c-1 7 3 12 4 18 1 5 5 10 0 16v9l1 4-3 1-2-8q0-8-7-8l-7-5q-4-3-6-3l-4 5-3 7h-2l-1-12q2-6-3-6l-7-3 4-15 2-10v-25l-1-9q-5-11-2-22 1-2-3-6"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m414 1356-1-4v-9c5-6 1-11 0-16-1-6-5-11-4-18l-3-4-4 3-8 15-4 3-2-5q0-3 2-4c7-6 5-14 4-22q-1-2-5-5l-4-14-1-14 7-3 2 6 1 6-2 6q-6 8 3 10 6 2 9 7 8 8 11 18 4 15 5 31-1 6-5 13z"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "m494 1447 4-6q4 6 3 12v23l-3 7-1 7-3 5-2-5-2-22z"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m422 1384-1 4-5-11-1-19 2 4q-2 8 4 16z"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M849 1513q-2 5 1 11 2 5-6 9-2 1-3 5c1 8-5 9-10 12q-5 2-6 7l-4 7q-5 7-6 17h-6v-11c0-4-7-9-11-7q-5 2-2 5c3 7 3 7-4 8l-3 2q-11 5-12-6v-14l1-4 2-3q3 10 9 3l9-6q2-1 4 1 3 2 5-2 4-7 10-1 5 4 6-1v-12q-3-6 0-9l-2-6 5-1 3 2h3q8-6 17-7zm-31 46-4-13c-3 2-8 3-6 9q4 6 10 4"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "m780 1551-2 3-1 4q-5-4-11 1l-6 1c-4-1-14 1-17 4l-7 4-14 6q-3 2-4-2-1-8-7-2l-5 1q-5-3-11 2-4 3-6-3 0-11-14-7l-7-13-3-1-6-4q8 0 11-7c5 1 8 11 15 5 6 6 6 6 7 14q1 3 3 5 8 0 14-6l4-3q5 8 14 4l6 3 4-8q4-10 13-7h11q3 7 8 1l5-4h7v5zm-18 3v3l2-1z"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m659 1545 6 4 3 1 7 13q-2 4-6 3l-5-2q-3-6-5 0l-4 17c-4-4-10-4-9-11l6-5q5-6-2-10-6-4 0-10 4-3 9 0"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M659 1545q-4-3-9 0-6 6 0 10 7 4 2 10l-6 5 2-4c6-7 3-7-3-12h-4l1-8-1-6 3-5c2-4 6 0 9-1q5-1 5 4z"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m641 1540 1 6-1 8-5-1q-5-5-9 0l-2 3h-4v-3l-1-8 3-7h2c-1 7 5 5 7 6q5 1 6-4z"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "m623 1538-3 7h-5q-6-3 0-6l4-4zM659 1564q2-6 5 0z"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "M553 1477h2c1 6-1 13 3 19v5l-6 9q-3 4-6 0l-3-5-5 4-10-4-4-8q1-11-2-23-1-4 3-6 4-1 6 5l2 9 4 4q6 1 2 7 6 6 7-1l1-8 2-3z"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M574 1486q-6 1-5-5-2-9-11-11l-7-1c-7-2-7-2-3-9q4 6 6 0l2-3v-11h2c6 6 6 15 13 19l5 4 2-6-1-3 8 10v6q-7 0-8 7v1z"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "M577 1483q1-6 8-7l2 12v8l-2-1-2-3-1-7z"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m566 1482 1 3q0 4 5 4l-1 3-6 3-1-7z"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "m513 1493-4-2 3-2z"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m577 1483 5 2-5-1z"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M508 1503h3l-1 1z"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m572 1489 2-2z"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "m736 1633 1 2-8 3c-8-1-13 4-20 7l-7 3h-45l12-2v-1q-5-1-10-1c-7 3-11-2-15-4q-4-5 1-6h13l13 1 6 1q12 5 26 1l18-3z"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m513 1591-12-9-23-21-21-18-6-6 5 2 2 2 13 10 2 2 3 2 5 4 5 4h1l11 12z"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m614 1649-17-5-8-3h-1l-6-4h-1l-9-5-3-1-3-4h7l1 2 3 1 2 1 4 2 4 2 2 1 15 7 3 1h2z"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m513 1591-15-16-11-12h1l21 20 7 5 2 4zM426 1511l-5-8 4 1 13 19c-5 0-6-5-8-7z"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m527 1603-9-10h3l10 8 4 3 3 3-1 1h-3z"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "m623 1644 14 1q3 0 7 3z"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M537 1609zh1l2 1 1 1h1l4 6h-6l-2-2v-1l-2-3z"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m604 1643-15-7 12 3 2 2z"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m547 1617-4-6h4l6 3v3l-2 1z"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "m729 1638 8-3h5c-3 5-8 3-13 3"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M553 1617v-2l11 8zM531 1601"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m446 1533-7-7h2l5 5z"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M537 1609v2h-5l-1-3h6z"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M569 1627h-3l-2-4 5 1z"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m471 1551-6-6zM579 1631l-2-1-3-1v-2l7 4zM486 1563l-5-4zM604 1643l-1-2 4 3zM582 1631l5 3-4-1zM446 1533v-2l3 3h-2z"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m583 1633 4 1v1z"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m551 1614-4-3zM535 1604l-4-3z"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m582 1631 1 2-4-2h3"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M441 1526h-2l-1-3zM569 1627v-3l2 3zM546 1611h-3zM476 1555l-3-2zM458 1541l-2-2z"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M447 1534h2v2z"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m603 1641-2-2zM449 1536zl1 2z"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "M542 1611z"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M539 1609z"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M537 1608z"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m585 1495 2 1 4 5 2 1 12 15q3 5 8 3 5-1 7 2 8 10 15 5l4-5 3-3 3 2c1 7 7 6 12 8q8 1 12-8 5-7 8 1l1 4q3 5 8 7l3-3-1-10 2-4 4 2q5 3 8 8l3 1q8 1 13 4c8 5 8 6 16 0l2-2q6 5 9 1l6 4 3-5q1-7 8-5l3-1q4-2 10 1 3 2 7 2 3-1 7-5l-1-1 8-5 9 6c5-5-2-11 1-17l3 1 3 4 2 4 9-6h2v2q-14 9-10 26l-3 4c-4 0-9 5-13 0l-2-1c-3 3-6 0-9-1l-3-2q-3-4-8-3-2 2-3 1-6-1-8 4-4 7-12 4c-5-2-9-5-13 1h-1c-10 0-19 1-26-8q-3-4-8-2-5 3-7-1l-5-6-1 7 1 5v7l-4-2-12-5q-6 0-7-5l-2-4-3 5q-4 2-6 1c-9-7-9-7-19 0l-2 1q-8 4-14-1-2-6-8-5l-13-2c0-6-10-8-10-16l-7-6h-1l-1-4v-6"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M585 1497v4h-2l-1-2z"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m587 1505 7 6c0 8 10 10 10 16l13 2-2 6-14 10q-6-3-7-11l-1-18-3-6q-1-3-3-5"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "m615 1535 2-6q6-1 8 5v4h-2l-4-3z"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M583 1501h2l1 4z"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M369 1207v-3l-1-31 1-17q2-7-3-12-2-2-3-5c7 3 7-5 11-7l1 11 2 5v28q-1 4 3 4v35z"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "M363 1139q1 3 3 5 5 5 3 12l-1 17c-5-3-2-8-4-12-3-6-2-13-8-19q1-6 7-4z"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M359 1169v-4h2l-1 4z"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M359 1169zv5h-1z"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M359 1174h1l2 1-1 2h-2z"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "M364 1299v6l-1 4-4 7q-3 5-7 2-8-6-2-13l9-9z"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m363 1309 1-4z"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m369 1207 11 8 2 8q-1 8 1 13c3 6 1 11 2 17l-1 1c-2-5-7-7-7-13 0-4-4-11-8-12l2-7v-5z"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m359 1329-1-2h3z"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m357 1290 2-2z"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M862 625q-4-6 0-12zM862 611l1-5z"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "M819 569h2l3 1 6 9 3 5 3 9-1 6-5 2h-27q-5 1-9-3l-8-4-4-3 2-16q2-6 6-1 9 6 19 1z"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "m833 584-3-5 6 2h5v9c-6 1-5-4-8-6"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m753 584 6-1-2 4h-1z"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m746 1754 6 1c2 3 9 4 5 10v4q-6-2-10-6-2-2-1-9M852 1813l1-9 7-1-2 7-2 4-2 5z"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "#231b19",
    d: "m736 1748 3 3z"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M876 1809h1z"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "m435 1627-8-3-6-7-2-5h2l9 7 1 2z"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m421 1612-2-1-1-1 2-2 1 1z"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M679 1697h2l2 1h3l7 2 2 3-28-6h-11l-1-2-42-12-6-3 23 6 17 4 3 1h5c1 5 6 3 9 4h9z"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m607 1680 6 3 42 12 1 2-20-4-19-6-18-7v-3l2 1 3 2zM658 1697h9l28 6h2l4 4h-3l-37-8zM597 1680h-4l-26-8c-5-1-11 0-14-6v-1l2 1 2 1 36 11 2-1 2 1zM551 1666l-11-1-27-8v-3l7 2zM509 1655l-23-9 6 1 13 2 6 5z"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m479 1646-10-4 4-1h2z"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m479 1646-4-5 9 5h-5"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m551 1666-9-4q6 1 11 3v1z"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m473 1641-4 1h-2l-2-4z"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m465 1638 2 4-7-3 1-1zM509 1655l2-1h2v3zM482 1646h4l1 2z"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M597 1680v-3h2v3z"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M461 1638zl-1-1v-1z"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m437 1623-1-1-4-5 1-1 7 3q10 9 22 12 12 1 21 8v2l-23-7-11-4-3-3-3-1-2-2z"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m449 1630 11 4 23 7 3 1 4 1 5 2 7 4-10-2-6-1h-2l-9-5h-2l-8-3h-4l-2-1-12-7zM443 1626l3 1 1 3-10-7 4 1zM432 1617l4 5-5-1-1-2v-1z"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M766 1820c-3-4 0-6 1-9l4 2v9zM847 1841v2z"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M777 1686v3l-3 3q-6 12-10 24-1 5 2 11-2 9 4 17l-7 1v-2l-2-17-3-2-14-3 1 4-3 1-3-1-2-3q-2-9-13-11c-4-6-17-10-23-8h-3l-1-4 4-2q2-3 1-5-5-7-14-9-8-1-14-3l-1-1 5-2q9-3 19-1 4 0 7-4t8-1q7 4 15 1 8-2 17 1 4 1 6 5c1 6 9 8 15 10q9 1 12-7h2v1z"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m742 1726 3-1 4 6 14 12v3q-13-6-21-20M701 1703c6-2 19 2 23 8l-9-3h-8z"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m715 1708 9 3 8 7z"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m732 1718-8-7q11 2 13 11h-1l-1-1z"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m701 1703 6 5-6-1-4-4h4M736 1722zl2 3zM732 1718l3 3z"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "M779 1749z"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fill: "#f47b55",
    d: "m490 1582 2 1 3 2 2 2 2 3 5 2 15 11 8 8q9 4 13 13l4 3 11 1 13 17v1c-4 2-15-1-19-4l-13-8-1-1c-3-6-10-6-13-11l-4-2q-12-5-23-14-5-2-9-6-5-6-9-13-7-11-15-18l-2-5 6 1c5 9 16 10 22 16zM483 1639q-9-7-21-8-12-3-22-12l-7-3v-2l7-1q1-5 6-5l7 4 10 5h2l2 2 14 8h2q3 7 9 6h2l3 3h3l9 8q-7 1-15-3l-5-1h-4z"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M650 1690h-3l-5-3-16-6q-1-8-9-8l-11-5-6-3h-1q1-7-4-11-11-9-24-15-7-4-12-11l8 3 5 4h1l4 2h3l3 2 3 4 19 13c4 3 4 11 12 10 4 7 11 7 18 10s16 2 21 9q3 2 4 6h-7z"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "M595 1654q5 4 4 11h-11q-2-2-3-5-1-4 4-4 5 3 6-2"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m626 1681 16 6 5 3-17-4-23-6h-3v-3l13 2 4 2z"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M513 1654h-2l-6-5h3l5 2 2 1 14 4 2 1 6 4-17-5z"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m538 1661-7-4 22 4 3 2 2 2h-5l-11-4z"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "m567 1631-8-3h-1l-3-3h-1l-3-5 13 7z"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M561 1664h2l12 4 3 1 7 4-24-8z"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m585 1673-7-4 14 5v1z"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m529 1656-14-4h8l5 3z"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M521 1652h-6l-2-1v-3z"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m575 1668-12-4z"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m502 1649-7-4 10 3z"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M599 1677zl-3-3 8 3-2 1z"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "m600 1665 6 3z"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M513 1648v3l-5-2z"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m528 1655-5-3z"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M485 1640h4l1 3-4-1z"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m595 1674 3 3h-3l-3-2v-1z"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m601 1678 2-1h1v3z"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M561 1664zh-3l-2-2z"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m621 1681-4-2zM555 1625l3 3h-3z"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m556 1663-3-2z"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "m463 1617-10-5-7-4q-4 0-6 5l-7 1-4-3-3-4q-2-1-3-4-2-5-1-9 3-3 8 0l20 13z"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m426 1607 3 4 4 3v2l-1 1h-2l-3-2-6-6-1-1-1-2-2-3-6-7-3-5 4 2 8 11z"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "M492 1633q-6 1-9-6zM497 1636l-3-3zM481 1627l-3-2zM467 1619l-2-2zM555 1625v3l-11-1-4-3q-4-9-13-13l-8-8h4l3 4 3 1 3 3h1l6 3v1l2 2h1l3 3h2z"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M521 1603h-2l-15-11-5-2-2-3-2-2-1-2 4 1z"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "m529 1608-3-1-1-4h3l3 5z"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m498 1584-4-1-1-4z"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m525 1603 1 4-3-4z"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "m494 1583 1 2-3-2z"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m417 1606-6-6 6 3zM401 1591l-6-3zM406 1594l-4-3z"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M417 1606v-3l2 3z"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M475 534h7l-1 12c1 6-2 12 3 17l13 11 3 2q9 9 16-2l3-6 2 9-5 13-3 2q-9-1-12-3-6-12-19-9l-4 1q2-5 4-7 3-3 0-7-5-6-4-14 2-9-3-19M478 584l3 2-2 1z"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "M553 530q-2 6-6 10-5 3-8-2c0-5-2-11 4-15q4-3 6-2 3 2 4 6z"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M485 540q4-6 9-1l7 9 10 12q6 6 2 10-6 3-11-2l-8-11-7-8q-3-5-2-9"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M363 1139zq-1-4-5-4-7-4-13-9l1-3 3-1q14 2 14-12v-4q6-8 1-17 0-4 2-6 3-5 0-8c-7 7-5 16-9 24l2 4-2 11-3 1-3-3 1-6q2-4-1-6-3 0-5 3l-10 10-9-8-2-3q1-7-4-10v-4l-3-6-4 2-2 2-19 2q-3 0-5-3l-9-12q-2-2-5-3-7 1-7-8l-1-3h-1l-1 4-2 3-4-1q-5-4-5-11 2-5-4-6l-2-4 3-10 2-16v-6l4 2 4-1 1-5-2-3q-5-4-3-10 1-10-2-18v-5l6-9q7-8 3-17-4-7 0-15 6 1 7-6 0-6 7-6 11-1 8-13-4-11-6-23c1-5-5-9-7-14l-2-5-1-4q-3-6-1-13 1-4-5-6l1 7-1 5q-3 2-8 1-6-3-3-12l1-10q-1-7 4-12 3-4 0-10-2-7-1-15 1-3 5-6t1-8c-8-7-7-17-7-27q1-3 5-5l7-3 2-1h19q9-1 8-9v-6c8 3 9-2 9-7l7-20-7 1-4-1 1-4c4-6 4-6-2-9q-7-3-3-10l2-4q-10-7-6-14 3-8 11-8 6 1 5-4l1-9 3 2v2q-1 8 5 10l5-3c1 8 9 14 16 13l2-2 10-10q6-5 11 1l7 8v6l-1 2q3 8-1 15l2 5v4q-3 6-4 13v44q0 5 2 8 7 15 6 31-1 6 3 12 1 4-1 7-6 4-13 6-5 3-5 8l2 3 2-2 1-5h1l2 5 1 13c-1 6 3 14-5 18l-1 1-1 16-2 4-12 2q-2 8-6 12-5 2-13 2 0 8 7 11 4 2 4 6l1 6q2 6-6 7l-2 1v2l10 1 5 2-2 4-6 6 5 4 1 4q0 4 2 6 2 4 8 1 4-3 6 2 1 9 9 14v7q-2 6-7 13v15q0 5 4 5 3-1 5-3l2-2q6 1 8-3l-1 11 1 6 13-12q5 2 2 5-5 10-5 22-1 7-4 14 0 6-7 9c-7 2-10 13-7 19q5 10 5 22 1 3 3 5v3l-3 6v38l-2-5-1-11c-4 2-4 10-11 7m-74-346 1 3-1 25q-3 4-7 7l-5 3q-5 9-1 18 5 9 6 20 1 9 10 12 5 1 5 5l3 3 4-2 2-11 3-6q2-3 3-5 2-5 3-11l1-7-1-10 2-3q2-2 3-5 0-8 8-7 10 1 8-9l-2-4-3 3q-3 9-11 5-6-6-16-6-6 1-9-6l2-10c6 2 13 5 18-1h4q7 3 13 4c5-1 11 0 15-6q4-7 12-11c2 0 5-5 5-7l-5-15c0-3-4-6-2-10q3-3 3-8v-22q0-13 4-26l2-26c0-5-4-4-7-5q-4-1-6 1l-15 11-4 1-13-2q-4 0-3-4l-1-6-9-6q-12-2-12 8 1 4 4 6 3 3 2 8 0 5 2 6l12 4q10 0 10 10l3 6 2 7c-1 10-8 18-12 26q-3 3-7 4l-10 3-10 3q-10 1-11 12l4 28q0 4 4 5m22 127q1 2 4 3l4-1q2-2 1-4c-1-3-10-3-13 0z"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m262 858-1 5h-3l-1-4z"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "m313 642-3-2v-2z"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fill: "#332d2d",
    d: "m207 965 2-2z"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "m323 651-5 3q-6-2-5-10l4 3q6-4 2-10v-5l2 1 2 6 1 3v6z"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M380 1000q-2 4-8 3l-2 2q-2 2-5 3-4 0-4-5v-15q5-7 7-13v-7q-8-6-9-14-2-5-6-2-6 3-8-1-2-2-2-6l-1-4-5-4 6-6 2-4-5-2-10-1v-2l2-1q8-1 6-7l-1-6q0-5-4-6-7-2-7-11 8 0 13-2 4-5 6-12l12-2 2-4 1-16 1-1c8-4 4-12 5-18l-1-13-2-5h-1l-1 5-2 2-2-3q-1-6 5-8 7-2 13-6 2-3 1-7-4-6-3-12 1-16-6-31-2-3-2-8v-44q1-6 4-13l-1 24 1 33 4 17 4 20 2 11v15q-2 6 2 8 8 6 5 16c4 7 0 15 3 23q3 5 7 9 6 5 0 10l-17 16-5 2-2-6 2-5h-11l-2 2c2 6-6 12-1 19q2 4 1 8 1 3 3 5 3-1 5-3 3-6 8-3 7 4 12-2l5-4 11-4h3q5 2 9-3 2-6 6-10l5-5-15 26q-6 9-9 18l-5 20-6 21v4l-8 18-1 2-4 3z"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m428 886-5 5q-4 4-6 10l-21 2q-8-1-4-8l19-22v-5l-9-13-1-4 8 8 4 5 2 2v1l1 6-2 3q-11 7-9 18 5 5 10-1l6-6 6-8 4-5v3z"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m369 689-2-5q3-7 1-15l1-2q4 10 0 22"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m396 838 3 6zM399 844l2 5z"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m323 637-2-4zM323 651l1-3zM324 642l-1-3z"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "M849 1513v-1l2-5q6-2 5-8v-1l2-4h2c-2 5 0 10-4 15-2 1 1 8 3 10q4 2 11 1l2-1q5 4 0 8l-5 10-4 5v-2l2-6v-3l3-5-4-2q-10 3-11-7 0-3-4-4"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M865 1531v3q-5 3-2 6v3h-2q-6 0-4-6v-7l5-4z"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "m833 1569-5 2q0-5 5-2M842 1571q-2 5-5 0zM861 1543h2l-3 4zM835 1571l-2-2z"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M856 1498zl-5 6h-3c1-2 6-2 3-6v-4l6-8 4-8 3-5 5-11 8-12c3-5-1-13 7-17v-2c1-7 1-7 8-7h6l5 3 4 3 3-5q1-6 3-11c4-6 5-14 14-14l2-2 5-13 5-9-9 29-2 3q-8 9-10 20l-8 12-3 7-2 7-5 12-7 4-1-7 1-11-2-4-6 2q-2 6-8 8-8 8-11 19v1l-1 2-2 2-2 4-1 7h-2z"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M866 1478q3-11 11-19 6-2 8-8l6-2 2 4-1 11 1 7 7-4v3q-4 4-6 10-1 6-8 5-6-2-3-8l4-12-3-5-5 2-8 13zM861 1487l2-4zM865 1481l1-2z"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m939 1377-5 9-5 13-2 2c-9 0-10 8-14 14q-2 5-3 11l-3 5-4-3-5-3h-6c-7 0-7 0-8 7v2c-8 4-4 12-7 17l-8 12-5 11-3 4 3-13v-3l1-1q8-3 6-9l2-10q0-6 5-10 2-2 3-6 1-6 7-4h4q8 2 13-4l7-9 11-13 10-15 10-13v3l-3 3z"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m900 1465 5-10v2l-3 8z"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m940 1374 3-3z"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    fill: "#33201c",
    d: "M900 1465h2l-2 2z"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M660 1691q-1-4-4-6c-5-7-14-6-21-9s-14-3-18-10c-8 1-8-7-12-10l-19-13-3-4 5 2h1l5 5 8 4q13 4 23 13l4 1 23 1q12 0 14 13 0 6 8 6l10 4 2 1q4 1 3 4l-6 2q-2-4-8-2c-4-4-9-1-15-2"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m795 1645-2 5-3 6-11 9-6-6-7-3 2-2c8 3 9-4 12-7q5-8 15-11z"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M698 1703zh-2l-2-3v-1h4z"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M693 1699zl-7-2zM679 1697l-6-2z"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m785 1671-2 3z"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m683 1698-2-1z"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M766 1727q-2-6-2-11 3-12 10-24l3-3v1l-5 14q-6 10-6 23"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m790 1656 3-6z"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m777 1686 2-4z"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M947 1325q1 16-8 31-5-6-6-10t-4-4q-5 0-5-5v-30l8-37 3-23 4-34c1-13-4-25-6-38q-1-11-5-22l1-5-1-27 4 7 3 33q1 8 3 14l3 11 2 5q4 7 3 15 1 3 1 8-1 10 1 20l1 8-1 11v3q2 9 1 18l-3 16v4c3 10 0 20 1 31"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m928 1121 1 27-1 4-2-19q0-9-6-10c-4 0-13 8-15 11l-13 16-18-3h-3q-6-5-16-5l-11-3-12-2-10-3q-6-2-8 3 0 12 7 21l3 9 1 5 11 26 9 23-4-2v-1l-1-3-16-29-9-18-8-19-3-17-4-7-6 6 1-6 3-6 1-7h2v1l5 7 2-7c14 5 27 11 41 8q3 3 0 6-4 8 5 8l14 2c7 3 12-2 18-3l2-6q-2-6 4-7 7-3 14-2l20-2z"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m893 1116-10 3q-15 5-29 0l-5-1-10-3-11-4v-4l-4-7-3 1h-2l-2 2-1 3-1 4-3-1v-2q4-11 15-11l2 2 1 5q2 5 5 8 15 6 32 6l4-2 4-4q-2 7 4 6l12-4q6-2 9-8h1v2l-1 2-1 3z"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m828 1112 11 3 2 1 8 2v3c-14 3-27-3-41-8v-2l4-1h3l4 2q5 5 9 0"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m893 1116 6-4 20-1 4-3q1-2-1-5l-3-3q4 2 7 6 1 7-6 7h-4l-3 2h-9z"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M904 1115h7zM913 1115l3-2z"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M936 1039c7 4 5 11 6 17l-1 4q0 9-6 17-7 4-15-1l-11-7-6-3-8-5h-4l-4-3-16-1-9 1h-21l-15-1q-12-3-20 0-4 0-6 4l-11 13 1-6 4-8 4-1q4-6 11-7 3-1 5-3l10-4h14q10 4 20 9l5 1h22q10-2 18 3 9 5 20 9 12 3 15-10 3-10-2-18"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m913 1083 2 5 1 6-3-2q-11-8-24-11-3-4-8-3l-8-1-10-1q-8-5-14 1h-4l-5-2 4-6 5-2 10-2h8l9 2 7 1 20 8 6 5z"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "M843 1062h6l-10 7q-4 1-7 3l-16 11-10 9q-5-3-2-6 7-12 21-18l16-6z"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M839 1069h5l-4 6 5 2-16 5-1-2 4-5z"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m903 1076-20-8-7-1-9-2h13l13 5q6 2 10 6"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m862 1058 9-1 16 1 4 3zM843 1062h-2v-4h13l-6 1z"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m859 1065-10 2v-1z"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m895 1061 8 5z"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m909 1081-6-5z"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M849 1066zl-5 2z"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "m892 1150 13-16c2-3 11-11 15-11q6 1 6 10l2 20q4 11 5 22c2 13 7 25 6 38l-4 34-3 23-8 37v30q-1 5 5 5 3 0 4 4t6 10v2q-7 3-6 8v2l-1 2-2 1-11-26-2-1-23-17q-6-6-3-14 5-6 11-5 10-1 12-7l1-14 2-11 2-7c2-9 1-19 7-27l1-3q0-11 3-23c1-7 4-15 0-22l1-5q2-11-4-20c-5-10-11-21-9-33l1-2q5-3 0-4l-6 1-3 8q1 8-6 9l-3 1z"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m901 1149 3-1q7-1 6-9l3-8q-3 8 5 5c-2 12 4 23 9 33q6 9 4 20l-1 5c4 7 1 15 0 22q-3 12-3 23l-1 3c-6 8-5 18-7 27l-2 7-2 11-1 14q-2 7-12 7-6-1-11 5-3 9 3 14l23 17 2 1 11 26-6 11q-7 13-19 22-8 7-11-5l-1-4v-2l3-8 1-8h2l2-1c3 6-1 10-3 14q-3 5 2 8 5 1 8-2 8-7 12-16 3-4 2-9-2-7-8-13h-1l-9-2-3-8-4-3-5-15q-5-10-18-8l-8-3q2-3 5-4c3-1 7-7 5-10l-10-14q-7-6-7-15l-2-3-3-11 6 8q4 10 11 18c4 5 4 13 10 18q4 8 10 3 7-6 16-8l4-2-2-3q2-5 1-8-1-7 4-12l3-6q-1-7 2-14l3-29c1-6-2-13 4-18l2-4-1-4q-8-4-3-11 4-13-6-24c-3-5-7-10-3-16v-2z"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M905 1418q-5 6-13 4h-4q-7-2-7 4-1 4-3 6-6 4-5 10l-2 10h-4q0-12 5-19l4-8 8-19q4 2 4-3-1-5 3-7h1v6l-2 14c3 7 9 2 15 2"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "M924 1382"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M933 1366q-1-5 6-8z"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M892 1396zl2-9v8z"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m932 1370 1-2z"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m919 1100 3 3q2 3 1 5l-4 3-20 1 1-3h2l9 1q11-1 7-9v-1z"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "M918 1100zq-2 8-10 6h-6v-2q2-5-3-6v-1q-6-8-13-8c-7-1-11 8-18 4h-7l-4-2q-5-3-8-1l-2 5q3 4 6 4 8 1 9 8 3 8-4 6l-13-4-1-6-2-5-6 2-5 2-1-6q-2-9 7-10 3-1 4-3h4l2-1h35q6 6 14 5l2 1 13 8z"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M889 1081q14 3 24 11l3 2-1 1z"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m887 1082 6 3 24 14-7-2-13-8-2-1-11-5 1-1z"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m912 1409-7 9z"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "m931 929-1 4 8 39 3 31-20-24h3l8 9 5 5 3-1c-6-23-8-48-15-71l1-1 5 7z"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m933 1030-4-3-1-2c7 2 7-1 9-6s-3-7-4-11l-5-14h3v1l4 8 4 6v2l1 6 2 2 1 2-2 8z"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M945 975v15l-2-3-4-22-3-23 5 19z"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m945 975-4-14-5-19v-3l-1-2v-3l4 7z"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M931 994h-3l-2-4-4-5-7-5h6zM935 1003l-4-8z"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M935 934zl-4-6v-2l1-1 3 5zM935 1003zl3 6zM945 993v3zM935 937l1 2z"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m942 1019-2-2z"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "M936 1039q5 8 2 18-3 13-15 10-11-4-20-9-8-4-18-3h-22l-5-1q-10-5-20-9h-14l2-5 5-4h7l7-3h5q4 11 14 12l25 2 14 2 17 7q12 6 14-8l1-10z"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "m860 1029 27-5 27 1q8 3 15 8v9l-3 3q-10 0-19-3-3-2-8-2h-7l-6-1c-9 3-16-5-24-7z"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "m860 1029 2 3c8 2 15 10 24 7l6 1h7q5 0 8 2 10 3 19 3l3-3v-6l2-1 4 3-1 10q-2 14-14 8l-17-7-14-2-25-2q-10-1-14-12v-2h2l5-2z"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m915 980 7 5 4 5h-1q-15-8-28-1-10 5-21 4l-15 2q-3 2-7 3-7 0-14 4l-10 5c-6 4-14 6-17 14q-4 4 0 9t11 2l10-2 14-5h3l12-3 33-3 1-1h4l6 1 21 6 1 2-4-1c-15-7-30-5-44-4l-40 9-5 2-5 1-2 1h-9c-13 0-15-2-11-14v-2l6-8h2l2-2 4-1 2-2 9-5 15-6q10 0 17-6h2q10 1 19-1 7-2 15-8z"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m845 1033-7 3v-3h7M857 1029l-5 2z"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M839 1033h-3l5-2z"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "m931 1035-2 1v-3z"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M850 1031v2h-2z"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    fill: "#312724",
    d: "m928 625-7 7q1-6 7-7M921 633l-3 4v-2z"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M918 635v2h-2z"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "M940 628q0 7-4 11-5 4-8 1-2-3-1-8 0-3 4-5 4-6 9 1"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M289 1209v-4l-4-18-4-12v-3l3-11q3-6 11-5c8 3 16 6 16 16q0 8 8 9l6 4q-10 0-14 11v2q-1 6-6 5-5-3-5-8l5-19q3-13-10-13-6-1-6 6v26l4 25-1 7-3-5v-13"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1997a",
    d: "m329 1203-8 1q-5 1-5-4l2-9q5-6 11-1l4 3 1 3-1 4h-1z"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M330 1184q6 0 3-4l-2-4 8 11-4 4h-2l-2-4z"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M333 1191h2l1 2c3 6 3 6-4 10v-3h1l1-4-1-3zM327 1185l3 2zM331 1203l-3 2 1-2z"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "M347 1231h-2l-2 2h-3l-9 4q-6 4-11 0-7-6-6-13l2-9h1l4-3 14-7 7-9 5 7 5 17q2 6-5 11m-9-23-7 5q-2 4 1 8 6 6 14-1 3-6-2-12-2-3-6 0"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m316 1215-2 9q-1 7 6 13 5 4 11 0l9-4v2l-1 1-7 3c-7 5-8 5-15 0-6-5-8-15-5-21z"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m339 1237-4 4z"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m321 1212-4 3z"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M331 1203h-2l3-3v3z"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m329 1171-3-3zM331 1174l-2-2z"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m362 1269-2 4-3-2z"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M340 1235v-2h3l-1 2z"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m347 1283-4-2-2-6q1-3 5-3l7 1q7 3 6 9-3 5-9 1zM321 1177l8 6z"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m288 1212 1 5h-2z"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M287 1217h2v5h-1z"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "m343 1233 2-2z"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M892 801q-4 4-7-3h7z"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M768 719v3l-2-1z"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M647 755q-14-1-29 5-7 2-15 2c-8 1-17 0-24 6q-4 2-10 2-18 2-34 11l-7 2q-12 4-23 11l-8 2-7 1q-6 6-14 4l-7 2-4 12v2l-4 3-6 6v-9h-3l-3-3q2-4 4-3 4 2 6-3 0-5-6-3l-2-1-5 4q-1 6-6 7l-6 3-14 15-3 7q-7 14 6 22 4 3 7-3l5-6q-2 10-9 16-2 4-6-1l-11-14v-14c0-7 6-11 10-15l1-1 18-19 2-4c0-7 4-7 9-8q6 0 11-5l13-10 9-8v-1l17-12c2-2 8 1 12 1l6 2q3-1 4-3l-4-3-4-2 5-3 10-5c7-2 14-6 21-3q6 3 10 9l4 3-1-3c-4-8 2-16 10-18q10-4 8 8c0 10 9 18 18 16l3-2q5-5 11-5l10-3q2 0 3-4v-5q-3-9 5-11 6-5 12 0 3 3 5-1l4-4q3 1 5 3l6 6 3 1q5 3 5 9-3 6-10 5-6-1-7 8z"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "m409 854 11 14q4 5 6 1 7-6 9-16l1-5 1-2 1-2 6-6 2-1h3l-9 13-3 5-4 16-2 3-4 5-6 8-6 6q-5 6-10 1-2-11 9-18l2-3q4-4-1-6v-1l-2-2-4-5v-5"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M767 534v3l-6 5-4 3q0-9 10-11M755 555l-4 6-2-1 7-12z"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "m753 584 3 3q-4 5-6-3z"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "M647 575v-2z"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m755 614 4-4 7-11q3-2 5-1l2 4-1 5-8 10q-5 7-9-2z"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M764 754q-5 0-5-4 7-3 5 4"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m692 705 3-3 1 2z"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m711 725 2-1z"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fill: "#28211f",
    d: "m751 619 2 3z"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m457 721 2-2 1 2z"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "m428 886 3-9 4-1-1 4-6 15-5 31-5 43-3 10-4 2-4 3 1-4q4-6 1-13v-9l2-10q0-4-4-2-8 6-9 16v2l-5 7 6-21 5-20q3-9 9-18z"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m418 969 5-43 5-31 6-15 1-4 12-24 4-11 22-25q3-4 8-6l16-6v3l-3 2h-2q-18 7-29 22l-1 4-4 2c-8 6-9 17-14 25q-6 15-11 29l-2 4q-3 15-4 28 0 18-5 36z"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "m465 815 4-12 7-2q8 2 14-4l7-1-12 8-6 3z"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "m455 826 6-6v2l-12 14v-2z"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e100e",
    d: "M461 822v-2l4-3z"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M449 834v3h-3z"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1612",
    d: "m431 874 2-3z"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c120f",
    d: "m824 570-3-1z"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M931 926zl-5-7v-2l-9-21-1-2-3-6-1-5-1-3-2-3v-2h3v1l9 21 6 10v5l4 6v7"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m927 907-6-9-9-21 7 12 4 5 1 4z"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m889 845 6 4 1 2 2 3 4 4v1l1 4h-3v-1l-5-6-4-5z"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m923 894-4-5-7-12v-1l-2-6 8 10zM927 908l-3-10 3 3 4 14-4-2z"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m910 870 2 6h-3v-1l-3-4-3-5v-2z"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m910 869-7-5v-1l-1-4zM932 926l-1-6 4 11z"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m927 913 4 2v4z"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m902 858-4-4zM898 854l-2-3z"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m766 780 5 1 5 1 5 1h8v2l-2 1-26-3-3-3z"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m787 786 2-1h4l5 1q3 6 8 3l4 1v3l-12-1q-3-2-7-3-4 1-4-3"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M817 793h4l22 13h-2l-6-3-4-2-14-6z"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "M855 815h2v4h-3c-1-3-7-1-4-6z"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M857 819v-3l6 6-4-1z"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "m859 821 4 1 2 1v4l-6-2z"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M806 789q-5 3-8-3z"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "M841 806h2l4 2h1v1q-6 3-7-3"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M810 793v-3l5 2-3 1z"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m855 815-5-2v-2h2z"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m781 783-5-1z"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M812 793h5v2z"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m847 808-4-2v-1zM793 784l-4 1v-2zM852 811h-2l-1-2zM787 783h-2zM848 809z"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "M787 786q1 4 4 3 4 1 7 3l-6-1-33 2c-5 0-9 4-13 4l-19-2q-12-4-25-1l-1 1-20-4q-13-4-26-3-4 1-7-2c-3-1-5-5-8 0l-2 1h-6l-18-2q-8 1-15-3h-4q-9 3-7-5l10-1 3-2 16-2 6-3h24l2-1 10 1 4 2 17 1 20 1 29 4 19 4h8l2-1 3 3zm-154-7-1 4h2z"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m693 769 4 2zM702 771h3zM742 777l3 2zM737 775l3 2zM687 769h2zM748 779h2z"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M588 777q-2 8 7 5h4q7 5 15 3l18 2h6l2-1c3-5 5-1 8 0q3 2 7 2 13-1 26 3l20 4 1-1q13-3 25 1l19 2c4 0 8-4 13-4l33-2 6 1 12 1h2l5 2q0 7 7 7l7-1 4 2q-3 3-7 3c-4 1-9 0-12 5l-11-1-24 3-4 3 4 5 5 4c6 9 5 9 16 7q10 0 16 8t13 15q4 3 4 7v28q0 9 7 5 9-2 10 4 3 8 9 11 6 5 5 11t5 9l2 1q6 5 4 13c-1 7 10 5 9 12l2 1 13 1 4 3 6 3 9 4v1q-11-2-23-1-4 0-6-2-4-3-8-1h-5l-10-14q-2-3-5-4c-6-1-6-6-9-10q-2-4-5-5l-22-1q-9 0-10-8l-2-7 1-3q4-12 1-23-1-4 1-6 5-4 4-10-1-2-3-5l-4 5v4l-2 4-3-4q1-9-7-9-5 0-5-6l1-5-1-4q-5 0-8-6l-3-3q-6-3-10-9-2-3-7-4l-8 1-12-2-10-3h-5l2-5-18-3q-5 1-5-4l-2-2-15-2-92 2-4 1h-9q-5-3-8 2l-3 2h-10q-5 2-7 5l-2 12c-1 7-1 7-8 7h-2q-9 2-15 6c-4 4-11 7-9 15l-6 5-4 2 2 7q0 9-2 17-4 8-5 17-3 6-3 13 1 16-11 28l-2 2c1 7-5 10-7 15l-4 8-3 3-9 12-7 14-3 2-5 6-3 9-5 4q-7 3-6 9l-1 8-4 3q-5-2-8 3c-1 1-7 0-7-1l-1-13 2-20q0-12 8-20 11-14 13-32v-5l-4-4-3 3q-2 9-11 12l1-8 4-3c3-8 9-15 4-25v-6l3-4 2-4 1-7 1-14q1-7 4-13l5-25c3-15 15-25 26-35q9-9 23-10l2-2q6-8 15-11l3-5 8-3 1 1 1-3h3q5 1 6-4l14-5 22-6 3-2h7M451 978l-1 3q2 10-6 13l-2 3-3 4q-7 4-7 11v10q-1 6 4 8 5 0 8-6l5-3 6-4 6-12q2-2 1-5l-4-8v-8l5-1q6 0 8-5c4-3 6-8 12-7l2-4 6-6q5-2 4-8v-5l3-7 1-11v-36q0-6 2-8 6-6 3-14c-2-9 0-18 12-18q5-1 7-5 4-8 13-9 4-1 4-4l2-5 12-12 7-9-3-5c-5-2-15 2-16 7q-2 6-8 5-4 0-6 3-9 8-21 6-3 0-6 2l1 4q2 3-1 4l-14 7-7 5v11q-5 10-13 17-8 5-9 15l-3 6q-10 9-6 22v17l2 25z"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "M542 790q-1 5-6 4l1-4h5"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M583 777h-2l-2-2h4zM547 785l3-2zM605 771l4-2z"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m601 774-3 2z"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M647 769h-15l1-2h14z"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M647 769v-2l2 1zM492 809h2l3-2 4-1v3h-1l-9 6h-1l-6 4h-1l-2 2-3 2-5 2 13-11z"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m537 790-1 4h-3l-2 2-8 3-1-1 5-4 4-3zM515 799l5-1-7 5z"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m515 799-2 4h-4z"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M509 803h2l-4 3v-3z"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M507 803v3h-4z"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M503 806h2l-4 3v-3z"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m524 795-2 3h-2z"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "m869 827 3 4 2 2 2 2h2l2 3-1 3q-5-4-8-5c-7 1-6-2-5-6v-3z"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m889 845 2 5-9-7v-4l4 2z"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M882 839v2h-3l1-3z"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M878 835h-2v-2z"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M876 833v2l-2-2zM874 833l-2-2h2z"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "M866 827v3c-1 4-2 7 5 6q3 1 8 5l3 2q3 9 10 14h3l1 4 4 4v4l2 1 2 3 1 2 3 4v2q0 5 4 3l1 5 3 6 1 2c0 5-4 9 0 13l9 8v2l-1 1-3-1-5 16-1-6v-5q-2-3-3-7-1-5-5-8l-3-4-4-16-2-1-11-11q-2-1-3-4-2-5-7-6l-4-3q-5-16-19-25l-5-7h7l3-2-3-2h-9l1 4-7-2c-6-7-15-7-22-11l1-4 2-1-2-1-5-3c3-5 8-4 12-5q4 0 7-3l6 3q0 6 7 3h1l1 2v2c-3 5 3 3 4 6l5 6 6 2zm-35-7 3-1-4-2z"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M406 1287v-2l-8-21-5-10v-2l-2-13v-4l-1-3v-4l1-3 4 16v4l9 30 3 2v1l10 19c4 6 4 13 10 18l5 8q4 4 2 8t1 8l5 2q8-3 6 5-1 4 4 5 4 2 7 6c3 3 2 9 6 11q3 2 4 6l7 6 13 3q6 4 6 11 2 4 6 7l5-4 2-3 2 4 3 6 6-3 8-6 7-2h1l-1 3-2 2q-14 3-17 16l-2 3-4-2-3-4q-3-5-8-3-3 1-4-1l-5-9q-4-10-12-5-6-5-8-11-2-3-6-4-5 0-6-4l-5-4q-8-2-9-11 1-6-5-7l-3-3-5-10q-2-2-3-5 1-12-5-24l-6-12z"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m406 1287 8 11 6 12q6 12 5 24 1 3 3 5l5 10 3 3q6 1 5 7 1 9 9 11l5 4q2 4 6 4t6 4q2 6 8 11l7 6q-5-1-10-3-3-1-4-4-3-6-10-7-3 0-5-4t-8-4c-4 0-8-2-11 3l-5-1-2-5v-13l-2-5-1-7-1-9-1-6q-1-16-7-30l-5-7z"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m482 1399-7-6q8-5 12 5l5 9q1 2 4 1 5-2 8 3l3 4 4 2 2-3q3-12 17-16l2-2 9 4 12 11 21-20v1c-7 8-4 18-6 27l-2 3-10 3-3-2-2-8-2-2q-9-1-12-10-1-5-6-2-4 2-8 3-9 8-10 20v9l-2 1-2-4q-1-8-10-10l-12-13z"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m599 1383-7 8-7 15q-2 3-6 4l-3-5q0-11 7-18 2-4 2-13l1-15 4-14v-2l1-2 3-1h2l-5 8-1 31 2 3 3-2 14-11v2l-2 4-1 1-3 2z"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m577 1460 1 3-2 6-5-4c-7-4-7-13-13-19q3-7 3-14c-1-1 4-4 7-4l5 5 1 9z"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M533 1393zl1-2c6-3 12-7 18-4h3l9-2q7 0 8-8l2-7 7-19 2-5h3l-3 10q-8 9-5 19v2l-2 5-3 4q-2 8-11 10l-5 2q-3 3-6 0-7-6-17-5"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M587 1496v-4l4-4q0-14-6-26l-3-8-1-16v-5l1-7q1-14 10-27l4-9 3-3c-3 12-11 21-13 33q-4 18-1 34 2 8 6 17l1 6q9 12 7 26l-2-2c-1-7-1-7-8-5zM533 1393q10-1 17 5 3 3 6 0l5-2q9-2 11-10l3-4-1 6v3l-21 20-12-11-9-4z"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M556 1446v11l-2 3q-2 6-6 0v-19c4-1 8-2 8 5M393 1254l5 10 8 21q-10 0-10-11l-3-9zM581 1438l1 16 3 8q6 11 6 26l-4 4v-4q4-9-2-15v-3q0-3-2-7c-5-8-3-16-4-24z"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M577 1375q-3-10 5-19v5l-2 6v2z"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m577 1375 3-6-3 10v-4"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m582 1354 3-8 2-1z"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m574 1388 1-6 2-1q-1 4-3 7"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M599 1383zl4-1v3l-2 2-2 1z"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m582 1426-1 7z"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m580 1367 2-6z"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m577 1381-2 1 2-5v4"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m550 1432-2-3z"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M590 1343v1l-3 1v-2z"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "M385 1253c-1-6 1-11-2-17q-2-5-1-13l1-10 2-4v6l3 20 3 24h-1z"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m391 1259-3-24-3-20h2v2l3 11v4l1 3v4l2 13v2z"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c2a20",
    d: "M848 1505h3v2l-2 5q-9 1-17 7h-3l-3-2-5 1 2 6q-3 3 0 9v12q-2 5-6 1-6-6-10 1-2 4-5 2-2-2-4-1l-9 6q-6 7-9-3l1-4v-5h-7l-5 4q-5 6-8-1h-11q-9-2-13 7l-4 8-6-3q-8 4-14-4l-4 3q-6 6-14 6-2-2-3-5c-1-8-1-8-7-14-7 6-10-4-15-5q-3 7-11 7l-1-7q0-5-5-4c-3 1-7-3-9 1l-3 5h-3l1-5 2-1c10-7 10-7 19 0q2 1 6-1l3-5 2 4q1 6 7 5l12 5 4 2v-7l-1-5 1-7 5 6q2 4 7 1 5-2 8 2c7 9 16 8 26 8h1c4-6 8-3 13-1q8 3 12-4 3-5 8-4 1 1 3-1 5-1 8 3l3 2c3 1 6 4 9 1l2 1c4 5 9 0 13 0l3-4q-4-17 10-26h2q-1 6 5 4l10-3z"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "M818 1559q-7 2-10-4c-2-6 3-7 6-9z"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m762 1553 2 3-2 1z"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m639 1535-1 5q-2 5-6 4c-2-1-8 1-7-6v-4q6 5 14 1"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M585 1473q6 6 2 15zM554 1460l2-3z"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M573 1635zv-3l9 5h-4z"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M572 1632v3l-5-4h2z"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m588 1641-5-2-1-2zM569 1631h-2l-3-4h2z"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m574 1629 3 1z"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "m582 1637 1 2-3-2h2"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m531 1608-3-5 6 5z"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m539 1614-6-3h4zM545 1620l-3-3h3z"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M545 1620v-3h2l1 2-1 1z"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m541 1617-2-2z"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M566 1627h-2l-13-7v-2l2-1 11 6z"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M551 1618zh-3l-1-2z"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M529 1608h2l1 3z"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m809 1505-3-1c-3 6 4 12-1 17l-9-6-8 5 1 1q-3 4-7 5-4 0-7-2-6-3-10-1l-3 1q-7-2-8 5l-3 5-6-4q-3 4-9-1l-2 2c-8 6-8 5-16 0q-5-3-13-4l-3-1q-3-5-8-8l-4-2-2 4 1 10-3 3q-6-2-8-7l-1-4q-3-8-8-1-4 9-12 8c-5-2-11-1-12-8l-3-2-3 3-4 5-2-11q2-7 7-4l15 11q6 5 8-3v-5l2-4 11-5 5 16 3-1 8-15 4-3 8 3v5q-2 8 4 12c2 2 3 5 5 1h2l8 2h3l3 1 12-1h2l12-6q7-2 7-8 1-6 7-3l2 5 11 11 5-12 13-3 1-10 8 2z"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m633 1516 2 11q-8 5-15-5-2-3-7-2-5 2-8-3l-12-15-2-1-4-5h2c7-2 7-2 8 5l2 2v2c0 6 6 7 9 8q9 0 14 8l4-2 3 4zM809 1505v-3q6 3 11 3c9 1 17 3 25-4l4-5 2-1v4l-9 7q-6 5-13 3l-4-2h-2l-11 2z"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m812 1509 11-2-9 6zM825 1507l4 2h-4z"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M377 1148v-38l3-6v14l1 11v18l-1 3-1 7 3 5-2 18q-4 0-3-4zM385 1209l-2 4-1 10-2-8v-21l1 4 4 4z"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m385 1202-4-4-1-5v-4l2-2 3 2v4l2 3-1 3zM380 1180h1l1 5h-2z"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M380 1185h2v2l-2 2z"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m427 1615 3 3v1l-9-7z"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m427 1615-6-3v-3z"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M650 1691h3z"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M558 1665h3l6 3 18 5 7 2 3 2-2 1-36-11-2-1z"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m485 1640 1 2-3-1v-2zM447 1630l-1-3 3 3zM443 1626l-2-2z"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m763 1743-14-12-4-6-1-4 14 3 3 2z"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "m499 1590 5 2zM495 1585l2 2z"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "m573 1635 4 2z"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M548 1619h3v1l3 5-7-5z"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2524",
    d: "M289 792q-4 0-4-4l-4-28q1-11 11-12l10-3 10-3q4-1 7-4c4-8 11-16 12-26l-2-7-3-6q-1-10-10-10l-12-4q-2-1-2-6 1-5-2-8-3-2-4-6 0-10 12-8l9 6 1 6q-1 4 3 4l13 2 4-1 15-11q2-2 6-1c3 1 7 0 7 5l-2 26q-4 13-4 26v22q0 5-3 8c-2 4 2 7 2 10l5 15c0 2-3 7-5 7q-8 4-12 11c-4 6-10 5-15 6q-7-1-13-4h-4c-5 6-12 3-19 1v-4q0-5-4-5-2 1-3 6"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2624",
    d: "M289 792q1-4 3-6 3 0 4 5v4l-1 10q3 7 9 6 10 0 16 6 8 4 11-5l3-3 2 4q2 10-8 9-8-1-8 7-1 3-3 5l-2 3 1 10-1 7q-1 6-3 11-1 3-3 5l-3 6-2 11-4 2-3-3q0-4-5-5-9-3-10-12-1-11-6-20-4-9 1-18l5-3q4-3 7-7l1-25z"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M380 1101q-2-2-3-5 0-12-5-22c-3-6 0-17 7-19q6-3 7-9 4-7 4-14 0-12 5-22 3-3-2-5c2-3 1-8 6-9l1 3h1l-2-3 2-6 5-3 1 9-1 3-5 8q-9 12-8 26l2 2v3h-2q-2 3-3 5l-5 24-2 19z"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "m401 990-2 6c-5 1-4 6-6 9l-2 2-6 6q-5-1-3-4l2-11v-3l1-2 5-6h1l1 6 6-2z"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m380 1101 3-15 2-19 8-29-8 43v16l-2 13h-3v-9"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "m311 920-4-2c3-3 12-3 13 0q1 2-1 4l-4 1q-3-1-4-3"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "m384 998-2 11q-2 4 3 4l-5 4-1-6 1-11v-2zM391 1007l2-2z"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m401 990-3 1-6 2-1-6 3-4c0-3 3-5-1-7v-1l1-1 4-13 7-6 1 1c-2 11 0 23-5 34"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M393 975zl-3 11-5 6z"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m398 964-4 10-1-3z"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "M384 998h-4l4-3z"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1411",
    d: "M415 867q5 2 1 6zM413 864l2 2z"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M851 1507v-2l5-6q1 6-5 8"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "M863 1540q-4-3 2-6z"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m856 1498 2-4z"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m864 1465-3 14-4 8h-2l5-15z"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m842 1506 9-7c3 4-2 4-3 6z"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M855 1487h2l-6 8 2-6z"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m864 1465-4 7-5 15-2 2-4 7q-6 4-11 6l-10 1q11-5 19-12 8-8 10-21l3-9v-6l2 2 2 5z"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M867 1452h4q2 6-6 9z"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m867 1452-2 9-1 1-2-5 3-6z"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    fill: "#e07a58",
    d: "m901 1149 14-1v2c-4 6 0 11 3 16q10 11 6 24-5 7 3 11l1 4-2 4c-6 5-3 12-4 18l-3 29q-2 7-2 14l-3 6q-5 4-4 12 1 3-1 8l2 3-4 2q-10 2-16 8-6 5-10-3c-6-5-6-13-10-18q-7-8-11-18l-6-8-2-6-1-21c4 14 7 28 20 36l1 3 6 6q2 2 5 1 5-5 11-2 7 2 9-6l1-4q3-7 4-14c0-11-1-23 5-33l-1-3q-8-7 1-14l3-3 4-18-2-3-4-7-6-5-9-5-5-4-13-1-25-7q-5-1-6 4l3 16q5 10-3 17-3 2-4 6l-2 9q-1 5 1 10 6 9 6 19l-5-5v-5l-1-2-9-23-11-26-1-5-3-9q-7-9-7-21 2-5 8-3l10 3 12 2 11 3q10 0 16 5h3l18 3zm-53 2-1 1 1 1z"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m794 1131 6-6 4 7 3 17 8 19 9 18 16 29 1 3-12-15-14-26-3-3q-2 3-1 5l11 33c2 4 3 10 9 10s7 6 10 9q1 3-1 5-6 5-13 9l-12 6-6 5-10 1-6 1h-20q-3-1-4-3l-13-5q-1-1-3 1l-4 1-4-1-7-2h-1l-5-2h-25l1-3h27q9 5 17-1 4-3 7 0l11 6 13 3 10-2 21-12q7-4 7-11l-3-13-7-20-9-24-1-4-4-8 1-5q1-8-3-14z"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m749 1252 4-1 20 11 9 7q4 5 10 3 5 0 6-4l4-5 7-7 6-5 12-6q7-4 13-9 2-2 1-5c-3-3-4-9-10-9s-7-6-9-10l-11-33q-1-2 1-5l3 3 14 26 12 15v1q4 10 4 19l1 3v5q-3 7-8 11l-29 19-4 5v4h-1l-4-3-1-1q-1-5-5-3h-9l-10-9h-2l-7-5-1-2-3-2h-1l-2-2-2-1-2-2h-2zm91 0 3-6-3-2-11 5h-1q-17 8-30 22c7 5 17 2 20-4h2l4-5h2l12-10z"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "m794 1131 1 8v10q-6-7-6-16l-2-8-2-5c1-13-4-26-5-39q0-10 3-18 5-10 12-20l1-2h2l3 10-7 9-4 8c-7 4-4 11-5 17l5 18q1 7 8 6l1 3-1 7-3 6z"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m846 1241-1-3q0-9-4-19l4 2 1 2v5l2 11zM808 1113l-2 7-5-7 4 3z"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m808 1113-3 3-4-3v-3c2 0 4 4 5 0l2 1z"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M801 1110v2h-2l-1-3v-1h3z"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M861 1108q-1-7-9-8-3 0-6-4l2-5q3-2 8 1l4 2h7c7 4 11-5 18-4q8 0 12 8h-3l-10-5-3 1v2l-1 1-1 3-4 8v3l-5 4v-3zm9-10q-5-3-10-1l-1 1c0 4 6 10 9 8z"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "M873 1083h-4c-6-5-13-1-19-1l-1 1h-3l-2 1h-4l-11 4q-7 2-2 8-11 0-15 11h-7l-2-3q9-10 20-16 4-3 9-5l21-4h20l8 4h-8"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m861 1108 9 4-4 1v1h4v1l-3 2q-17 0-32-6-2-2-5-8l5-2 6-2 2 5 1 6 13 4q7 2 4-6"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m875 1111 1-4 3-5-2 8 2 5c6-2 12-2 16-8h1v-6l2 1 1 3q-2 6-8 8l-12 4q-6 1-4-6"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b4af",
    d: "M817 1106v-3l2-2h2l3-1 4 8q-7 3-11-2"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "M816 1106q5 5 12 2v3q-4 6-9 1l-4-2z"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M827 1096q-5-5 2-8l11-4q-1 2-4 3-10 1-7 10z"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M805 1107h7v2l-4 2-2-1z"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "m900 1105-2-3v-3q5 1 3 6z"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "m824 1100-3 1zM819 1101l-2 2z"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m841 1116-2-1z"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    fill: "#343031",
    d: "M901 1107zv2h-2z"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M841 1058v2h-2l-14 1-17 1c-13 3-19 16-13 28l1 3-5-6-2-9v-4l11-13q1-3 6-4 9-3 20 0z"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m801 1051-3-10v-7l3-5v4q-1 10 8 8l19-4 1-2h2v1l-5 4-2 5-10 4z"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "m801 1051 13-2q-2 2-5 3-7 1-11 7l-4 1zM789 1074v12l-4-1c1-6-2-13 5-17z"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M869 1079h-16l-21 4q-5 2-9 5-12 6-20 16-2-7 3-12l10-9 16-11q3-2 7-3l-7 6-4 5 1 2 16-5h4l14-1h2zM881 1083l-8-4v-1h8l4 4-1 1z"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m863 1076-14 1q6-6 14-1M885 1082l-4-4q5-1 8 3l-2 1zM873 1077v2h-3l-5-3z"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M806 1092q-5 4-3 12l2 3 1 3c-1 4-3 0-5 0v-5l-4-20q-1-13 9-15l33-10h2v2l-16 6q-14 6-21 18-3 3 2 6"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    fill: "#e07a58",
    d: "M918 1136q-8 3-5-5l6-1v4z"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M919 1134v-4q4 1 0 4"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "m857 1273 2 3q0 9 7 15l10 14c2 3-2 9-5 10q-2 1-5 4l-20-12-3-2-4-3-4-4h-2q-4-7-12-9h-2q-9-9 2-13l4-1c2-1 3-6 7-4l9 5 3 3q5 4 10 1 2-4 3-7"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    fill: "#f47b55",
    d: "m904 1356 9 2h1q6 6 8 13 1 4-2 9-4 9-12 16-3 3-8 2-5-3-2-8c2-4 6-8 3-14q-1-11 3-20"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M857 1273q-1 4-3 7-5 3-10-1l-3-3-9-5c-4-2-5 3-7 4l-4 1q-11 4-2 13l-9-3h-1v-4l17-12 13-7q7 0 8-4 3-7-1-13v-5l2-2-2-11 5 5v2l1 21 2 6z"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m810 1286 9 3h2l12 9h2l4 4 4 3 3 2h1l4 4 23 11q11 7 18 16l5 7v8h-2l-4-11-2-3q-6-8-15-12l-23-12-31-21z"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m897 1345-5-7q-7-9-18-16 13-2 18 8zM898 1353l-1-8 4 3 3 8q-4 9-3 20h-2l-1-4v-19"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M898 1362v10l-1 5-1 8h-3l2-10 2-13z"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M893 1385h3l-3 8v-8"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m897 1377 1-5 1 5z"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m867 1452-2-1q-1-10 3-20 3-9 8-19c6-7 1-16 0-24l-7-15 7 6 3 6 2 14q-1 5 3 5v2l-8 19-4 8q-5 7-5 19"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m881 1399-2-14q6 6 11 0l2-7v-3h3l-2 10v2l-2 9q-5 2-3 7 0 5-4 3v-2z"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M902 1109v-2h5q8 1 10-6 5 8-6 9zM849 1083l1-1c6 0 13-4 19 1zM881 1083h3l11 5q-8 1-14-5"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M898 1099v3l-2-1-1-1-1-2z"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M873 1083h5zM844 1084l2-1z"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    fill: "#df7a55",
    d: "m456 1024 3-9 5-6 3-2 7-14 9-12 3-3 4-8c2-5 8-8 7-15l2-2q11-12 11-28 0-7 3-13 1-8 5-17 2-8 2-17l-2-7 4-2 6-5c-2-8 5-11 9-15q6-4 15-6h2c7 0 7 0 8-7l2-12q2-3 7-5h10l3-2q3-5 8-2h9l4-1 92-2 15 2 2 2q0 5 5 4l18 3-2 5h5l10 3 12 2 8-1q5 1 7 4 4 6 10 9l3 3q3 6 8 6l1 4-1 5q-1 6 5 6 8 0 7 9l3 4 2-4v-4l4-5q2 3 3 5 1 6-4 10-2 2-1 6 3 12-1 23l-1 3 2 7q0 8 10 8l22 1q3 1 5 5c3 4 3 9 9 10q3 1 5 4l10 14h5q4-2 8 1 2 3 6 2 12-1 23 1l4 10h-3q-9-12-23-7l-1 2-6 4-4 1 3-8-6-1h-4q-17-8-27-23-4-5-9-5l-14-2c-4 0-10 2-12-5l-16-2-9 1-21-2c-10 0-10 0-10-10q1-4-4-6l-3-3 4-3 9 2q3 3 5 0 3-8 3-16v-23q1-5-4-5l-22 1q3-12-9-18l16-1 15-1q6-3 4-8 0-6-7-6l-18 1-4-1-6-3q-7 1-10-5-5-6-12-1l-5 1-3-2q-6 0-6-5-2-6-6-3-8 4-16 3-6 2-11-3h-5q-3 7-8 0l-3 4h-20l-6 3h-17l-8-3-20 5-3 3-6 11-2 1-4 4-2 3q-4 4-8 5c-8 1-7 6-7 11l-4 4c-5-4-8 1-11 3l-6 3-3 2q-6 10-6 22l-1 4c-5 4-2 7 1 11l-3 2q-7 3-5 10t-3 13l-7 14-1 3c-5 2-4 6-5 10l-2 3c-3 3-8 6-7 8q0 6-5 8l-6 8q-3 3 1 6v2l-5 21q-7-6-13 1zm327-125c-3 3-4 13-2 18l1 6q-1 5 3 6 4-1 3-5 0-8 7-8t4-6v-24l-2-6-2 1-1 8c0 11 0 11-11 10"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "m924 979-4-10v-1q-2-9 0-16 2-5-3-7v-9l5-16 3 1c7 23 9 48 15 71l-3 1-5-5z"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m897 974 1-2q14-6 23 7v1h-2c-6-6-12-5-19-5z"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m848 1025-14 5-10 2q-7 3-11-2t0-9c3-8 11-10 17-14l10-5q7-4 14-4 4-1 7-3l15-2 3 2q9 2 13 5c5 7 11 6 18 6h5q9 5 18 2c1 4 6 6 4 11s-2 8-9 6l-21-6-5-1q11-2 21 2h6v-6l-4-2-6-1-9-1q-9 1-17-2l-16-9c-11-5-20 3-30 3q-8 1-16 7t-15 14v2q3 7 9 4 12-4 23-4"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "M933 1008q-9 3-18-2h-5c-7 0-13 1-18-6q-4-3-13-5l-3-2q11 1 21-4 13-7 28 1l3 4z"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M900 975c7 0 13-1 19 5h-4q-7-4-16 0h-3l-2-1z"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m928 994-3-4h1z"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M831 1036zv-1l5-1h2v3z"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M848 1025q-12 0-23 4-6 3-9-4v-2q7-8 15-14t16-7c10 0 19-8 30-3l16 9q8 3 17 2l9 1 6 1 4 2v6h-6q-10-4-22-2h-27l-3 3-8 1q-11-4-12 3z"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m829 1035-1 2-19 4q-9 2-8-8v-4q1-12 10-18l22-10-8 5-2 2-4 1-2 2h-2l-6 8v1q-8 6-5 15l2 2c3 2 11 1 14-2h9"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M820 1035c-3 3-11 4-14 2l-2-2q-3-9 5-15v1c-4 12-2 14 11 14"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m894 979 2 1-5 3-7 2h-2l-4 2-10 2h-2l-14 4 13-6 27-8z"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m891 983 5-3h5q-7 6-14 8-9 2-19 1l10-2 4-2h2z"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m871 1021 3-3 22 1z"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m849 995-15 6h-1l17-8z"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M851 1025q1-7 12-3z"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m849 995 1-2h2l14-4q-7 6-17 6"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M902 980h-2q8-4 15 0z"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m809 1019 6-8zM823 1008l2-2zM817 1011l2-2zM831 1034zh-2zM827 1035h-2z"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m334 1196-1 4z"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M339 1208q3-3 5 0 5 6 2 12-8 7-14 1-3-4-1-8z"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "m449 834-3 3-2 1q-6 1-6 6l-1 2-1 2-1 5-5 6q-3 6-7 3-13-8-6-22l3-7 3-4 17-14q5-1 6-7l5-4 2 1q6-1 6 3-1 4-6 3-2-1-4 3l3 3h3v9z"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    fill: "#140e0d",
    d: "M438 844q0-5 6-6zM436 848l1-2z"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m418 969 4-10q5-18 5-36 1-13 4-28l2-4q5-14 11-29c5-8 6-19 14-25l4-2q-5 7-9 14a388 388 0 0 0-20 61l-3 23-5 23q-3 14-10 26v-3z"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M401 990c5-11 3-23 5-34l-1-1-7 6q1-9 9-15 3-2 4 2l-2 10v9q3 7-1 13l-1 4-1 3z"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m406 987 1-3 4-3 4-2v4l-3 4-1 4v2l-2 3h-2z"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m492 809-6 5-13 11-3 3-5 5v1l-3 1 1-4q11-15 29-22M497 807l-3 2z"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "m926 918-9-8c-4-4 0-8 0-13zM908 879l-3-4h4v3zM916 895l-3-6zM912 884q-4 2-4-3h3z"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M911 881h-3v-2l1-1z"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "M895 857h-3q-7-5-10-14l9 8 4 5z"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M895 857zl4 6-3-1z"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "m896 861 3 1 1 1v2z"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M900 865v-2h3v3z"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M900 866h3l3 5 2 4h-3l-1-2-2-3-2-1z"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m908 875-2-4z"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m831 801-7 1q-7 0-7-7z"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m859 825-5-6h3l2 2zM633 779l1 4h-2z"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m456 1024 6-2q6-7 13-1c1 5 10 11 13 9l15-13 3-1-5 10v8q2 4 7 1l4-2c11 2 19-4 29-5q12 0 23-3 12-1 22 0l29 2 2 2-33-2q-13 0-27 2-18 4-35 9l-20 1c-8 2-16 1-24 6h-2c-7 1-8 1-5 8q2 6-1 11l-4 8c-1 6 10 21 16 21 12-1 24 3 35-2l10 4 5 4v4l-5-3q-6-5-13-3-6 4-14 3-5 1-2 4 4 5-2 6l-4 2 1 7q0 13 13 18l3 3q-2 8-7 12-6 4-13 3-10-1-9 8v6l-2 8v7q2 4 3 10-1 4 2 8l2 4-8 11q-6 4 0 9 4 4 4 10-1 5 6 6c5 0 12 6 12 11q0 6 7 8 11 6 5 17-6 10 1 19c4-6 9-4 14-4l3 3 3 6 2 3-4 1-5 3q0 6 7 8l14 2 7-1q7-1 12-1 9 4 16-2 10-6 17 4 1 6 7 5l-11 8q-7 3-9 10l-3 4-2 5-5 5-5 14q-3 6-10 5-7-3-13 1-10 10-22 4l-4-1q-7 0-12-2-9-7-21-9l-4-2-19-21-6-8-22-30q-1-3-4-4-6-3-7-9 0-9-8-13-6-4-3-11l1-4 1 1 8 14q3 5 8 1l-2-4 2-1 5 7q2 6 9 7c4 0 3-5 4-6l10-11q8-3 4-10l-2-4c4-4 1-12 9-14l1-5q1-4 3-6c4-4 1-5-1-7l-4-5-5-15q-8-16-6-34v-2q-1-7-4-11-6-3-5-10l-1-13-2-10v-5l1-35c0-9 3-19-5-27l-2-5q8-3 6-10-1-10 3-18z"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    fill: "#df7a55",
    d: "M451 1028q-4 8-3 18 2 7-6 10l2 5c8 8 5 18 5 27l-1 35v5l2 10 1 13q-1 7 5 10 3 4 4 11v2q-2 18 6 34l5 15 4 5c2 2 5 3 1 7q-2 2-3 6l-1 5c-8 2-5 10-9 14l2 4q4 7-4 10l-10 11c-1 1 0 6-4 6q-7-1-9-7l-5-7-2 1 2 4q-6 4-8-1l-8-14-1-1-4-4 1-1 10 2v6q2 5 5 2l7-2q8 0 9-8v-11l3-3q7 2 4-5-4-14 0-29v-3l-2-10-2-7-2-20q-1-3-3-4l-3-6-2-24-4-6q-2-2-3-5l-1-16q1-3-4-4t-5-6v-5h-2l-2 3c1 8-5 12-8 18q-4 8-7 15c-1 6-5 11-4 17l-2 11v23q1 6-4 8-4-18-3-36v-33l3-25q2-18 5-37l8-36q2-10 6-20l11-22q6-4 8-10v-2q9-3 11-12l3-3 4 4v5q-2 18-13 32-8 8-8 20l-2 20 1 13c0 1 6 2 7 1q3-5 8-3l4-3 1-8q-1-6 6-9"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "M451 977v-16l-2-25v-17q-4-13 6-22l3-6q1-10 9-15 8-7 13-17v-11l7-5 14-7q3-1 1-4l-1-4q3-3 6-2 12 2 21-6 2-3 6-3 5 1 8-5c1-5 11-9 16-7l3 5-7 9-12 12-2 5q0 3-4 4-9 1-13 9-2 4-7 5c-12 0-14 9-12 18q3 8-3 14-3 2-2 8v36l-1 11-3 7v5q1 6-4 8l-6 6-2 4c-6-1-8 4-13 7z"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "M917 936v9q-5 10-16 13l-13-1-2-1c1-7-10-5-9-12q2-8-4-13l-2-1q-5-3-5-9t-5-11q-6-3-9-11-1-6-10-4-7 4-7-5v-28q0-4-4-7-7-7-13-15t-16-8c-11 2-10 2-16-7l-5-4-4-5 4-3 24-3 11 1 5 3v2l-1 4c7 4 16 4 22 11l7 2h1l5 7q14 9 19 25l4 3q5 1 7 6 1 3 3 4l11 11 2 1 4 16 3 4q4 3 5 8 1 3 3 7v5z"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m421 983-11 22q-4 10-6 20l-8 36q-3 19-5 37l-3 25v33q-1 18 3 36l1 25-2-5-3-7v-10l-2-2v-25c-1-3 3-8-3-9v-9l1-3v-23l7-42 5-34 6-23 6-20v-3l2-4 2-3v-2l1-2 3-3q1-4 3-7 13-22 15-46c3-20 4-39 11-58l5-8-1 5q-5 15-9 31l-1 24-3 3q0 16-5 31l-1 8v2q-8 3-8 10"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7744c",
    d: "m451 977 19 1q-1 5-7 5l-5 1v8l4 8q1 3-1 5l-6 12-6 4-5 3q-3 6-8 6-5-3-4-8v-10q0-7 7-11l3-4 2-3q7-3 6-13z"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "m438 929 1-24q4-16 9-31l1-5c1-14 10-23 16-33l3-3 1-1 9-9 3-2 2-2h1l6-4h1l10-6 4-3h2l4-3h2l7-5h2l1 1-3 5q-9 3-15 11l-2 2q-14 1-23 10c-11 10-23 20-26 35l-5 25q-3 6-4 13l-1 14-1 7-2 4z"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fill: "#da734c",
    d: "M901 958q11-3 16-13 4 2 3 7-2 7 0 16l-9-4-6-3z"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "M430 963q5-15 5-31l3-3v6c5 10-1 17-4 25zM531 796l2-2-1 3z"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m478 823-9 9 1-4 3-3zM490 815l-6 4zM483 819l-2 2z"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "m882 843-3-2h3z"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M850 833zl-1-4h9l3 2-3 2zM831 820l-1-3 4 2zM821 816v-2l2 1z"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7704b",
    d: "m900 869 2 1zM904 873l1 2z"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M392 1217v-2q2 5 5 7 6 8 6 16 2 14 9 24l4 4-1 4q-3 7 3 11 8 4 8 13 1 6 7 9 3 1 4 4l22 30 6 8 19 21 4 2q12 1 21 9 5 2 12 2l4 1q12 6 22-4 6-4 13-1 7 1 10-5l5-14 5-5-7 19-2 7q-1 8-8 8l-9 2h-3c-6-3-12 1-18 4l-20 2q-4-6-12-7-11-7-22-13-9-5-14-14c-6-9-10-20-20-27l-2-2q-1-8-9-11-4-4-6-9l-12-20-9-12v-1l-3-11-6-18-3-3v-4l-1-19-2-2z"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m407 1278 9 12 12 20q2 5 6 9 7 3 9 11l2 2c10 7 14 18 20 27q5 9 14 14 11 6 22 13 8 1 12 7h2l18-2-1 2-7 2-8 6-6 3-3-6-2-4-2 3-5 4q-4-3-6-7 0-7-6-11l-13-3-7-6q-1-4-4-6c-4-2-3-8-6-11q-3-4-7-6-5-1-4-5 2-8-6-5l-5-2q-3-4-1-8t-2-8l-5-8c-6-5-6-12-10-18zM395 1245l3 3 6 18 3 11-3-2zM392 1220l2 2 1 19-4-16v-3z"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M391 1222v3l-1 3-3-11zM391 1235l-1-3z"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m532 1396-2 2z"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "m609 1369-14 11-3 2-2-3 1-31 5-8 10-7 6-4h2l2 1v1q-3 8 4 11l-3 8q-1 3-3 3l-3-3q9-1 5-7l-4 3c-1-4 2-8-4-10l-5 4q-6 3-7 8-4 8-1 18 1 7 7 3 12-7 26-6 5 0 3-3c-3-2-1-5-2-7l-1-6v-4l7 2-1 6q-5 9 6 12l2 1c-2 5-6 2-9 3h-16l-2 2-2-1z"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M585 1342q2-7 9-10l11-8h4l10-4 8-3 13-2 7-3 5 1-18 6-22 7-5 3h-1q-6 2-11 6-3 2-4 6l-1 2h-3z"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M591 1341q1-4 4-6 5-4 11-6v3q-8 2-12 8z"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M594 1340q4-6 12-8v1l-10 7zM609 1369h4v2h-4z"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M609 1371zl1 1v1l-1 1-1 1h-2z"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M607 1375h2l-3 4v-3z"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m603 1381-4 1 4-4z"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M603 1381v-3l3-2v3l-1 1z"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m582 1346 3-4v4z"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M599 1505v-2q2-14-7-26l-1-6q-4-8-6-17-3-16 1-34c2-12 10-21 13-33l2-1-2 8v3q-3 4-4 8l-2 26-4 15q-3 6-1 10l5 12 2 8q5 8 6 17 1 3 3 4c6-1 10 5 15 7q6 4 11 0t10 0q3 3 7 3l4 2q7 5 8-4 0-4 5-5l6-1q-7 4-10 11l-3 6q-3 1-6-1l-5-2q-3-1-5-3-5-7-11-1l-7 7-17-14z"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M585 1346v-4l2 1v2z"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m603 1381 2-1v1l-2 3zM601 1386l2-2z"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m391 1222-4-5v-2l-2-2v-5l2-3 3 7 2 5v3z"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m385 1213 2 2h-2z"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m842 1506 6-1-6 5-10 3q-5 2-5-4h2q7 1 13-3"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m599 1505 7-3 17 14 7-7q6-6 11 1 2 2 5 3l5 2q3 2 6 1l3-6c6-3 12-4 13-11h5q4 4 7-2l2-2h6l8 3 4 6-1 2-8-3-4 3-8 15-3 1-5-16-11 5-2 4v5q-2 8-8 3l-15-11q-5-3-7 4l-4 7-3-4-4 2q-5-8-14-8c-3-1-9-2-9-8"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m828 1503 10-1q6-2 11-6l-4 5c-8 7-16 5-25 4q-5 0-11-3l-8-2h-2l-6-3-3 2q2 6-2 12l-1 1-3 2-4 4-3-5c-1-3-9-8-13-8-5 1-4 5-5 9h-1q-7-3-12 1l-4 7h-22l-1 2h-6l-2-1-3-3-1-3-1-4-2-2v-2q7 2 7 7l5 4 20-1q7-1 7-8l-4-11v-3l6 2c2 1 3 5 8 3v-10h2l2 3 3 4 9 4q7 1 10 3 4 4 7 2l1-7v-10h6l14 6c5 6 12 5 18 6z"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m739 1500 4 11q0 7-7 8l-20 1-5-4q-1-5-7-8v-2l1-2 1-3q8-2 15 3l5 1 7 7 4 2 2-5z"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m742 1522 4-7q4-4 12-1h1c1-4 0-8 5-9 4 0 12 5 13 8l3 5 4-4 3-2v1l-5 12-11-11-2-5q-6-3-7 3 0 6-7 8l-12 6h-2l-12 1-3-1 13-3z"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M787 1513zl1-1 7-5 4-6h2l-1 10z"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m742 1522-3 1-13 3h-3l-4-2 1-2z"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m707 1517 1 3v3q-6-4-4-12l2 2zM719 1524l4 2-8-2zM711 1523l2 1c-2 4-3 1-5-1z"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m849 1496 4-7-2 6zM382 1159c6 1 2 6 3 9v21l-3-2v-2l-1-5 1-19zM383 1131l-1 16h-1v-16z"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M383 1124v5h-2l-1-11v-8h3z"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "M382 1159v2l-3-4 1-7h2zM380 1113v5z"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M382 1150h-2l1-3h1z"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M381 1129h2v2h-2z"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m387 1205-2 3v-7h2z"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M387 1201h-2l1-2zM385 1193l2 2z"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M383 1124v-14l2-13 5-28 5-31v-3l7-23 5-7-6 20-6 23-5 34z"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m395 1038-5 31-5 28v-16l8-43zM407 1005l-5 7-7 23-2-2 3-8 5-18v-1l6-5v4"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m401 1007-8 26q0-14 8-26M407 1001l-6 5 5-7h1z"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c211f",
    d: "m399 996 2 3h-1z"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M407 996h2v2l-2 1z"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m390 987 3-11c4 2 1 4 1 7l-3 4z"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m853 1489 2-2z"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7744c",
    d: "M793 1491h-6l-5 1-10 2-3-5-2-4q-9-7-20-2l-8 2q-3 1-5 3l-3-4 12-7 3-2-2-3-4-1-10-4 12 1q13 0 27-2 10-3 20-8l17-7q6-1 10-5l14-15q4-4 2-10c6 0 12-7 11-12l1-7 12 5c7 4 7 4 12-1h5l-1 3-7 12q-5 17-5 34v6l-2 1-10 13-3 1q1-8-6-9-9 0-14-6t-11-7-15 3l-28 11-4 5q0 2 3 5 9 6 20 8z"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m793 1491-3-5 14 4 7 3q7 5 16 5 5 0 8-4 8-7 10-18l3-1 10-13 2-1-3 9q-2 13-10 21-8 7-19 12h-3l-18-6h-2z"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M860 1455q0-17 5-34l7-12 1-3q5-5 3-10v-8c1 8 6 17 0 24q-6 10-8 19-4 10-3 20l-3 6z"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88460",
    d: "M851 1235v-2q0-10-6-19-2-5-1-10l2-9q1-4 4-6 8-7 3-17l-3-16q1-5 6-4l25 7 13 1 5 4 9 5 6 5 4 7 2 3-4 18-3 3q-9 7-1 14l1 3c-6 10-5 22-5 33q-1 7-4 14l-1 4q-1 8-9 6-6-3-11 2-3 1-5-1l-6-6-1-3c-13-8-16-22-20-36"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M846 1225v-2z"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88460",
    d: "M848 1152z"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M735 1244h-27c-8 0-12-7-17-10l-2-3c0-6-1-13 5-17l3-4 3-3q10-7 18 2l17 14q4 2 6 1l2-6-2-8 1-20-2-5-3-8-1-8 1-7v-4c-2-1-8 0-9 2-2 8-10 12-15 18l-3 2-4 2-17 11v-3l8-8q4-8 10-15 6-5 4-12l-3-13-2-11-4-17q-1-4-5-1l-12 8q-5 2-9 6t-8 1l-9-5-10 4q4-7 10-9 9-3 11-11 3-7 10-2 4 9 10 2l12-10 4-1c7-2 15-7 15-12l-2-19c-2-11-6-21-3-32l4-1-1 12 4 24 2 11 9 24v1q-3 13 2 27l2 8 6 13 5 9 1 20-2 10q0 12-2 24c0 4 1 11 4 13q9 7 20 10h9q10 2 18-2 4-2 9-2l5-3q4-6 2-14 6 7 1 13-3 7-10 7-5 0-8 3-5 6-14 4l-18-6c-5-2-10-5-16-1zm-31-29c-7 2-13 11-8 16q4 6 11 7h14l14-3q4-2-1-5l-14-9q-7-5-16-6"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "m689 1193 17-11 4-2 3-2c5-6 13-10 15-18 1-2 7-3 9-2v4l-1 7 1 8 3 8 2 5-1 20 2 8-2 6q-2 1-6-1l-17-14q-8-9-18-2l-3 3-3 4c-6 4-5 11-5 17l2 3c5 3 9 10 17 10l-1 3h-2l-8-2-8-4q-8-10-1-22l11-22q-3-1-7-1l-17 13q-5 7-10 15-5 7 0 14l9 15v1h-2l-8-3-10-1q-6-4-4-9l7-14q12-21 32-34M735 1244l13-7c6-4 11-1 16 1l8 3 10 3q9 2 14-4 3-3 8-3 7 0 10-7 5-6-1-13v-5l-2-3-7-23-3-9-7-20 1-6 3 2-1 5q0 6 4 8l1 4 9 24 10 33q-1 7-7 11l-21 12-10 2-13-3-11-6q-3-3-7 0-8 6-17 1"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m809 1256-7 7-4 5q-1 4-6 4-6 2-10-3l-9-7-20-11q2-2 3-1l13 5q1 2 4 3h20l6-1z"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M705 1247h4q-9 6-19 4-5-1-9-6-4-12 0-23l3-3-2 12q-1 9 4 14 9 5 19 2"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M690 1251q10 1 19-3l4-1 6 2v1h-3l-9 2h-2l-9 2-12 5 8 9q-8-3-12-9l-1-6h6q4 2 5-2"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M749 1252v1l4 2h2l2 2 2 1 2 2h1l3 2 1 2 1 2-8-3-5-4-13-7h8"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M737 1249zl-1 3-4-1-4-1h-4l-4-1v-2h12z"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m798 1153-3-2v-12q5 5 3 14"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m737 1252 1-3 7 2-4 2z"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M801 1166q-4-2-4-8z"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M721 1247v2h-2l-6-2zM737 1249l-4-1zM728 1247h-3z"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m810 1286 10 8 31 21 23 12q9 4 15 12v2l-2-1h-1l-11-9-1-1h-3q-14-10-29-18l-27-17-14-10h4z"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M846 1246q4 7 1 13-1 3-8 4l-13 7-17 12-4-1 4-5 29-19q5-4 8-11"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M825 1262h-1l-5 5h-1l-7 3-3-1 1-4 19-13 1-3h5q5-4 5 3h-1z"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m829 1249-1 3-19 13-1 4 3 1 7-3c-3 6-13 9-20 4q13-14 31-22"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M773 1269h2q4 8 10 9h9l5 3 1 1v2q-5-3-11-4-9 1-15-6l-7-8z"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "M839 1252q1-7-5-3h-4l10-5 3 2zM825 1262"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M785 1278q-6-1-10-9z"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m805 1281 4 1v4l-4-1z"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m773 1269-6-3-1-2z"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m819 1267 5-5z"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m799 1281-5-3q4-2 5 3M800 1284v-2l4 3h-3zM753 1255l-4-2zM765 1262l-3-2zM757 1257l-2-2zM761 1260l-2-2z"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    fill: "#e07a58",
    d: "M795 1149v2l-1 6 7 20 3 9 7 23 2 3-2 19-5 3q-4 0-9 2-8 4-18 2h-9q-11-3-20-10c-3-2-4-9-4-13q3-12 2-24l2-10-1-20-5-9-6-13-2-8q-5-13-2-27v-1l-9-24-2-11-4-24 1-12v-4q11 17 6 36v3l7 21c4 13 10 25 8 39l2 4 6 10q1 4 3 7c8 10 7 23 7 34l-1 10c-1 7 0 15-7 20q-2 2-1 6l7 10q4 6 10 5l8 3 3-1q11 4 19-5l5-1 8-2q1-4-1-9l-3-9q1-6-6-8l-3-4v-11q2-10-7-17l-2-4q0-15-4-29-4-12-4-24 0-11-3-23-4-9-1-18 1-4-2-9l-3-2q-5 2-6-2-4-3-1-8l6-3 7-2c3-3 4-9 10-9l3-3 7-5 1 9-2 4-1 2q-7 10-12 20-3 8-3 18c1 13 6 26 5 39l2 5 2 8q0 9 6 16"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m785 1085 4 1 4 13 5 7v3q-7 1-8-6z"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m796 1041 2-4v4z"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M798 1108v-2l1-1h2v3z"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M895 1100zl-1 6-3-4q-4-4-7-3t-4 5v2q-2 6 4 4l10-4c-4 6-10 6-16 8l-2-5 2-8v-2l1-3 1-1z"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    fill: "#564e44",
    d: "m870 1098-2 8c-3 2-9-4-9-8l1-1q5-2 10 1"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m895 1100-14-4v-2l3-1 10 5z"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "M879 1100v2l-3 5q0-3 3-7"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "M870 1114h-4v-1l4-1z"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "M880 1097v3z"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    fill: "#70625c",
    d: "m884 1093-3 1z"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M801 1105h-2l-1-4-2-3v-5l-1-3c-6-12 0-25 13-28l17-1 14-1-33 10q-10 2-9 15z"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m798 1101 1 4-1 1-5-7-4-13v-8l2 9 5 6v5z"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m798 1034-1-6v-4l5-8q7-7 13-12l22-9 12-5q10-6 22-7l16-4 4-1 1 1-27 8-15 6-17 8-22 10q-9 6-10 18z"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m833 1298-12-9q8 2 12 9M851 1311l-4-4zM839 1302l-4-4zM846 1307l-3-2z"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M897 1355zl-2 2-3-3v-2l-1-2v-1l-1-5v-3h1l4 11z"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m898 1355-3-2h2zM891 1342zl-1-1v-2z"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m896 1358 2-2v6h-2z"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m895 1358 1 4-1 13h-3v-20z"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M876 1388v8q1 5-3 10h-4q6-10 2-20l-1-3q-2-4-5-5t-7 2l-4 2-14 14-2 6h6l-1 7c1 5-5 12-11 12l-5-1q-11-2-4-11l9-8 7-9v-3l2-1 8-6 5-6h1c5-1 8-7 14-4v1z"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M869 1373v-1q-3-6-7-3l-5 3 1-5-31 4 1-2 27-6 3-4-7-10v-1l-7-6-5-4-3-4-3-5 5 3q13 11 22 24l9 11 3 4 3 4 1 2v1z"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "M876 1379v-2l6 5 10-4-2 7q-5 6-11 0z"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m881 1399 3 5q-4 0-3-5"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m892 1378-10 4-6-5-1-2-3-4-3-4-9-11q-9-13-22-24l-5-5-4-4h-2l-2-2-1-2 7-1 4 5 11 9 14 18c4 5 6 13 12 16l1 1q3 7 9 3 4 2 7 1l2-7 1-7v21"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "m887 979-16 4 12-8-13-2-4-2q-3-3-6-4-5-1-8-6l-3-4q-8 1-14-4l-4-1q-6 2-13 2-7 2-13-3c-7-5-17-5-25-8l-4 1-20-2q-5 1-5-4l1-16q0-3-3-4l-7-2-5 2-10 6c-1-4 2-8-3-9q-7-1-6-9l3-24q2-7 1-14 0-8-1-16l5-2 15 1q12 6 9 18l22-1q5 0 4 5v23q0 8-3 16-2 3-5 0l-9-2-4 3 3 3q5 1 4 6c0 10 0 10 10 10l21 2 9-1 16 2c2 7 8 5 12 5l14 2q5 0 9 5 10 15 27 23h4l6 1z"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    fill: "#e07a58",
    d: "m741 851-15-1-5 2-6-2 1-4-1-5-4 4v1l-2 2-2-2c1-7-5-9-9-9h-25c-5 1-14-1-16-4q-2-2-5-3h-35l-8 1 4-7 40 2 3-5 3-4q5 7 8 0h5q5 5 11 3 8 2 16-3 5-3 6 3 0 6 6 5l3 2 5-1q7-5 12 1 4 5 10 5l6 3 4 1 18-1q6 0 7 6 2 6-4 8l-15 1z"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "m613 824-4 7-6 3-9 8q-7-3-9 3l-2 17q1 9-8 11-9-4-12 6-12-1-20 5-8 5-15 13-3 6 0 12 4 4 0 7-4 4-3 9 0 4-3 6l-11 14-2 4q-1 10-10 16c1-4 0-8 5-10l1-3 7-14q4-6 3-13-2-7 5-10l3-2c-3-4-6-7-1-11l1-4q0-12 6-22l3-2 6-3c3-2 6-7 11-3l4-4c0-5-1-10 7-11q4-1 8-5l2-3 4-4 2-1 6-11 3-3 20-5z"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M784 899c10 1 10 1 10-10l1-8 2-1 2 6v24q3 6-4 6t-7 8q2 4-3 5-4-1-3-6l-1-6c-2-5-1-15 3-18M503 1017l-15 13c-3 2-12-4-13-9l5-21 2-2 4-1v4q-5 1-3 5v2q-7 5-3 11 2 3 7 4l9-4z"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "m486 997-4 1h-2q-4-3-1-6l6-8q5-3 5-8c-1-2 4-5 7-8v7l-1 2c-4 6-10 10-10 17zM656 821l-3 5-23-2 6-3z"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M892 979zl6-4 3 1-6 4z"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "m497 968 2-3z"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M480 998h2l-2 2z"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m891 983-7 2zM882 985l-4 2zM465 836c-6 10-15 19-16 33l-5 8c-7 19-8 38-11 58q-2 24-15 46-2 3-3 7l-3 3v-4l3-4v-1q7-12 10-26l5-23 3-23a205 205 0 0 1 20-61q4-7 9-14l3-1z"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m415 983-3 4zM411 993v2l-2 1z"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m470 828-1 4-1 1h-3z"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M465 833h3l-3 3v-3"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "m627 1317-8 3c-4 1-9-1-10 4h-4q-6 1-7-5-7-10-17-4-7 6-16 2-5 0-12 1l-7 1-14-2q-7-2-7-8l5-3 4-1-2-3-3-6-3-3c-5 0-10-2-14 4q-7-9-1-19 6-11-5-17-7-2-7-8c0-5-7-11-12-11q-7-1-6-6 0-6-4-10-6-4 0-9l8-11-2-4q-3-4-2-8-1-6-3-10v-7l2-8v-6q-1-9 9-8 7 1 13-3 5-5 7-12l-3-3q-13-5-13-18l-1-7 4-2q6-1 2-6-3-3 2-4 8 1 14-3 8-2 12 3h-2c-13-1-15 1-15 10l-3 3-6 4-1 4 10 7q7 2 9 9 3 7-4 11-5 1-4 5 1 3-1 4-7 10-6 22 0 5-3 10-2 3 1 7 3 1 0 6l-1 6q2 5-2 5t-4 5q-1 7 5 11 8 6 4 12l7 13 4 3 4 3q0 6 6 5 9 1 10 11v8q-1 4 4 3 8 1 5 10-5 9 6 11l4 1c7 1 15 4 22 0l12-6q9-3 8-13v-1l16-15 1-4c2-5 1-12 7-15l1-2 2-16 1-26q0-8 3-14l2-7q1-6 6-5l7-3q1-8 9-11 3-2 4-6-1-3-5-6l-5-1h-13q-7 1-6-6l19 1 3-5q-2-7 2-13l1-3 3-3 8 1c-1 10 8 15 8 24l2 2 13 5 3 3 1 4q4 5-2 9l-1 4q-2 11-11 12l-18-16-4 4q-7 6-15 12-4 3-6 9v5q-2 7 5 8 3 1 7 3l1 6q-2 3-5 2-6-2-6 3l-2 10-1 5q-5 5-4 11 0 19-17 27-5 2-2 6 3 5 9 6 8 3 12-4l5-6 11-8 5-7 3-4h1l15-8 7 8q-15-2-22 7l-13 13-8 11-2 7-13 13zm-26-6q0 6 5 2-2-6-5-2m-118-91h-2z"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M524 1100h3l5 3 1 1c2 5 5 9 0 13l1 5c4 5 13 7 18 4q6-3 8 2 2 3 6 4l23 3 9 6q11 2 18-4l5 1q4 0 4 4v10q-6 6-2 13l-3 2c-7-1-11 5-17 7l-4 5-2 18q0 5 5 3 8-3 11 3l5 11v1q-6 7-4 15l-2 4q-4 4 1 5l3 3c-4 5-10 9-10 16v9q-1 6-3 8-6 6-8 14v1l-6 7-11 7q-6 6-14 2l-4-1q-11 3-10-8v-4q0-4-4-6l-6-6-6-15q-3-9-10-16v-2q-2-3-5-4-7 0-6-7 1-5-4-7-5-1-6-5c1-4-3-9 4-10l1-3 2-13-1-7c-1-5-4-11 0-16v-5q-3-4 1-9 6-5 8-13l2-1q6-4 3-11l-8-14 3-5c-6-1-5-6-5-10q-1-6 5-7zm45 86q3-4 7-3 2 1 4-1l1-3-5-1q-4 1-6-2v-6q3-4 8-4 6 3 11 1 7-6 16-9l10-5q5-1 4-5l-5-4q-9-3-16 4-4 3-8-1-8-4-15-9-5-5-8 1-1 6-6 4l-7-3q-4-4-9-3-5 0-8 3-2 6 1 11 4 6-3 8h-4q-6 0-6 6l-2 8q-2 9 1 18 4 8 5 17c0 9-2 19 3 27l1 4q-2 8 6 6 6-1 5 6v4q4 6 3 13l1 6q2 5 6 1h3l9 6 1 5 3 5q6 2 11-3l3-3q9-2 9-11l1-4 3-7c-2-8 3-15 3-22 1-7 3-15-2-22l-6-9q-4-8-12-9-9-4-11-15"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M517 1091c-11 5-23 1-35 2-6 0-17-15-16-21l4-8q3-5 1-11c-3-7-2-7 5-8h2c8-5 16-4 24-6l20-1q17-5 35-9 13-2 27-2l33 2 6 1 18 5 12 2 28-5 1-2 1-3h4q-1 6-3 8l-20 8h-2l-12-2q-8 1-14-1-16-6-32-1h-7q-5-3-5 2h-6l-7-2-10 1q-13 2-25-2h-5l-5 2-30 4-17 5c-3 2-7 12-6 16l1 7q0 8 7 12 10 5 24 5z"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m517 1091-4-2q-13 0-24-5-7-5-7-12l-1-7c-1-4 3-14 6-16l17-5 30-4 5-2h5q12 4 25 2l9-1-5 3-22 6-8 3q-3-8-10-5l-13 3c-9-2-16 4-22 7-5 3-7 14-3 17l16 10 2-1q8-3 8 5 0 4 4 4l2 2v2z"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "m623 1030-6-1-2-2-29-2q-10-1-22 0-11 3-23 3c-10 1-18 7-29 5l-4 2q-5 3-7-1v-8l5-10 1-1q5-1 4-5l6-6 4-5 24-12-2 5h-2l-6 5q-21 9-28 30l3 1c12 4 23-2 35-4l11-3 8-1c10-4 20-1 29 0l39 8h8l10 1h-22z"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M507 1015zl-3 1-7 2-1-2q13-6 20-18l6-4q13-11 30-11 11 1 24 4l12 1 10 3v2l-10-1-27-6h-15l-24 12-4 5-6 6z"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m532 1099-5-4h4z"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M532 1099zl2 5h-2l-1-1z"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7744c",
    d: "M412 1262q-8-10-9-24 0-8-6-16-2-2-5-7l-1-23q5-2 4-8v-23l2-11c-1-6 3-11 4-17q3-8 7-15c3-6 9-10 8-18l2-3h2v5q0 5 5 6 5 0 4 4l1 16q1 2 3 5l4 6 2 24 3 6q2 1 3 4l2 20 2 7 2 10v3q-4 14 0 29 3 7-4 5l-3 3v11q-1 9-9 8l-7 2q-3 3-5-2v-6l-10-2z"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M421 983q0-7 8-10-2 6-8 10"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m407 999 2-1-2 4v-3M409 996l2-1-2 3z"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m642 1364-2-1q-3-5-3-8l6-12 2-5q0-6 4-8 6-2 5-10l-19 8-11-2 1-2 11-2h2q8 1 11-4h2q15 1 29-1 3-1 4-3l2-4h2l1 5 4-1 5-1v5l-6 5-4 4-11 5c-2-1-3-5-7-2q-9 11-22 15l-1 2-1 1-2 2v1l-3 3q0 7 5 9v1z"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "m611 1350 3 3q2 0 3-3l3-8v-3l2-2v-1l6 1v10l1 6c1 2-1 5 2 7q2 3-3 3-14-1-26 6-6 5-7-3-3-10 1-18 1-5 7-8l5-4c6 2 3 6 4 10z"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "M620 1339v3q-7-3-4-11l8-5 11 2 19-8q1 8-5 10-4 2-4 8l-2 5-6 12q0 3 3 8-11-3-6-12l1-6-7-2v-12l-5 3-1 2v1z"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M638 1322h-2q-7-3-11 2l-13 5h-5l5-3 22-7 23-8h6l18-4 5-4h8l-8 5-20 5-13 2-2 3h-2z"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M642 1364h4q8 1 11 7l-10 2h-3l-2-2-5-2-4-2c3-1 7 2 9-3"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m633 1367 4 2 5 3h-1l-12-2-3-1h-4v-2h11"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    fill: "#40241d",
    d: "m611 1350 1-4 4-3q4 6-5 7"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m614 1329 11-5-1 2-1 1-7 3z"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m616 1330 7-3z"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M622 1367v2h-5v-2z"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M607 1329h5l-6 4v-1z"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M631 1367h-3z"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M617 1367v2h-2v-1z"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M613 1371v-2h2q0-1 0 0z"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1997a",
    d: "m653 1311-1 1h-16l3-6 4-1q5-1 4-7v-4q7-14 23-21l4 2 18 4c6 1 12-1 14 8l4-5 3-1q2 2 1 4l-4 3-6 7h-2l-5 3-6 1q-17 0-30 5l-4 4zm-2-10-1-1v2z"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "m704 1295 6-7 4-3q1-2-1-4l-3 1-4 5c-2-9-8-7-14-8l-18-4-4-2q-16 7-23 21v4q1 6-4 7l-4 1-3 6h11l-7 3-13 2-10-1 13-13 2-7 8-11 13-13q7-10 22-7 5 6 12 5h2q4 7 11 5h6q3 4 6 0h5l13 3 4 3-4 4-4 2h-2l-7 1z"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M609 1324c1-5 6-3 10-4z"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m613 1371 2-1 2-1h10v3l-10 1h-6v-1l1-1z"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M611 1371z"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "M614 1373h3l-3 4c-3 5-1 12 5 13l13 1 14 4 17 3-3-7h2l1 1 6 3q6 8 15 8h2l4 3h1l-3 5q-5-1-10-3-12-5-25-2l-15-1-6-1-12 2c-15 2-16 1-16-13l2-9-1-3v-1l1-1 3-4 1-1z"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m614 1373-3 1v-1z"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M604 1393c0 14 1 15 16 13l12-2 6 1 15 1q13-3 25 2 5 2 10 3l3-5 3 1q-2 7-12 6l-10-3q-6-1-12 1l-1 3q4 3 3 8l1 9 3 6-4 3q-7 7-16 6c-7 0-15 0-18 9l-1 1-15 10q-9 4-13-6l-3-3v-19c2-11-2-22 3-32v-12z"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M599 1397v9c-5 10-1 21-3 32v19q1 15 8 28l4 4q5 1 8 6 4 7 13 4l14 2q7 4 13-1l6-3q7-4 14-6l17-4 17-3 6-1q7 3 15 1l8 13v12l-2 5-4-2-7-7v-9c-2-9-12-13-18-7l-5 2h-8l-13 1q-2 1-5 3h-2l-4 4h-1l-6 1q-5 1-5 5-1 10-8 4l-4-2q-4 0-7-3-5-4-10 0t-11 0c-5-2-9-8-15-7q-2-1-3-4-1-9-6-17l-2-8-5-12q-2-4 1-10l4-15 2-26q0-4 4-8"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M670 1499h3c-1 7-7 8-13 11q4-7 10-11"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m604 1393-5 1 2-8 2-2 2-3 1 3z"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M708 1489c6-6 16-2 18 7v9l-5-1q-7-5-15-3l-5-3-8-3 2-4h8q5 3 5-2"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m695 1491-2 4h-6l-6 3-4-3q3-2 5-3z"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m677 1495 4 3 6-3-2 2q-3 6-7 2h-5l2-4z"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m701 1498 5 3-1 3z"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m739 1497-5-9q2-2 5-3l8-2q11-5 20 2l2 4 3 5v2l-12 3-3-4-2-3h-2v10c-5 2-6-2-8-3z"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m760 1499 12-3 9 7 3 2 1-3-3-10 5-1v10l-1 7q-3 2-7-2-3-2-10-3z"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m799 1500-4 6-7 5q4-6 2-12l3-2z"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m807 1497 18 6c-6-1-13 0-18-6M793 1491"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M711 1523h-3v-3zM707 1517l-1-4z"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "M731 1484q-8 3-15-1l-6 1-17 3-17 4q-7 2-14 6l-6 3q-6 5-13 1l-14-2q-9 3-13-4-3-5-8-6l-4-4q-7-13-8-28l3 3q4 10 13 6l15-10 1-1c3-9 11-9 18-9q9 1 16-6l4-3h2l2 2 9 1c6 0 16 9 16 14-1 8-1 8 7 8h6l5 3 8 2h9l10 4 4 1 2 3-3 2zm-88 12 8 1 18-6 17-8 6-1q8 6 15-2 5-4 11-1c4 3 8 0 11-1q3 0 4-4l-5-2-7-2q-8-5-17-4-7 2-15-4 3-4 2-6-3-7-9-9-5-1-11 3c-3 2 0 5 1 7v4h-4l-10-4h-6q-18-2-20 16v9q-3 14 11 14"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "M845 1476q-2 11-10 18-3 4-8 4-9 0-16-5l-7-3-14-4q-11-2-20-8-3-2-3-5l4-5 43-14q6 1 11 7 6 6 14 6 7 1 6 9"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "M708 1462zq-3-3-4-6c-1-11-10-17-19-20q-7-2-8-8 1-9 9-10l12 1 34 8 6 4h-5l-13-3q-11-3-24-4-7-1-6 7 1 5 5 6 7 3 9 9 6 14 19 16l27 4q10 1 21-3 5-4 11-6 20-4 33-20l2-1q4-2 3-6-3-3-7-3h-7c-5-3-9 0-14 1l-5 2-30 2-6 1h-10v-2l8-1 28-1q6 1 8-6l3-4h6l16-5c2-2 7-2 7-7l7-3 5-3 11-9-7 9-9 8q-7 8 4 11l5 1q2 6-2 10l-14 15q-4 4-10 5l-17 7q-10 6-20 8-13 2-27 2l-12-1h-9c-3-6-9-4-13-5"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88460",
    d: "M844 1402h-6l2-6 14-14 4-2q3-2 7-2 3 1 5 5l1 3q5 10-3 20c-5 5-5 5-12 1z"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m782 1492 3 10-1 3-3-2-9-7v-2z"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "m652 1265-3 4-5 7-11 8-5 6q-4 7-12 4-6-1-9-6-3-4 2-6 17-8 17-27-1-6 4-11l1-5 2-10q0-5 6-3 3 1 5-2l-1-6q-4-2-7-3-7-1-5-8v-5q2-6 6-9 8-6 15-12l4-4 18 16q9-1 11-12l1-4q6-5 2-9l-1-4-3-3-13-5-2-2c0-9-9-14-8-24l-2-5v-2l9 5q4 3 8-1t9-6l12-8q4-3 5 1l4 17 2 11 3 13q2 7-4 12-6 7-10 15l-8 8-21 15q-7 5-9 12l-3 3q-3 5-7 9c-6 5-5 15-14 18l-1 2q2 12-4 22-1 3 1 4h5l2-2q6-6 14-8m12-69-9 2 3 9q8-3 6-11"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "M716 1033c-3 11 1 21 3 32l2 19c0 5-8 10-15 12l-4 1-12 10q-6 7-10-2v-8l4-2c11-5 21-10 21-24l2-4 2-9c-1-7-4-15 1-22v-3l5-4z"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    fill: "#e07a58",
    d: "M652 1265q-8 2-14 8l-2 2h-5q-2-1-1-4 6-10 4-22l1-2c9-3 8-13 14-18q4-4 7-9l3-3q2-7 9-12l21-15v3q-20 13-32 34l-7 14q-2 5 4 9l10 1 8 3-4 2q-10 2-15 9z"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M680 1097v8q-6-5-10 2-3 8-11 11-6 2-10 9l-7 3-26-6q-5-3-11 0c-4 2-12 1-14-1l8-1c8-2 16-5 23 1q6 2 7-3v-4l6-3 20-5 7-3 5-2 4-5 2-4z"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "M704 1215q9 1 16 6l14 9q5 3 1 5a58 58 0 0 1-28 3q-7-1-11-7c-5-5 1-14 8-16"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m716 1033-1-4q5-1 1-4c-2-6 0-12-5-16l-3-5q-1-8-7-9h-1l-2-2h-2l-5-4-2-1-3-1v-1l-14-9h3l21 11 15 13 2 2v1l2 2 1 3 4 11v12z"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M659 1123v2l-6 4-3 3-1 3-7 3q-10 0-19-5l10 1q10 3 16-7z"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M705 1247q-10 3-19-2-5-5-4-14l2-12v-1l3-6v-2l4-4-3-3c-3-1-9 5-10 9-7 5-7 12-8 18l2 15 3 8h-1l-9-15q-5-7 0-14 5-8 10-15l17-13q4 0 7 1l-11 22q-7 12 1 22l8 4z"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M674 1253zl5 6q4 6 12 9l1 1 6 2 3 2h3v2h-5l-11-5h-2l-2-2q-9-5-11-14z"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M674 1254q2 9 11 14l2 2q-7 1-12-5l-7-8v-1l4-2z"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m813 1212-2-3z"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m680 1259-5-6-3-8-2-15c1-6 1-13 8-18l5-4q4-2 4 2v2l-3 6v1l-3 3q-4 11 0 23 4 5 9 6-1 4-5 2h-6z"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M800 1284zl14 10 27 17q15 8 29 18-8 2-12-3l-3-3-30-21q-7-6-15-6l-19-14c-2-1-10 5-10 8-1 7 6 15 13 16l7 4-6 1-4-1-4-3h-1l-2-1-2-2v-2l-2-3h-2v-6q-1-5-3-8l-16-7h-2q-5-4-10-6-21-21-50-13l3-5 4-3h2l9-2h13v2l-10 2 19 7 7 4q8 10 20 13l7-1-4-6-2-1-7-7 8 3 7 8q6 7 15 6 6 1 11 4"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m705 1252-4 3-3 5q29-9 50 13l-5-2-19-8-12-2q-6 0-8 4 0 5-4 4l-7-1h-1l-4-4 4-5 4-5z"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m696 1254-4 5-4 5-4-5z"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m716 1250-9 2zM725 1250h-6v-1h2z"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M737 1253h4l13 6 5 4-16-6zM737 1252zl-5-1 1-1z"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m733 1251-1 1h-3v-2z"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    fill: "#180b0a",
    d: "M811 1297q8 0 15 6l30 21 3 3q5 5 12 3h3l1 1 11 9h1v5l4 5v1l1 2v4l-1 7-2 7q-3 1-7-1-6 4-9-3l-1-1c-6-3-8-11-12-16l-14-18-11-9-4-5-5-5q-10-1-19-4-11-5-16-15-2-4 3-5l5 2z"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M886 1340"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "M887 1345v-4h2l1 1v3z"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M875 1331z"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "M720 1028v-8l4 8c1 8 13 16 20 12q11-5 21-4 5 0 9-4 6-5 14-6l9-2v4l-7 5-3 3c-6 0-7 6-10 9l-7 2-6 3q-3 5 1 8 2 4 6 2l3 2q2 4 2 9-3 9 1 18 3 12 3 23 0 12 4 24 4 14 4 29l2 4q9 7 7 17v11l3 4q7 2 6 8l3 9q2 5 1 9l-8 2-5 1q-8 9-19 5l-3 1-7-3h6l5-3q2-7 8-7l3-2-1-3-7-5v-4q0-11-7-20c-2-2-5-5-8-1l-7 12-1 10q-3 9-2 18l-7-10q-1-4 1-6c7-5 6-13 7-20l1-10c0-11 1-24-7-34q-2-3-3-7l-6-10-2-4c2-14-4-26-8-39l-7-21v-3q4-19-6-36m47 49q0-7-7-11-6-4-10-11-2-7-11-6t-8 9l-1 9q-2 7 4 13l3 7 7 21q4 9 6 18l2 3q7 5 6 14-1 5 5 5l7 2q6 2 7-2v-10q-1-6-1-12c3-8 0-16-1-24 0-9-8-15-8-25m5 92-3-2v5l2 1z"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M757 1228q-1-9 2-18l1-10 7-12c3-4 6-1 8 1q7 9 7 20l-2-3c-4-8-13-6-15 0q-2 8-1 16c0 5 6 7 10 4q8-4 8-13l7 5 1 3-3 2q-6 1-8 7l-5 3h-7q-6 1-10-5"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeeee6",
    d: "m895 1107-10 4q-6 2-4-4v-2q1-4 4-5 4-1 7 3z"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m798 1101-2-3z"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "m497 968 2-3q9-6 10-16l2-4 11-14q3-2 3-6-1-5 3-9 4-3 0-7-3-6 0-12 7-8 15-13 8-6 20-5l8-2 4-4q9-3 8-11l2-17q2-6 9-3v5c0 5 3 3 5 4l-1 18 3 1c9 0 12 8 15 13q6 6 11 5h9q6 1 5 7 0 4 4 5l15 6q8 6 14-2 4-2 9-3l1 6c0 5 6 12 11 11q6-1 5 5 0 9 9 9h6q14-2 17 12 2 4 6 2l7 1 8 6 18 4q7 2 7-6l-2-7 4-1c8 3 18 3 25 8q6 5 13 3 7 0 13-2l4 1q6 5 14 4l3 4q2 5 8 6 3 1 6 4l4 2 13 2-12 8q-12 1-22 7l-12 5-22 9-13 11c0-5 3-9-1-14l1-2v-7q-2-5 2-9 4-2 4-6 1-3-2-7l-5 1c-3 2-13 2-15-1v-3q0-5-5-5l-12-2-13-3q-14 1-24-9l-8-3-4 4-4 1-12-1-2-1-9-7-6-1q-5-1-7-3-7-8-16-11l-7-3 5-5 1-2-5-1-27 1-4-2c-1-7-5-4-9-3l3 4q2 5-3 9c-2 1-8 0-9-3q-2-6-9-2-3 2-7 3l-24-2c-5 0-10-1-12 5l-4 4-7 7q-10 0-17 8l5 1-3 4-9 5-6 5h-1l-2 2-5 5-1 1-7 8h-3z"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m546 936 7-7 4-4c2-6 7-5 12-5l24 2q4-1 7-3 7-4 9 2c1 3 7 4 9 3q5-4 3-9l-3-4c4-1 8-4 9 3l4 2 27-1 5 1-1 2-5 5 7 3q9 3 16 11 2 2 7 3l6 1 9 7 2 1 12 1 4-1 4-4 8 3q11 10 24 9l13 3 12 2q5 0 5 5v3c2 3 12 3 15 1l5-1q3 4 2 7 0 4-4 6-4 5-2 9v7l-1 2c4 5 1 9 1 15l-5 8-9 2q-8 1-14 6-4 4-9 4-10-1-21 4c-7 4-19-4-20-12l-4-8-4-11 2 1c5 6 9 13 19 12q2 0 5 2 5-7 14-6l13-1 15-7q6-4 3-10l-4-3-5-8-5-5-6-3q-10-7-23-7-4-1-8-3l-5-5q-15-3-26 6-6 4-10-1l-9-10q-1-4-6-4-2 0-4-3-1-3-4-4-10-1-16-9l-5-1q-9 5-15-3l-5-4-8 1h-5l-29-3h-8q-10-4-19-1z"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "M887 1345h3l1 5z"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m892 1353-1-2z"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m839 1392-11 9-5 3q2-3 1-4l-2-3-8 2-28 12q-6 2-4 8h-18c-16-1-32 3-47-4l-15-6h-1l-11-8-22-10-17-11-5-2v-3l10 5v-2l10-3 17-1 10 1-1 1-23 1q-6 0-4 5 5 6 11 7h5l18 8q8 5 17 4 10 9 22 5h2l6 3 16 1q8 3 12-4h3c6 5 10 0 13-2q10-6 18-14l3-4q-2-2-5-3h-14l-3 2h-36l-6-3h6l36-1c9 0 18-3 27 0l9 1q4 1 7 4 3 4 7 3z"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M839 1389q-4 1-7-3-3-3-7-4l-9-1c-9-3-18 0-27 0h-34 17l23-3 2-2h18l30 6-4 6z"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m827 1372 31-5-1 5-2 2v2h-8l-17-1z"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M855 1376v-2l2-2 5-3q4-3 7 3c-6-3-9 3-14 4"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m841 1388 4-6h4z"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M849 1382h-2l5-6h2zM851 1349l7 10-3 4-27 6q-19-4-37 0l-14 2h-40l-24-3-42-1q1-7-6-6h-8l7-3 3-2h3l10-2q7-2 9 4 1 6 7 6l15 1q24 3 47 2l31-1q7 0 14-2 12-3 24 1 7 2 13-3l11-1q6-1 3-7z"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M775 1371h15l21-1 16 1v1l3 3 17 1q-6 4-11 3l-21-3h-18l-12 1-13 4h-18l-1-2-5-3 6-2 18-1z"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m827 1371-16-1-21 1h-13l14-2q18-4 37 0z"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m839 1338 5 4 3 6-11-9q-12-11-27-18l-2-3 25 14 4 2z"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m836 1334-4-2-25-14-3-1-6-2-10-4h4l4 1 17 5 4 2 3 2h1l12 8z"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m851 1349 3 5q3 6-3 7l-11 1-3-1-1-2h3l9-1 3-1-1-4-2-5z"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M851 1348h-4l-3-6z"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m833 1327 5 5-5-3z"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m839 1338-3-4z"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m872 1371 3 4z"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "m811 1297-12-6-5-2q-5 1-3 5 5 10 16 15 9 3 19 4l5 5-7 1h-1l-7-3h-1l-13-5-7-4c-7-1-14-9-13-16 0-3 8-9 10-8z"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M823 1319zl1 2 2 2h2l4 4v2l-12-8z"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m833 1327-4-4zM827 1323l-2-2z"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "m776 944 2 7q0 8-7 6l-18-4-8-6-7-1q-4 2-6-2-3-13-17-12h-6q-9 0-9-9 1-6-5-5c-5 1-11-6-11-11l-1-6q-5 1-9 3-6 8-14 2l-15-6q-4-1-4-5 1-7-5-7h-9q-5 1-11-5c-3-5-6-13-15-13l-3-1 1-18-5-4v-5l9-8 6-3 8-1h35q3 1 5 3c2 3 11 5 16 4h25c4 0 10 2 9 9l2 2 2-2v-1l4-4 1 5-1 4 6 2q1 8 1 16 1 7-1 14l-3 24q-1 7 6 9c5 1 2 5 3 9l10-6 5-2 7 2q3 1 3 4l-1 16q0 5 5 4zM575 873l-4 4-8 2q3-10 12-6"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m507 967 1-1 5-5 2-2h1l6-5 17-7v1l-2 2-3 1-14 10-3 1a132 132 0 0 0-31 46q-1 5 3 6l10-5h2l2-3 4-3 4-4 4-1v1q-7 12-20 18h-2q-6 2-8 1-2-3-2-8v-4l3-5v-4l2-3 2-3 5-7v-1l4-5 1-3z"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M483 1008v2q0 5 2 8 3 1 8-1h2l1 2-9 4q-5 0-7-4-4-6 3-11M486 1001l-3 5q-2-4 3-5"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m500 975-1 3-4 5v1q-6 2-5 7l-2 3h-2c0-7 6-11 10-17l1-2z"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M486 994h2l-2 3z"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88460",
    d: "M595 1289q2-8 8-14 2-2 3-8v-9c0-7 6-11 10-16l-3-3q-5-1-1-5l2-4q-2-8 4-15v-1l-5-11q-2-6-11-3-5 2-5-3l2-18 4-5c6-2 10-8 17-7l3-2q-4-7 2-13-1 7 6 6h13l5 1q4 3 5 6 0 4-4 6-8 3-9 11l-7 3q-5-1-6 5l-2 7q-3 6-3 14l-1 26-2 16-1 2c-6 3-5 10-7 15l-1 4zm22-102 2 6 3-1v-6zm-1-7v-2h-1zM524 1100l-6 1q-6 1-5 7c0 4-1 9 5 10l-3 5 8 14q3 7-3 11l-2 1q-2 8-8 13-3 5-1 9v5c-4 5-1 11 0 16l1 7-2 13-1 3c-7 1-3 6-4 10q1 4 6 5 5 2 4 7-1 7 6 7 3 1 5 4v2q7 7 10 16l6 15 6 6q4 2 4 6v4q-1 11 10 8l4 1q8 3 14-2l11-7 6-7q1 10-8 13l-12 6c-7 4-15 1-22 0l-4-1q-10-3-6-11 3-9-5-10-5 1-4-3v-8q-1-10-10-11-6 1-6-5l-4-3-4-3-7-13q4-6-4-12-6-4-5-11 0-5 4-5t2-5l1-6q3-5 0-6-3-4-1-7 3-5 3-10-1-12 6-22 2-1 1-4-1-4 4-5 7-4 4-11-1-7-9-9l-10-7 1-4 6-4 3-3c0-9 2-11 15-10"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "M623 1133q9 5 19 5l7-3q-4 6-2 13l-3 5-19-1v-10q4-5-1-5h-8q-7 6-18 4l-9-6c7 2 12 6 19 3l10-5zm12 14-1-2-4-2-1 5 2 3z"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "M668 1256zl-15 8q5-7 15-9"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M601 1311q3-3 5 2-5 3-5-2"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "m653 1129 6-4 2 5zM650 1132l3-3z"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M483 1220h-2z"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "M569 1187q2 9 11 14 8 1 12 9l6 9c5 7 3 15 2 22 0 7-5 14-3 22l-3 7-1 4q0 9-9 11l-3 3q-5 5-11 3l-3-5-1-5-9-6h-3q-4 4-6-1l-1-6q1-7-3-13v-4q1-7-5-6-7 2-6-6l-1-4c-5-8-3-18-3-27q-1-9-5-17-3-9-1-18l2-8q0-6 6-6h4q7-3 3-8-3-5-1-11 3-3 8-3 5-1 9 3l7 3q5 2 6-4 3-6 8-1 7 5 15 9 4 4 8 1 7-6 16-4l5 4q1 4-4 5l-10 5q-9 3-16 9-5 2-11-1-6 0-8 4v6q2 3 6 2l5 1-1 3q-2 2-4 1-4-1-7 4"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m618 1133-10 5c-7 3-12-1-19-3l-23-3q-4 0-6-4-2-6-8-2c-5 3-14 1-18-4l-1-5c5-4 2-8 0-13h2l2 1 4 5q6 3 1 11h8q7-1 12 3 7 5 13 5c4 0 9 3 12-2 1-2 7 0 10 0l2 5q2 6 6 2 7-3 13-1"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88460",
    d: "M616 1137h8q5 0 1 5 0-4-4-4z"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M604 1039q16-5 32 1 6 2 14 1l12 2h2l20-8q2-2 3-8l7 4q4 6-1 10l-12 7c-5 2-8 7-14 6l-13-4-24-7-2 1h-5l-6-1-3-2z"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m543 1051 8-3 35-7h7l-3 2c-2 2-7 1-7 5h-5l-3-3-2 3h-1q-12-3-13 4l-3 1c-5-2-7 2-9 4l-8 6-2 2-2 2v1l-4 5-6 5-11-7q-4-2-3-8 3-7 10-8 12 2 22-4"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m623 1030 5-1h28l26 1-1 2-28 5-12-2z"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m694 1031-7-4h-3l-3-4h3l15 6h9q7-3 4-11l-1-9c5 4 3 10 5 16l-1 4-5 4h-4z"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "m682 1030-25-1 7-1q3-1 5-3h8l6 2z"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m604 1039 10 2 3 3-20-3v-2zM586 1041l-13 1 6-3z"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m683 1027-6-2 1-2h3z"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M597 1039v2h-5q0-5 5-2"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M543 1051q-10 6-22 4-7 1-10 8-1 6 3 8l11 7 1 3-1 10q-4 0-4-4 0-8-8-5l-2 1-16-10c-4-3-2-14 3-17 6-3 13-9 22-7l13-3q7-3 10 5"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m525 1091 1-10 17-7 13-6h2l17-4h11l5-1h11l11 2 22 6q8 2 16 6l16 15q3 5-2 8h-6l-5 1-9 2h-4l-5-1 10-5c5 4 10 1 14 1q5-2 2-7l-18-13-9-3-2-1-7-4q-18-3-35-4-16 1-31 5-4 1-8 4h-2l-18 8-3 6 4 3q9 4 18 1l4 4-7 2-19-4-2-2z"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m527 1093 2 2h-2z"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "M541 992h2l10-2-7 5q-2 3-2 6 1 2 5 3l25 1 6 1 12 3 5 1q16 6 32 5 3-1 6-4l9 5q1 5 5 3l3 1q0 4-4 4l-13-3q-12 0-24-2-16-3-32-7c-11-1-21 5-32 3l-2 1q-12 7-25 5-3 0-3-2 0-1 1-3l5-6 3-4 9-9z"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m535 997-9 9-3 4-5 6q-1 2-1 3 0 2 3 2 13 2 25-5l2-1c11 2 21-4 32-3q16 4 32 7 12 2 24 2l13 3q4 0 4-4l3-1h2c2 7 8 5 12 6q-2 2-5 3l-8 1h-6l-10-1h-8l-39-8c-9-1-19-4-29 0l-8 1-11 3c-12 2-23 8-35 4l-3-1q7-21 28-30M553 990l-10 2 2-5h15v3zM541 992l-6 5z"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m507 1015 4-5q1 4-4 5"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1997a",
    d: "M553 990h11l23 3 10 1 2-1 2 1 19 9 15 8q-3 3-6 4-16 1-32-5l-5-1-12-3-6-1-25-1q-4-1-5-3 0-3 2-6z"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M601 993h-2l-2-2h-4l-6-2h-2l-3-1h-8l-2-3c-14-3-28-6-42 0q-7 6-15 13l-4 1v-3l13-11 2-2h1l5-3h2l19-1h14l9 4h3l2 2 12 3h6l4 2h2v3z"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M515 998q8-7 15-13c14-6 28-3 42 0l2 3q-12-3-23-4-17 0-30 11zM587 989l6 2z"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2805c",
    d: "m564 989-4 1v-3z"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M582 989h3zM597 992h2l-2 2z"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m531 1095 17 4v2c-4 5-4 5-8 1q-3-2-7-3z"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "M533 1099q4 1 7 3c4 4 4 4 8-1l1 3q-4 6-9 3l-3-2-2-1z"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m688 1327 4-4 6-5v-5l-5 1-4 1-1-5 9-7 1 1 14-1 5-2q6-2 6 3c-1 6 3 13 0 20l-1 1-7 2q-12 1-22 3-4 0-5-3"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M657 1361h8q7-1 6 6l-14-3-11-1q-5-2-5-9l3-3v-1l2-2 1-1q14-3 25-8 12-4 23-6h8l-13 4-27 7-15 9q-5 3 0 6z"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M703 1333h-8q-11 1-23 6-11 5-25 8l1-2q13-5 22-15c4-3 5 1 7 2l11-5q1 3 5 3 10-2 22-3v2l-3 1z"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m651 1318 2-3 13-2 20-5v2l-2 4q-1 2-4 3-14 2-29 1"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m646 1363 11 1 6 6-6 1q-3-6-11-7z"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M686 1310v-2l8-5h3z"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m638 1322 11-4q-3 5-11 4M625 1324q4-5 11-2z"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m644 1351-3 3zM646 1348l-2 2z"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "m622 1336 1-2 5-3v6zM620 1339l2-2z"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "m657 1308 4-4q14-5 30-5l-4 4h-3l-8 2h-2l-7 3h-10"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M664 1308h3l7-3h2l10-2-5 4-18 4z"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m687 1303 4-4 6-1v1l-2 4h-8M664 1308l-1 3h-6v-3z"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "M657 1308v3h-4z"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M655 1311h2z"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m657 1371 6-1-6-6 14 3 42 1 24 3h38l-3 2-18 1-6 2 5 3 1 2-1 1h-4l-4-2h-2l-19-4h-11l-3-1h-6l-4-3h-12l-35 2-6-1z"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m647 1373 6 1 35-2h12l3 3h-10l-10-1-17 1-10 3v2l-10-5-2-1v-1z"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M644 1373zl-3-2h1z"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m641 1372 3 2 2 1v4h-2l-3-1-6-4h-5v-1l-1-2z"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M627 1371v-1h2v1z"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m704 1295 13-7 7-1-6 4-10 7h-6v-3z"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "M702 1295v4h-5v-1zM651 1301l-1 1v-2z"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M702 1299zh6l10-5 11-2q5 1 5-4h1l10-6-5-7-2-1-18-2q-5 1-10 4h-5v-2l13-3c10-1 19-3 27 5l7 4 18 10q4 3 5 8l-8-5-2 8-1-2q-3-12-12-7-4 3-7-1l-4-2-2 2q0 5-5 6-5 0-3 5l-3 6-2-6v-2l-1-6-6 4z"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M710 1275q5-3 10-4l18 2 2 1 5 7-10 6 6-7c-3-6-15-8-24-5h-7"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M717 1275c9-3 21-1 24 5l-6 7h-9l4-2 4-4-4-3z"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M726 1287h8q0 5-5 4l-11 2-10 5 10-7 6-4z"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m689 1270 11 5q-7 2-11-5M710 1275h2q-3 4-6 0z"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "m627 1372 2-1v2l-1 1h7l6 4 3 1 5 4q3 6 10 7l1 1 3 7-17-3-14-4-13-1c-6-1-8-8-5-13l3-4z"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "M646 1379zl5 2 17 11 22 10 11 8-10-3h-1l-4-3h-2l-15-8h-1l-5-3-1-1-3-2-10-6z"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m669 1395 15 8q-9 1-15-8M663 1392l5 3zM686 1403l4 3zM659 1389l3 2h-2z"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6e4e",
    d: "m694 1407 7 2h1q7 9 16 10 13 4 26 4h40q-2 7-8 6l-28 1-8 1h-3l-6-4-46-9q-8 1-9 10l-13 3-1-9q1-5-3-8l1-3q6-2 12-1l10 3q10 2 12-6"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m663 1431 13-3q1 6 8 8c9 3 18 9 19 20q1 3 4 6h-5c-8 0-8 0-7-8 0-5-10-14-16-14l-9-1-2-2h-2z"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M726 1503v-7zM708 1489q0 5-5 2zM675 1495l-2 4h-2z"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "M642 1495q-12 1-10-13v-9q2-18 20-16h6l10 4h4v-4c-1-2-4-5-1-7q5-4 11-3 6 2 9 9 0 2-2 7v6q1 7-4 11-10 9-23 10h-3z"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m642 1495 20-5q13-1 23-10 5-4 4-11v-6q8 4 15 3 9-1 17 4l7 2 5 2q-1 4-4 4c-3 1-7 4-11 1q-6-3-11 1-7 8-15 2l-6 1-17 8-18 6z"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7744c",
    d: "M708 1462c4 1 10-1 13 5l-8-2zM725 1467h3z"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m668 1437 2 2z"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m750 1433 6-1 30-2 5-2c5-1 9-4 14-1h7q4 0 7 3 2 5-3 6l-2 1q-13 16-33 20-6 2-11 6-10 4-21 3l-27-4q-13-2-19-16-2-6-9-9-4-2-5-6-1-8 6-7 13 1 24 4l12 3q-6 3-12 0l-11-1q-5 2-3 7l6 12q3 10 14 11l37 3 30-13q6-3 10-10 4-6-3-7l-18 1-2 2h-1l-7-1q-5-3-8 1l-13-1z"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m779 1436 2-2 18-1q7 1 3 7-4 7-10 10l-30 13-6 1-31-4q-11-1-14-11l-6-12q-2-5 3-7l11 1q6 3 13 0h2v4h-10l-5-1q-5-2-9 1c-3 4 1 6 3 8l3 4q2 8 11 10l18 3c5 0 11 3 17-1q8-6 18-7 10-2 17-9l1-4-4-2-11-1z"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M782 1419q-3-6 4-8l28-12 8-2 2 3q1 1-1 4l-7 3-16 8-7 4z"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    fill: "#c96041",
    d: "M782 1419h5l-3 4h-40q-13 0-26-4-10-1-16-10l15 6c15 7 31 3 47 4z"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "m793 1419 7-4 16-8c0 5-5 5-7 7z"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M750 1433v2h-11l1-2z"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m740 1433-1 2h-5v-4h6z"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "M664 1197q1 7-6 10l-3-9z"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m694 1031 12 2h4v3c-5 7-2 15-1 22l-2 9-2 4c0 14-10 19-21 24l-4 2-7-3-1-6q3 5 8 3c7-4 12-15 9-22q-2-4-6-5c-8 2-14-3-21-7h-7l-4-4-2-2-19-5v-3l24 7 13 4c6 1 9-4 14-6l12-7q5-4 1-10"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "m537 1105 3 2q5 3 9-3c5 2 10 0 13 5q-4 4 0 7l3 4q8 11 20 4l6-1c2 2 10 3 14 1q6-3 11 0l26 6 7-3q-6 9-16 7l-10-1h-5q-7-2-13 1-4 4-6-2l-2-5c-3 0-9-2-10 0-3 5-8 2-12 2q-7 0-13-5-5-4-12-3h-8q6-8-1-11z"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb6545",
    d: "m591 1123-6 1q-11 7-20-4l-3-4q-4-3 0-7l7-1q10 5 13 12h10c4 0 8 1 9-5l3-2 4 4h10l11-1v4q-1 5-7 3c-7-6-15-3-23-1z"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m672 1088 1 6-2 4-4 5-5 2-2-5h5q5-3 2-8l-16-15q-8-4-16-6l-2-2h4q7 1 4-5l-1-2h1l5 1h1v2l2 2 3 2 2 2 3 4 11 8z"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m659 1100 3 5-7 3-20 5h-10l4-4 12-6h4l9-2z"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M625 1113h10l-6 3-11 1h-10l-4-4 7-1z"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec8d6b",
    d: "m546 936 16-6q9-3 19 1h8l29 3h5l8-1 5 4q6 8 15 3l5 1q6 8 16 9 3 1 4 4 2 3 4 3 5 0 6 4l9 10q4 5 10 1 11-9 26-6l5 5q4 2 8 3 13 0 23 7l6 3 5 5 5 8 4 3q3 7-3 10l-15 7-13 1q-9-1-14 6-3-2-5-2c-10 1-14-6-19-12l-2-1-1-3-2-2v-1l-2-2-15-13-21-11h-3l-5-1 1-1-4-4-5-2-24-11-16-5-32-12-13-1q-21 0-40 5l-5-1q7-8 17-8"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M681 1023zl-2-1h-3l-10-1-5-3-7-4h2l10 4h14c7 3 8 3 12-4l2 4h7l-1-6-4-7-8-15 2-2 2 1 1 4q3 9 11 7l2 4 1 5 3 10q0 3-4 4-8 2-16-1l-5 1zM667 976l4 1 2 1 6 5 5 3h2v4l-15-8-8-6z"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M703 1000q-9 2-11-7h6l3 2z"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m703 1000-2-5q6 1 7 9h-3zM686 986h-2l-5-3-6-4zM696 993h-4l-1-4zM708 1004l3 5z"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M686 990v-3l3 1-2 2z"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4704c",
    d: "m715 1029 1-4q4 3-1 4"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m713 1004 2 2zM711 1001l2 2z"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m700 995-2-2z"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M687 1210q-1-4-4-2l-5 4c1-4 7-10 10-9l3 3zM684 1218l3-6z"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M775 1297q-1-5-5-8l-18-10-7-4c-8-8-17-6-27-5l-13 3h-3l-3-2-6-2h7q4 1 4-4 2-4 8-4l12 2 19 8 5 2 10 6h2l8 6 11 9-1 4z"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m699 1271 3 2z"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "M729 1252h3l5 1 6 4 16 6 7 7 2 1 4 6-7 1q-12-4-20-13l-7-4-19-7z"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m779 1294-11-9-8-6 16 7q2 3 3 8"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m785 1307 2 1v3q-7-2-8-9h2l2 1v2z"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m802 1311 4 1v3l-10-3z"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M758 1279"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M775 1298h3l1 2v2z"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M792 1311h-3l-1-3z"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M779 1302v-2h2v2z"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M781 1302v-2l2 3z"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m788 1308 1 3h-2zM785 1307l-2-2z"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M767 1077c0 10 8 16 8 25 1 8 4 16 1 24q0 6 1 12v10q-1 4-7 2l-7-2q-5 0-5-5 1-9-6-14l-2-3q-2-9-6-18l-7-21-3-7q-6-6-4-13l1-9q0-8 8-9 9-2 11 6 4 7 10 11 7 4 7 11"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1997a",
    d: "M782 1213q0 9-8 13c-4 3-10 1-10-4q-1-8 1-16c2-6 11-8 15 0l2 3z"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m772 1169-1 4-2-1v-5z"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M534 945q19-5 40-5l13 1 32 12 16 5 24 11 5 2 3 4-5-1-3-2h-4l-1-2-2-1-1-1h-2l-8-5-4-1-18-7-8-3-29-7h-5l-9-2h-15l-4 3h-4l-6 1-8 2zM507 967l-7 8z"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37d57",
    d: "m594 847 5 4c-2-1-5 1-5-4"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m522 954-6 5zM513 961l-5 5zM515 959l-2 2z"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "M693 1375h13l2 1 2-1 3 1 13 2q9 6 19 4h2l6 3h36l5 2q10 5 1 9c-6 4-10 10-18 10h-29l4-2q17 3 32-4l6-6q3-6-5-6l-27 1-13-2-27-5h-4l-9-4h-4q-8-2-12 6l14 8q6 4 12 5 10 2 16 6l-15-2-5-3-9-3-15-7-6 1h-5q-4-7-11-7-2-5 4-5l23-1z"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M777 1406c8 0 12-6 18-10q8-4-1-9l-5-2 3-2h14q2 1 5 3l-3 4q-8 8-18 14c-3 2-7 7-13 2M681 1389l6-1 15 7 9 3 5 3q-9 1-17-4zM748 1406h26q-5 7-12 4l-16-1-6-3 1-1zM716 1401l15 2h3l4 3q-12 4-22-5M665 1382q7 0 11 7-6-1-11-7"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m738 1406-4-3 7 2-1 1z"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M747 1382h-2v-2l4 2z"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m815 1376 21 3q6 1 11-3h5l-5 6h-2zM772 1381l13-4 12-1-2 2zM801 1376h11z"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m857 1372-2 2z"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "m837 1361 3 1q-6 5-13 3-12-3-24-1-7 2-14 2l-31 1q-23 1-47-2l-15-1q-6 0-7-6-2-6-9-4l-10 2 10-5 6-4h3l15 11 17 4q3 1 7-1l13-8c5-3 13-3 15-10q5-6 9 0 3 7 8 2t11-2q4 2 6-2 4-4 7 0l10 7 5 5q3 3 6 4z"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M688 1347h-2l-16 6-2 3h-4l-7-2 5-6 12-5 18-4 20-7 21-6-2 4q-14 11-32 12-7-1-11 5"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m712 1332-20 7-18 4-12 5-5 6 7 2v2l-7 3-9-2q-4-3 0-6l15-9 27-7 22-7z"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m668 1356 2-3 16-6-6 4-10 5z"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    fill: "#c35846",
    d: "M664 1358v-2h3z"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "M847 1348zl2 5 1 4-3 1-9 1-9-9-11-9-4-7q-11-12-28-6-7 3-15 3l-27-3q-5 1-5-4l20 2 1-4 1-1h2l5 2 12-7q5-5 10 1h-6l-4 4 2 3h10q6-2 0-7l11 1h3l2 3q15 7 27 18z"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M804 1317h-13q-5-6-10-1l-12 7-5-2h4q9-3 4-7l-3-1-1-4-1-2-2-2v-5l2-8 8 5v1l4 4q1 7 8 9h1z"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M806 1315v-2l9 3-2 1z"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "m823 1319-2 2-2-1-2-1-1-3z"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m816 1316 1 3-4-2 2-1zM817 1319l2 1z"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    fill: "#d56a4a",
    d: "m837 1361-19-4q-3-1-6-4l-5-5-10-7q-3-5-7 0-2 4-6 2-6-3-11 2t-8-2-9 0c-2 7-10 7-15 10l-13 8q-4 2-7 1l-17-4-3-2-12-9q14-5 27 1l5-1 9-5 2 2q5 5 6-2c4-11 4-11 15-11l9 1 2 1c3 6 7 4 11 2q4-2 8-3 9-1 16 1l12 10q11 11 25 16z"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7752",
    d: "M836 1359q-14-5-25-16l-12-10q-7-2-16-1-4 1-8 3c-4 2-8 4-11-2l-2-1-9-1c-11 0-11 0-15 11q-1 7-6 2l-2-2-9 5-5 1q-13-6-27-1h-1q4-6 11-5 17-1 32-12l2-4 6-2h1q0 5 5 4l27 3q8 0 15-3 17-6 28 6l4 7 11 9 9 9z"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m499 1009-10 5q-4-2-3-6l6-13a132 132 0 0 1 28-34l-13 16-9 14-8 15q-2 4 3 4z"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m499 1009-6 1q-5 0-3-4l8-15h4l-1 7h6l1 1-1 4-4 3-2 3z"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m520 961 14-10-3 4-3 1-3 3-2 2z"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m531 955 3-4 3-1 1 1z"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M490 991q-1-5 5-7z"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m507 1003 1-4h3z"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m539 947 6-1v2h-6z"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m495 983 4-5z"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M539 948h3l-2 3h-2l-1-1zM501 1009l2-3z"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m618 1187 4-1v6l-3 1zM615 1179v-1h1z"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m635 1147-4 4-2-3 1-5 4 2z"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m651 1053 4 4-18-7q-6-4-12 0l5 3q6 0 7 6h-1l-3-1-7-5q-17-6-35-5h-8c0-4 5-3 7-5l3-2h4l20 3h11l2 2 19 5z"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m630 1046-2-2 2-1zM625 1044h-2z"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m633 1058 3 1 4 3 1 2q3 5-4 5h-4l-20-4-11-2 2-3 3-4-5-2c-9 1-17-3-26 0h-1q-9-2-18 2l-6 1 5-4 3-1 7-2 6-2h19l4 2q18-1 33 7z"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m543 1074-17 7-1-3 6-5 4-1 2 2 4-1z"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m541 1073-4 1-2-2v-5l2-2 2-2 8-6h2l-3 4c-6 4-7 5-5 12"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m572 1048-6 2-7 2q1-7 13-4M549 1057h-2c2-2 4-6 9-4l-5 4z"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M578 1048h-5l2-3z"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "M535 1068v4l-4 1zM537 1065l-2 2zM539 1063l-2 2z"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m708 1004 3 5 1 9q2 8-4 11h-9l-15-6 5-1q8 3 16 1 4-1 4-4l-3-10-1-5z"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m665 1021 10 1v3h-6c-4-1-10 1-12-6z"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "M675 1025v-3h3v1l-1 2z"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M678 1023zl2 1z"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a1917",
    d: "M633 1075h2l12 8 12 9q-5 8-9 2l-3-4-8-8-17-5q-9-3-8 6l-2 13-2 8-1 1-9 1-23-4-6-4 2-3q4 5 10 4h2c4 5 9 3 13 2q3-2 4-8l-11-4q-6-3-3-9 2-5 8-2l8 7 3 2 3-3 3-11-5-2h-9l-20-1 8-2 13 1 20 3q7 1 13 3m-40 12q4 3 6-2l-2-4-7 1q-2 3 3 5"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1997a",
    d: "M549 1057h2l6-1q9-4 18-2h1c9-3 17 1 26 0l5 2-3 4-2 3h-3c-3-2-6-6-8 0h-6q-2-4-4 0l-3 1h-4l-5 1-11 3h-2l-13 5h-2c-2-7-1-8 5-12z"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m571 1098 6 4 23 4 9-1q-3 4-7 4l-21-3q-10-2-16-9l-1-10q-1-6-8-4-6 4-5 10-9 3-18-1l-4-3 3-6 18-8-2 3-12 5q-2 3-1 5c0 3 9 4 11 2l11-11q11-1 10 11 0 5 4 8"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67f71",
    d: "m625 1113-14-1 1-10 4-19q-1-6 5-4l15 4q9 4 10 14l-10 5 5 1-12 6zm1-10 12-5q7-3 3-9-8-7-19-7-2 0-4 4l-1 9c-3 11-1 11 9 8"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M646 1097q-1-10-10-14l-15-4q-5-2-5 4l-4 19-2 2 2-8 2-13q-1-9 8-6l17 5 8 8 3 4q5 7 9-2l-12-9-12-8 9 3 18 13q3 5-2 7c-4 0-9 3-14-1"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "m557 1079-11 11c-2 2-11 1-11-2q-1-2 1-5l12-5 2-2 3-1 18-4-5 3-6 3z"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m571 1071-18 4q3-3 7-4 15-4 31-5 17 1 35 4l7 4-13-2-20-3-13-1-8 2z"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m569 1108-7 1c-3-5-8-3-13-5l-1-3v-2l7-2 9 3z"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    fill: "#999287",
    d: "m564 1100-9-3-4-4q-1-6 5-10 7-2 8 4l1 10zm-8-5 4-1-1-9q-10 4-3 10"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M558 1068"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m543 1073 13-5zM591 1063c2-6 5-2 8 0z"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m654 1101-9 2z"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "M581 1063q2-4 4 0z"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "M581 1063zh-3zM599 1063h2zM601 994l4-1h2l26 15 9 3 2 2 3 1 2 1 6 4-3 1-3-1-14-8-15-8z"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88764",
    d: "m644 1016 5 3q-4 2-5-3"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m655 1019-6-4 2-1h2l7 4 5 3-8-2z"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    fill: "#37221d",
    d: "M538 951h2l12 2q18-4 34-1 6 3 12 3 12 2 19 9l1 7-6-2-20-10q-5-2-7 4l-5 5h-4c-6-5-6-5-12 2l8 2-3 6-2 1-27-1-6 2h-2q-5-2-5 3h-3q-5-1-5 4l-3 2-5 7-2 3h-1l-1-1h-6l1-7 1-4 9-8 11-18 2-2 3-3 3-1z"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m569 978 3-6-8-2c6-7 6-7 12-2h4l5-5q2-6 7-4l20 10 6 2-1-7 19 4 5 3q-8-1-8 6 0 5-5 3h-6l5 8-1 2q-5-1-9-4-11-7-22-1l-2 3-12-3-2-2h-3c2-3 16-6 19-6q8 2 16 3l3-3q-1-3-3-4c-5-6-13-5-19-9l-4 2-3 4-15 9z"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m593 988 2-3q11-6 22 1 4 3 9 4l1-2-5-8h6q5 1 5-3 0-7 8-6l10 6h-5l-8-3-3 10-4 17h-4q-5-6-11-6l-9-3-2-2h-2l-4-2z"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m569 978 1 1 15-9 3-4 4-2c6 4 14 3 19 9q2 1 3 4l-3 3q-8-1-16-3c-3 0-17 3-19 6l-9-4z"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m534 980 6-2q6-1 13 1z"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m511 996 5-7 3-2h2z"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M521 987h-2q0-5 5-4v2zM527 983q0-5 5-3zM599 988l4 2z"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "m509 999 2-3v3z"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m605 990 2 2z"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m579 983 2 2zM524 985v-2h2z"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m703 1300 16-3 7 2v2l2 6 3-6 3-2 5-1 3 9-4 2-3 4q-4 9-12 11c3-7-1-14 0-20q0-5-6-3l-5 2h-14z"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M723 1324q8-2 12-11l15 2 1 2h-10l-5 2q-6 7-14 7v-1z"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m703 1300-5 3h-3l2-4h5z"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "M722 1325zl-7 3v-2z"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m715 1329 7-3q8 0 14-7l5-2h12l9 3v1l-1 1-12-2q-7-2-10 4l-6 2z"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    fill: "#de7e5a",
    d: "m684 1303-8 2zM674 1305"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M745 1380v2q-10 2-19-4z"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m743 1380-17-2h-2v-2z"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M724 1376v2l-11-2h11"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m710 1375-2 1v-1z"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    fill: "#b14e35",
    d: "M708 1375zl-2-1z"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M720 1376h-2z"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "m641 1378-6-4zM646 1379l3 4-5-4zM630 1374h-2l2-1z"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "M753 1317h-2l-1-2-15-2 3-4 4-2-3-9-5 1-3 2q-2-5 3-5 5-1 5-6l2-2 4 2q3 4 7 1 9-5 11 7l-2-1q-7-6-8 2c0 5-2 11 2 17z"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M755 1316c-4-6-2-12-2-17q1-8 8-2l2 1 2 2v5l2 4h1l1 4q-1 5-5 4l-6-1z"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m726 1299-7-2 6-4z"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6825e",
    d: "M659 1389zq-6-1-10-7z"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    fill: "#290d0c",
    d: "M738 1435zh11l28 1h1l1 1q4 8-5 7h-2q-7-1-11 5-3 5-7 6c-7-2-17-1-21-9l-3-2-4-4 5-3z"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b3a2c",
    d: "m770 1437-7-1q3-4 8 0z"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m770 1437 1-1h7z"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "m783 1436 11 1 4 2-1 4q-7 8-17 9-11 1-18 7c-6 4-12 1-17 1l-18-3q-9-2-11-10l-3-4c-2-2-6-4-3-8q4-4 9-1l5 1-1 2q-8 1-3 7l1 3 6 5 24 6q6 2 11-3 3-4 7-6l17-4q3-1 4-3l-3-3z"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    fill: "#441812",
    d: "m783 1436 4 3 3 3q-1 2-4 3l-17 4q-4 2-7 6-5 5-11 3l-24-6-6-5-1-3q-5-6 3-7l1-2h14l-6 2-5 3 4 4 3 2c4 8 14 7 21 9q4-1 7-6 4-6 11-5h2q9 1 5-7z"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e221a",
    d: "M729 1435h-2z"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M672 1088q-2-2-3-5h3q5 4 5-2-1-6-4-9l-15-15h4c7 4 13 9 21 7q4 1 6 5c3 7-2 18-9 22q-5 2-8-3"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m658 1057 15 15q3 3 4 9 0 6-5 2h-4l-4-2v-3q6-2 2-8l-11-13z"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "m651 1053-2-2z"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m564 1100 1-3q6 8 16 9l21 3q4 0 8-4v-1l2-2-1 10-7 1-3 2c-1 6-5 5-9 5h-10q-3-7-13-12z"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    fill: "#883021",
    d: "m655 1057 11 13q4 6-2 8l-15-13-2-2h-1l-5-4h-4q-1-6-7-6l-5-3q6-4 12 0z"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M664 1078v3l-7-6z"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m649 1065 7 6h-2l-2-2-3-2z"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M654 1071h3v4z"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "m641 1059 5 4-5-1z"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7553f",
    d: "M641 1059v3h-1l-2-3zM649 1067l3 2zM649 1065v2l-2-2z"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M649 1065h-2v-2z"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m662 974 5 1v1h-4z"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M686 990zl8 15 4 7 1 6h-7l-2-4c-4 7-5 7-12 4h-11l6-2q3-6 8-1l4-1 1-3-2-9-2-4-8-6-3-3q-6 1-4-5l3-2z"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "M668 984q-2 6 4 5l3 3 8 6 2 4 2 9-1 3-4 1q-5-5-8 1l-7 2h-2q-3-6-10-4h-4l-4-5h1l5 1q7 1 13 3 4 3 7 0 3-5 7-4 2 1 3-2l-2-5-14-11q-3-9-12-6l-1-8q9 1 14 7"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "M655 1014q7-3 10 4z"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    fill: "#55281a",
    d: "M668 984q-5-7-14-7h-3l-10-6-5-3-19-4q-7-7-19-9-6 0-12-3-16-3-34 1l-12-2 2-3h3l4-1h36l16 4 9 4 6 1 4 3 5 1 18 8h6v1l5 2 1 1 8 4 8 6z"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m679 983 5 3z"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m616 956-7-1-8-4h-2l-14-4h-3v-2l29 7 8 4z"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M569 947h-16v-1c4-1 8 2 9-3l6 1zM643 968l-18-9 7 2 5 2h4z"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m637 962-5-1-7-2h-4l-1-3zM562 943c-1 5-5 2-9 3v-3zM569 947v-3l8 1-2 1z"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m575 947 2-2h5v2z"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m643 968-2-5 8 5h-6"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m663 976-8-4h4l3 2z"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "M553 943v4h-4v-1z"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "M620 956v3l-4-3h4M654 970l-5-1 2-1 1 1zM549 946zl-4 1v-2z"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m662 974-3-2z"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "m652 969-1-1z"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    fill: "#e88460",
    d: "M714 1382h4l2 3 23 5q4 2 10 3 13-2 25 0l4 2-3 3-8 3-13 1-5-1-16-2q-9 1-15-6h-2l-20-6-4-3 5-6h4q4 6 9 4"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "m701 1378-5 6 4 3 20 6h2q6 7 15 6l16 2 5 1 13-1 8-3 3-3-4-2q-13-2-25 0-6-1-10-3l-23-5-2-3 27 5 13 2 27-1q8 0 5 6l-6 6q-15 7-32 4l-4 2-7-1-7-2h-3q-7-5-16-6-6-1-12-5l-14-8q4-8 12-6"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec724f",
    d: "M714 1382q-5 2-9-4z"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1997a",
    d: "M739 1324q3-6 10-4l12 2-1 4zM791 1317h2q6 5 0 7h-10l-2-3 4-4z"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M762 1321v-2l4 2h-4"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m766 1321-4-2-4-3 6 1q4 1 5-4l3 1-4 7z"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "m768 1321 4-7q6 4-4 7"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b4733",
    d: "m767 1309-2-4 2 2z"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d513c",
    d: "M767 1309v-2l1 2z"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    fill: "#543123",
    d: "m523 961-11 18-9 8-1 4h-4l9-14 13-16zM528 956l-3 3z"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46141",
    d: "m633 1058-5-1q-15-8-33-7l-4-2q18-1 35 5z"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca7857",
    d: "m638 1059 2 3-4-3h2"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    fill: "#120907",
    d: "m571 1071 8-1 20 1h9l5 2-3 11-3 3-3-2-8-7q-6-3-8 2-3 6 3 9l11 4q-1 6-4 8c-4 1-9 3-13-2q3-4-2-6v-3q-3-12-7-7-7 3-9-2l-7-4 6-3z"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "m560 1077 7 4q2 5 9 2 4-5 7 7l-3-1q-7-5-7 5v1l-2 3q-4-2-4-8 1-12-10-11z"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3938",
    d: "M573 1095zq2-5 7-5l3 1v9q-6 1-10-4"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c59",
    d: "M592 1087q-4-2-2-5l7-1 2 4q-2 5-7 2"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "M583 1099v-6q5 2 2 6z"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c1b8",
    d: "M626 1103c-10 3-12 3-9-8l1-9q2-4 4-4 11 0 19 7 5 6-3 9zm3-4 6-2q3-2 4-5l-4-4-11-4-3 2-3 15zM556 1094q-7-4 3-9l1 9z"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M607 993zl9 3 11 6h2l5 5 8 5-9-3z"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m642 1011-8-5-5-5h3l2 3 13 5 4 5h-4l-3-2z"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5674c",
    d: "m644 1013 3 1z"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "m519 987-3 2z"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    fill: "#291d1a",
    d: "M632 1001zl4-17 3-10 8 3h8l1 8q9-3 12 6l-7-4-1 3q-7-5-8 2l-2-2q-2-7-11-5 12 11 10 24h-1l-13-5z"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b3429",
    d: "m627 1001-11-6q6 0 11 6"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e5945",
    d: "m758 1316 4 3v1l-9-3 2-1z"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2472e",
    d: "M657 1075v-4l7 7z"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    fill: "#201917",
    d: "M648 1009q2-14-10-24 9-2 11 5l2 2 1 1 6 5 1-8 1-3 7 4 14 11 2 5q-1 3-3 2-4-1-7 4-3 3-7 0-6-2-13-3z"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e3a29",
    d: "m601 951 8 4z"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b4a37",
    d: "M644 968h3z"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    fill: "#442e2b",
    d: "M580 1089q-5 0-7 5 0-10 7-5"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeeee6",
    d: "m629 1099-11 2 3-15 3-2 11 4 4 4q-1 3-4 5z"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2821",
    d: "m632 1001 2 3zM659 990l-1 8-6-5-1-1q1-7 8-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilepic);
export default __webpack_public_path__ + "static/media/profile pic.e4e0c184398532c77a69cbd8b62901d5.svg";
export { ForwardRef as ReactComponent };